var $jscomp = {
  scope: {},
  getGlobal: function (d) {
    return "undefined" != typeof window && window === d ? d : "undefined" != typeof global ? global : d;
  }
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.initSymbol = function () {
  $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
  $jscomp.initSymbol = function () {};
};
$jscomp.symbolCounter_ = 0;
$jscomp.Symbol = function (d) {
  return "jscomp_symbol_" + d + $jscomp.symbolCounter_++;
};
$jscomp.initSymbolIterator = function () {
  $jscomp.initSymbol();
  $jscomp.global.Symbol.iterator || ($jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));
  $jscomp.initSymbolIterator = function () {};
};
$jscomp.makeIterator = function (d) {
  $jscomp.initSymbolIterator();
  if (d[$jscomp.global.Symbol.iterator]) return d[$jscomp.global.Symbol.iterator]();
  var e = 0;
  return {
    next: function () {
      return e == d.length ? {
        done: !0
      } : {
        done: !1,
        value: d[e++]
      };
    }
  };
};
$jscomp.arrayFromIterator = function (d) {
  for (var e, k = []; !(e = d.next()).done;) k.push(e.value);
  return k;
};
$jscomp.arrayFromIterable = function (d) {
  return d instanceof Array ? d : $jscomp.arrayFromIterator($jscomp.makeIterator(d));
};
$jscomp.inherits = function (d, e) {
  function k() {}
  k.prototype = e.prototype;
  d.prototype = new k();
  d.prototype.constructor = d;
  for (var b in e) if ($jscomp.global.Object.defineProperties) {
    var a = $jscomp.global.Object.getOwnPropertyDescriptor(e, b);
    a && $jscomp.global.Object.defineProperty(d, b, a);
  } else d[b] = e[b];
};
$jscomp.array = $jscomp.array || {};
$jscomp.array.done_ = function () {
  return {
    done: !0,
    value: void 0
  };
};
$jscomp.array.arrayIterator_ = function (d, e) {
  d instanceof String && (d = String(d));
  var k = 0;
  $jscomp.initSymbol();
  $jscomp.initSymbolIterator();
  var b = {},
    a = (b.next = function () {
      if (k < d.length) {
        var b = k++;
        return {
          value: e(b, d[b]),
          done: !1
        };
      }
      a.next = $jscomp.array.done_;
      return $jscomp.array.done_();
    }, b[Symbol.iterator] = function () {
      return a;
    }, b);
  return a;
};
$jscomp.array.findInternal_ = function (d, e, k) {
  d instanceof String && (d = String(d));
  for (var b = d.length, a = 0; a < b; a++) {
    var c = d[a];
    if (e.call(k, c, a, d)) return {
      i: a,
      v: c
    };
  }
  return {
    i: -1,
    v: void 0
  };
};
$jscomp.array.from = function (d, e, k) {
  e = void 0 === e ? function (a) {
    return a;
  } : e;
  var b = [];
  $jscomp.initSymbol();
  $jscomp.initSymbolIterator();
  if (d[Symbol.iterator]) {
    $jscomp.initSymbol();
    $jscomp.initSymbolIterator();
    d = d[Symbol.iterator]();
    for (var a; !(a = d.next()).done;) b.push(e.call(k, a.value));
  } else {
    a = d.length;
    for (var c = 0; c < a; c++) b.push(e.call(k, d[c]));
  }
  return b;
};
$jscomp.array.of = function (d) {
  for (var e = [], k = 0; k < arguments.length; ++k) e[k - 0] = arguments[k];
  return $jscomp.array.from(e);
};
$jscomp.array.entries = function () {
  return $jscomp.array.arrayIterator_(this, function (d, e) {
    return [d, e];
  });
};
$jscomp.array.entries$install = function () {
  Array.prototype.entries || (Array.prototype.entries = $jscomp.array.entries);
};
$jscomp.array.keys = function () {
  return $jscomp.array.arrayIterator_(this, function (d) {
    return d;
  });
};
$jscomp.array.keys$install = function () {
  Array.prototype.keys || (Array.prototype.keys = $jscomp.array.keys);
};
$jscomp.array.values = function () {
  return $jscomp.array.arrayIterator_(this, function (d, e) {
    return e;
  });
};
$jscomp.array.values$install = function () {
  Array.prototype.values || (Array.prototype.values = $jscomp.array.values);
};
$jscomp.array.copyWithin = function (d, e, k) {
  var b = this.length;
  d = Number(d);
  e = Number(e);
  k = Number(null != k ? k : b);
  if (d < e) for (k = Math.min(k, b); e < k;) e in this ? this[d++] = this[e++] : (delete this[d++], e++);else for (k = Math.min(k, b + e - d), d += k - e; k > e;) --k in this ? this[--d] = this[k] : delete this[d];
  return this;
};
$jscomp.array.copyWithin$install = function () {
  Array.prototype.copyWithin || (Array.prototype.copyWithin = $jscomp.array.copyWithin);
};
$jscomp.array.fill = function (d, e, k) {
  null != k && d.length || (k = this.length || 0);
  k = Number(k);
  for (e = Number((void 0 === e ? 0 : e) || 0); e < k; e++) this[e] = d;
  return this;
};
$jscomp.array.fill$install = function () {
  Array.prototype.fill || (Array.prototype.fill = $jscomp.array.fill);
};
$jscomp.array.find = function (d, e) {
  return $jscomp.array.findInternal_(this, d, e).v;
};
$jscomp.array.find$install = function () {
  Array.prototype.find || (Array.prototype.find = $jscomp.array.find);
};
$jscomp.array.findIndex = function (d, e) {
  return $jscomp.array.findInternal_(this, d, e).i;
};
$jscomp.array.findIndex$install = function () {
  Array.prototype.findIndex || (Array.prototype.findIndex = $jscomp.array.findIndex);
};
$jscomp.Map = function (d) {
  d = void 0 === d ? [] : d;
  this.data_ = {};
  this.head_ = $jscomp.Map.createHead_();
  this.size = 0;
  if (d) {
    d = $jscomp.makeIterator(d);
    for (var e = d.next(); !e.done; e = d.next()) e = e.value, this.set(e[0], e[1]);
  }
};
$jscomp.Map.checkBrowserConformance_ = function () {
  var d = $jscomp.global.Map;
  if (!d || !d.prototype.entries || !Object.seal) return !1;
  try {
    var e = Object.seal({
        x: 4
      }),
      k = new d($jscomp.makeIterator([[e, "s"]]));
    if ("s" != k.get(e) || 1 != k.size || k.get({
      x: 4
    }) || k.set({
      x: 4
    }, "t") != k || 2 != k.size) return !1;
    var b = k.entries(),
      a = b.next();
    if (a.done || a.value[0] != e || "s" != a.value[1]) return !1;
    a = b.next();
    return a.done || 4 != a.value[0].x || "t" != a.value[1] || !b.next().done ? !1 : !0;
  } catch (c) {
    return !1;
  }
};
$jscomp.Map.createHead_ = function () {
  var d = {};
  return d.previous = d.next = d.head = d;
};
$jscomp.Map.getId_ = function (d) {
  if (!(d instanceof Object)) return String(d);
  $jscomp.Map.key_ in d || d instanceof Object && Object.isExtensible && Object.isExtensible(d) && $jscomp.Map.defineProperty_(d, $jscomp.Map.key_, ++$jscomp.Map.index_);
  return $jscomp.Map.key_ in d ? d[$jscomp.Map.key_] : " " + d;
};
$jscomp.Map.prototype.set = function (d, e) {
  var k = this.maybeGetEntry_(d),
    b = k.id,
    a = k.list,
    k = k.entry;
  a || (a = this.data_[b] = []);
  k ? k.value = e : (k = {
    next: this.head_,
    previous: this.head_.previous,
    head: this.head_,
    key: d,
    value: e
  }, a.push(k), this.head_.previous.next = k, this.head_.previous = k, this.size++);
  return this;
};
$jscomp.Map.prototype["delete"] = function (d) {
  var e = this.maybeGetEntry_(d);
  d = e.id;
  var k = e.list,
    b = e.index;
  return (e = e.entry) && k ? (k.splice(b, 1), k.length || delete this.data_[d], e.previous.next = e.next, e.next.previous = e.previous, e.head = null, this.size--, !0) : !1;
};
$jscomp.Map.prototype.clear = function () {
  this.data_ = {};
  this.head_ = this.head_.previous = $jscomp.Map.createHead_();
  this.size = 0;
};
$jscomp.Map.prototype.has = function (d) {
  return !!this.maybeGetEntry_(d).entry;
};
$jscomp.Map.prototype.get = function (d) {
  return (d = this.maybeGetEntry_(d).entry) && d.value;
};
$jscomp.Map.prototype.maybeGetEntry_ = function (d) {
  var e = $jscomp.Map.getId_(d),
    k = this.data_[e];
  if (k) for (var b = 0; b < k.length; b++) {
    var a = k[b];
    if (d !== d && a.key !== a.key || d === a.key) return {
      id: e,
      list: k,
      index: b,
      entry: a
    };
  }
  return {
    id: e,
    list: k,
    index: -1,
    entry: void 0
  };
};
$jscomp.Map.prototype.entries = function () {
  return this.iter_(function (d) {
    return [d.key, d.value];
  });
};
$jscomp.Map.prototype.keys = function () {
  return this.iter_(function (d) {
    return d.key;
  });
};
$jscomp.Map.prototype.values = function () {
  return this.iter_(function (d) {
    return d.value;
  });
};
$jscomp.Map.prototype.forEach = function (d, e) {
  for (var k = $jscomp.makeIterator(this.entries()), b = k.next(); !b.done; b = k.next()) b = b.value, d.call(e, b[1], b[0], this);
};
$jscomp.Map.prototype.iter_ = function (d) {
  var e = this,
    k = this.head_;
  $jscomp.initSymbol();
  $jscomp.initSymbolIterator();
  var b = {};
  return b.next = function () {
    if (k) {
      for (; k.head != e.head_;) k = k.previous;
      for (; k.next != k.head;) return k = k.next, {
        done: !1,
        value: d(k)
      };
      k = null;
    }
    return {
      done: !0,
      value: void 0
    };
  }, b[Symbol.iterator] = function () {
    return this;
  }, b;
};
$jscomp.Map.index_ = 0;
$jscomp.Map.defineProperty_ = Object.defineProperty ? function (d, e, k) {
  Object.defineProperty(d, e, {
    value: String(k)
  });
} : function (d, e, k) {
  d[e] = String(k);
};
$jscomp.Map.Entry_ = function () {};
$jscomp.Map.ASSUME_NO_NATIVE = !1;
$jscomp.Map$install = function () {
  $jscomp.initSymbol();
  $jscomp.initSymbolIterator();
  !$jscomp.Map.ASSUME_NO_NATIVE && $jscomp.Map.checkBrowserConformance_() ? $jscomp.Map = $jscomp.global.Map : ($jscomp.initSymbol(), $jscomp.initSymbolIterator(), $jscomp.Map.prototype[Symbol.iterator] = $jscomp.Map.prototype.entries, $jscomp.initSymbol(), $jscomp.Map.key_ = Symbol("map-id-key"));
  $jscomp.Map$install = function () {};
};
$jscomp.math = $jscomp.math || {};
$jscomp.math.clz32 = function (d) {
  d = Number(d) >>> 0;
  if (0 === d) return 32;
  var e = 0;
  0 === (d & 4294901760) && (d <<= 16, e += 16);
  0 === (d & 4278190080) && (d <<= 8, e += 8);
  0 === (d & 4026531840) && (d <<= 4, e += 4);
  0 === (d & 3221225472) && (d <<= 2, e += 2);
  0 === (d & 2147483648) && e++;
  return e;
};
$jscomp.math.imul = function (d, e) {
  d = Number(d);
  e = Number(e);
  var k = d & 65535,
    b = e & 65535;
  return k * b + ((d >>> 16 & 65535) * b + k * (e >>> 16 & 65535) << 16 >>> 0) | 0;
};
$jscomp.math.sign = function (d) {
  d = Number(d);
  return 0 === d || isNaN(d) ? d : 0 < d ? 1 : -1;
};
$jscomp.math.log10 = function (d) {
  return Math.log(d) / Math.LN10;
};
$jscomp.math.log2 = function (d) {
  return Math.log(d) / Math.LN2;
};
$jscomp.math.log1p = function (d) {
  d = Number(d);
  if (.25 > d && -.25 < d) {
    for (var e = d, k = 1, b = d, a = 0, c = 1; a != b;) e *= d, c *= -1, b = (a = b) + c * e / ++k;
    return b;
  }
  return Math.log(1 + d);
};
$jscomp.math.expm1 = function (d) {
  d = Number(d);
  if (.25 > d && -.25 < d) {
    for (var e = d, k = 1, b = d, a = 0; a != b;) e *= d / ++k, b = (a = b) + e;
    return b;
  }
  return Math.exp(d) - 1;
};
$jscomp.math.cosh = function (d) {
  d = Number(d);
  return (Math.exp(d) + Math.exp(-d)) / 2;
};
$jscomp.math.sinh = function (d) {
  d = Number(d);
  return 0 === d ? d : (Math.exp(d) - Math.exp(-d)) / 2;
};
$jscomp.math.tanh = function (d) {
  d = Number(d);
  if (0 === d) return d;
  var e = Math.exp(2 * -Math.abs(d)),
    e = (1 - e) / (1 + e);
  return 0 > d ? -e : e;
};
$jscomp.math.acosh = function (d) {
  d = Number(d);
  return Math.log(d + Math.sqrt(d * d - 1));
};
$jscomp.math.asinh = function (d) {
  d = Number(d);
  if (0 === d) return d;
  var e = Math.log(Math.abs(d) + Math.sqrt(d * d + 1));
  return 0 > d ? -e : e;
};
$jscomp.math.atanh = function (d) {
  d = Number(d);
  return ($jscomp.math.log1p(d) - $jscomp.math.log1p(-d)) / 2;
};
$jscomp.math.hypot = function (d, e, k) {
  for (var b = [], a = 2; a < arguments.length; ++a) b[a - 2] = arguments[a];
  d = Number(d);
  e = Number(e);
  for (var c = Math.max(Math.abs(d), Math.abs(e)), G = $jscomp.makeIterator(b), a = G.next(); !a.done; a = G.next()) c = Math.max(c, Math.abs(a.value));
  if (1E100 < c || 1E-100 > c) {
    d /= c;
    e /= c;
    G = d * d + e * e;
    b = $jscomp.makeIterator(b);
    for (a = b.next(); !a.done; a = b.next()) a = a.value, a = Number(a) / c, G += a * a;
    return Math.sqrt(G) * c;
  }
  c = d * d + e * e;
  b = $jscomp.makeIterator(b);
  for (a = b.next(); !a.done; a = b.next()) a = a.value, a = Number(a), c += a * a;
  return Math.sqrt(c);
};
$jscomp.math.trunc = function (d) {
  d = Number(d);
  if (isNaN(d) || Infinity === d || -Infinity === d || 0 === d) return d;
  var e = Math.floor(Math.abs(d));
  return 0 > d ? -e : e;
};
$jscomp.math.cbrt = function (d) {
  if (0 === d) return d;
  d = Number(d);
  var e = Math.pow(Math.abs(d), 1 / 3);
  return 0 > d ? -e : e;
};
$jscomp.number = $jscomp.number || {};
$jscomp.number.isFinite = function (d) {
  return "number" !== typeof d ? !1 : !isNaN(d) && Infinity !== d && -Infinity !== d;
};
$jscomp.number.isInteger = function (d) {
  return $jscomp.number.isFinite(d) ? d === Math.floor(d) : !1;
};
$jscomp.number.isNaN = function (d) {
  return "number" === typeof d && isNaN(d);
};
$jscomp.number.isSafeInteger = function (d) {
  return $jscomp.number.isInteger(d) && Math.abs(d) <= $jscomp.number.MAX_SAFE_INTEGER;
};
$jscomp.number.EPSILON = Math.pow(2, -52);
$jscomp.number.MAX_SAFE_INTEGER = 9007199254740991;
$jscomp.number.MIN_SAFE_INTEGER = -9007199254740991;
$jscomp.object = $jscomp.object || {};
$jscomp.object.assign = function (d, e) {
  for (var k = [], b = 1; b < arguments.length; ++b) k[b - 1] = arguments[b];
  k = $jscomp.makeIterator(k);
  for (b = k.next(); !b.done; b = k.next()) if (b = b.value) for (var a in b) Object.prototype.hasOwnProperty.call(b, a) && (d[a] = b[a]);
  return d;
};
$jscomp.object.is = function (d, e) {
  return d === e ? 0 !== d || 1 / d === 1 / e : d !== d && e !== e;
};
$jscomp.Set = function (d) {
  d = void 0 === d ? [] : d;
  this.map_ = new $jscomp.Map();
  if (d) {
    d = $jscomp.makeIterator(d);
    for (var e = d.next(); !e.done; e = d.next()) this.add(e.value);
  }
  this.size = this.map_.size;
};
$jscomp.Set.checkBrowserConformance_ = function () {
  var d = $jscomp.global.Set;
  if (!d || !d.prototype.entries || !Object.seal) return !1;
  var e = Object.seal({
      x: 4
    }),
    d = new d($jscomp.makeIterator([e]));
  if (d.has(e) || 1 != d.size || d.add(e) != d || 1 != d.size || d.add({
    x: 4
  }) != d || 2 != d.size) return !1;
  var d = d.entries(),
    k = d.next();
  if (k.done || k.value[0] != e || k.value[1] != e) return !1;
  k = d.next();
  return k.done || k.value[0] == e || 4 != k.value[0].x || k.value[1] != k.value[0] ? !1 : d.next().done;
};
$jscomp.Set.prototype.add = function (d) {
  this.map_.set(d, d);
  this.size = this.map_.size;
  return this;
};
$jscomp.Set.prototype["delete"] = function (d) {
  d = this.map_["delete"](d);
  this.size = this.map_.size;
  return d;
};
$jscomp.Set.prototype.clear = function () {
  this.map_.clear();
  this.size = 0;
};
$jscomp.Set.prototype.has = function (d) {
  return this.map_.has(d);
};
$jscomp.Set.prototype.entries = function () {
  return this.map_.entries();
};
$jscomp.Set.prototype.values = function () {
  return this.map_.values();
};
$jscomp.Set.prototype.forEach = function (d, e) {
  var k = this;
  this.map_.forEach(function (b) {
    return d.call(e, b, b, k);
  });
};
$jscomp.Set.ASSUME_NO_NATIVE = !1;
$jscomp.Set$install = function () {
  !$jscomp.Set.ASSUME_NO_NATIVE && $jscomp.Set.checkBrowserConformance_() ? $jscomp.Set = $jscomp.global.Set : ($jscomp.Map$install(), $jscomp.initSymbol(), $jscomp.initSymbolIterator(), $jscomp.Set.prototype[Symbol.iterator] = $jscomp.Set.prototype.values);
  $jscomp.Set$install = function () {};
};
$jscomp.string = $jscomp.string || {};
$jscomp.string.noRegExp_ = function (d, e) {
  if (d instanceof RegExp) throw new TypeError("First argument to String.prototype." + e + " must not be a regular expression");
};
$jscomp.string.fromCodePoint = function (d) {
  for (var e = [], k = 0; k < arguments.length; ++k) e[k - 0] = arguments[k];
  for (var k = "", e = $jscomp.makeIterator(e), b = e.next(); !b.done; b = e.next()) {
    b = b.value;
    b = +b;
    if (0 > b || 1114111 < b || b !== Math.floor(b)) throw new RangeError("invalid_code_point " + b);
    65535 >= b ? k += String.fromCharCode(b) : (b -= 65536, k += String.fromCharCode(b >>> 10 & 1023 | 55296), k += String.fromCharCode(b & 1023 | 56320));
  }
  return k;
};
$jscomp.string.repeat = function (d) {
  var e = this.toString();
  if (0 > d || 1342177279 < d) throw new RangeError("Invalid count value");
  d |= 0;
  for (var k = ""; d;) if (d & 1 && (k += e), d >>>= 1) e += e;
  return k;
};
$jscomp.string.repeat$install = function () {
  String.prototype.repeat || (String.prototype.repeat = $jscomp.string.repeat);
};
$jscomp.string.codePointAt = function (d) {
  var e = this.toString(),
    k = e.length;
  d = Number(d) || 0;
  if (0 <= d && d < k) {
    d |= 0;
    var b = e.charCodeAt(d);
    if (55296 > b || 56319 < b || d + 1 === k) return b;
    d = e.charCodeAt(d + 1);
    return 56320 > d || 57343 < d ? b : 1024 * (b - 55296) + d + 9216;
  }
};
$jscomp.string.codePointAt$install = function () {
  String.prototype.codePointAt || (String.prototype.codePointAt = $jscomp.string.codePointAt);
};
$jscomp.string.includes = function (d, e) {
  e = void 0 === e ? 0 : e;
  $jscomp.string.noRegExp_(d, "includes");
  return -1 !== this.toString().indexOf(d, e);
};
$jscomp.string.includes$install = function () {
  String.prototype.includes || (String.prototype.includes = $jscomp.string.includes);
};
$jscomp.string.startsWith = function (d, e) {
  e = void 0 === e ? 0 : e;
  $jscomp.string.noRegExp_(d, "startsWith");
  var k = this.toString();
  d += "";
  for (var b = k.length, a = d.length, c = Math.max(0, Math.min(e | 0, k.length)), G = 0; G < a && c < b;) if (k[c++] != d[G++]) return !1;
  return G >= a;
};
$jscomp.string.startsWith$install = function () {
  String.prototype.startsWith || (String.prototype.startsWith = $jscomp.string.startsWith);
};
$jscomp.string.endsWith = function (d, e) {
  $jscomp.string.noRegExp_(d, "endsWith");
  var k = this.toString();
  d += "";
  void 0 === e && (e = k.length);
  for (var b = Math.max(0, Math.min(e | 0, k.length)), a = d.length; 0 < a && 0 < b;) if (k[--b] != d[--a]) return !1;
  return 0 >= a;
};
$jscomp.string.endsWith$install = function () {
  String.prototype.endsWith || (String.prototype.endsWith = $jscomp.string.endsWith);
};
(function (d, e) {
  "object" === typeof exports && "object" === typeof module ? module.exports = e() : "function" === typeof define && define.amd ? define([], e) : "object" === typeof exports ? exports.CitrixWebRTC = e() : d.CitrixWebRTC = e();
})(self, function () {
  return function () {
    function d(b) {
      var a = k[b];
      if (void 0 !== a) return a.exports;
      a = k[b] = {
        exports: {}
      };
      e[b].call(a.exports, a, a.exports, d);
      return a.exports;
    }
    var e = {
        945: function (b, a, c) {
          var d = this && this.__extends || function () {
            var a = function (b, c) {
              a = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (a, b) {
                a.__proto__ = b;
              } || function (a, b) {
                for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
              };
              return a(b, c);
            };
            return function (b, c) {
              function d() {
                this.constructor = b;
              }
              a(b, c);
              b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
            };
          }();
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var v = c(658),
            r = c(550),
            n = c(851),
            g = c(946);
          b = function (a) {
            function b() {
              var c = a.call(this, null, r.class_id_t.AudioElement, 0, v.ProxyMode.Local) || this;
              c.sinkId_ = "";
              c.srcObject_ = null;
              return c;
            }
            d(b, a);
            b.prototype.setSinkId = function (a) {
              var b = this;
              n.logger.log(this.user_friendly_id() + ".setSinkId: set sinkId to " + a);
              return new Promise(function (c, d) {
                b.waitUntilConnected("AudioElement.sinkId").then(function () {
                  var d = b.remoteInvoke(!0, r.method_id_AudioElement_t.sinkId, a);
                  g.getRedirector().getFeatureValue(r.FEATURE_ms_teams_pstn) || (b.sinkId_ = a, c());
                  return d;
                }).then(function () {
                  n.logger.log(b.user_friendly_id() + ".setSinkId: success! resolving...");
                  b.sinkId_ = a;
                  c();
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".sinkId setter: failed to connect!");
                  d(a);
                });
              });
            };
            Object.defineProperty(b.prototype, "sinkId", {
              get: function () {
                return this.sinkId_;
              },
              set: function (a) {
                this.setSinkId(a);
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "srcObject", {
              get: function () {
                return this.srcObject_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".srcObject: set srcObject to " + JSON.stringify(a));
                if (a !== this.srcObject_) {
                  this.srcObject_ = a;
                  var c = null !== a && void 0 !== a ? a.id : "null";
                  this.waitUntilConnected("AudioElement.srcObject").then(function () {
                    return b.remoteInvoke(!0, r.method_id_AudioElement_t.srcObject, c);
                  }).then(function () {
                    n.logger.log(b.user_friendly_id() + ".srcObject setter: remote success!");
                  })["catch"](function (a) {
                    b.logRemoteInvokeError(a, ".srcObject setter: failed to connect!");
                  });
                }
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "src", {
              get: function () {
                return this.src_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".src: set src to " + a);
                this.src_ = a;
                this.waitUntilConnected("AudioElement.src").then(function () {
                  b.remoteInvoke(!0, r.method_id_AudioElement_t.src, a);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".src setter: failed to connect!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.play = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".play() called.");
              return new Promise(function (b, c) {
                a.toggleAudio(!0);
                a.waitUntilConnected("AudioElement.play").then(function () {
                  a.remoteInvoke(!1, r.method_id_AudioElement_t.play, []).then(function () {
                    b();
                  })["catch"](function (b) {
                    a.logRemoteInvokeError(b, ".play: failed to remote!");
                    c();
                  });
                })["catch"](function (b) {
                  a.logRemoteInvokeError(b, ".play: failed to connect!");
                  c();
                });
              });
            };
            b.prototype.pause = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".pause() called.");
              return new Promise(function (b, c) {
                a.toggleAudio(!1);
                a.waitUntilConnected("AudioElement.pause").then(function () {
                  a.remoteInvoke(!1, r.method_id_AudioElement_t.pause, []).then(function () {
                    b();
                  })["catch"](function (b) {
                    a.logRemoteInvokeError(b, ".pause: failed to remote!");
                    c();
                  });
                })["catch"](function (b) {
                  a.logRemoteInvokeError(b, ".pause: failed to connect!");
                  c();
                });
              });
            };
            b.prototype.toggleAudio = function (a) {
              this.srcObject_ && (n.logger.log(this.user_friendly_id() + ".toggleAudio() toggle audio tracks:" + a), this.srcObject_.toggleAudio(a));
            };
            b.prototype.dispose = function () {
              n.logger.log(this.user_friendly_id() + ".dispose()");
              this.src_ = this.sinkId_ = "";
              this.srcObject_ = null;
              this.release();
            };
            return b;
          }(v.ProxyObject);
          a.AudioElement = b;
        },
        9: function (b, a, c) {
          var d = this && this.__extends || function () {
            var a = function (b, c) {
              a = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (a, b) {
                a.__proto__ = b;
              } || function (a, b) {
                for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
              };
              return a(b, c);
            };
            return function (b, c) {
              function d() {
                this.constructor = b;
              }
              a(b, c);
              b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
            };
          }();
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var v = c(550),
            r = c(946),
            n = c(658),
            g = c(851);
          (function (a) {
            a[a.Webrpc = 0] = "Webrpc";
            a[a.WebrtcCodecs = 1] = "WebrtcCodecs";
            a[a.Receiver = 2] = "Receiver";
            a[a.Vda = 3] = "Vda";
            a[a.Endpoint = 4] = "Endpoint";
            a[a.TypeScript = 5] = "TypeScript";
            a[a.Max = 6] = "Max";
          })(a.VersionType || (a.VersionType = {}));
          b = function (a) {
            function b() {
              return a.call(this, null, v.class_id_t.EngineControl, 0, n.ProxyMode.Local) || this;
            }
            d(b, a);
            b.prototype.bind = function () {
              g.logger.log(this.user_friendly_id() + ".bind() called.");
              this.reconstructor(null, v.class_id_t.EngineControl, 0);
            };
            b.prototype.syncBarrier = function () {
              var a = this;
              g.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("EngineControl.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, v.method_id_EngineControl_t.version, {
                    major: 0,
                    minor: 0,
                    revision: 0,
                    build: 0
                  }), a.remoteInvoke(!1, v.method_id_EngineControl_t.feature_flags, [])]);
                }).then(function (b) {
                  g.logger.log(a.user_friendly_id() + "received webrpc version and supported feature list.");
                  b = b.map(function (b) {
                    return a.param0(b);
                  });
                  a.version_ = b[0];
                  a.features_ = b[1];
                  r.getRedirector().setFeatures(a.features_);
                  b = [];
                  for (var c = 0, t = a.features_; c < t.length; c++) {
                    var h = t[c];
                    "ms_teams_desktop_sharing" === h.name && h.value ? b.push(a.remoteInvoke(!1, v.method_id_EngineControl_t.version_info, [])) : "ms_teams_osinfo" === h.name && h.value ? b.push(a.remoteInvoke(!1, v.method_id_EngineControl_t.osinfo, {
                      family: "",
                      version: "",
                      architecture: "",
                      distro: "",
                      edition: ""
                    })) : "ms_teams_endpoint_id" === h.name && h.value && b.push(a.remoteInvoke(!1, v.method_id_EngineControl_t.endpoint_id, {
                      machine_id: "",
                      user_id: ""
                    }));
                  }
                  if (0 < b.length) return Promise.all(b);
                }).then(function (c) {
                  if (void 0 === c) g.logger.log(a.user_friendly_id() + "release-1905 client.");else {
                    g.logger.log(a.user_friendly_id() + "release-1906 or later client: received detailed client version list.");
                    for (var d = 0; d < c.length; d++) {
                      var t = c[d];
                      t.hdr.proc.iid == v.class_id_t.EngineControl && t.hdr.proc.methodid == v.method_id_EngineControl_t.version_info ? a.versions_ = a.param0(t) : t.hdr.proc.iid == v.class_id_t.EngineControl && t.hdr.proc.methodid == v.method_id_EngineControl_t.osinfo ? a.osinfo_ = a.param0(t) : t.hdr.proc.iid == v.class_id_t.EngineControl && t.hdr.proc.methodid == v.method_id_EngineControl_t.endpoint_id && (a.endpointid_ = a.param0(t));
                    }
                  }
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, "failure to retrieve version/feature related client info.");
                  c(b);
                });
              });
            };
            return b;
          }(n.ProxyObject);
          a.EngineControl = b;
        },
        368: function (b, a, c) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var d = c(851),
            v = c(946);
          b = function () {
            function a() {
              var b = this;
              this.running_ = !1;
              this.elements_ = [];
              this.clipRects = new Set();
              this.wheelEventHandler = function (a) {
                setTimeout(function () {
                  b.updateAll();
                }, 10);
              };
              this.keyupEventHandler = function (a) {
                "Tab" != a.code && "ArrowUp" != a.code && "ArrowDown" != a.code && "ArrowLeft" != a.code && "ArrowRight" != a.code && "PageUp" != a.code && "PageDown" != a.code && "Home" != a.code && "End" != a.code || b.updateAll();
              };
              a.sendOverlayInfo();
              this.observer_ = new MutationObserver(function (a) {
                b.updateAll();
              });
            }
            a.sendOverlayInfo = function () {
              var a = window.getWindowHandleAsHex;
              if (void 0 === a || null === a) d.logger.log("FrameTracker.sendOverlayInfo: getWindowHandle method is undefined or null");else {
                var b = v.getRedirector();
                Promise.all([a(), b.startRedirection(!1, "sendOverlayInfo")]).then(function (a) {
                  d.logger.log("FrameTracker.sendOverlayInfo: set window handle: " + a[0]);
                  b.WSSendObject({
                    v: "overlay",
                    command: "window",
                    windowHandle: a[0]
                  });
                });
              }
            };
            a.prototype.rectanglesIntersect = function (a, b) {
              return a.x < b.x + b.width && a.x + a.width > b.x && a.y < b.y + b.height && a.y + a.height > b.y ? !0 : !1;
            };
            a.prototype.intersectingRect = function (a, b) {
              var c = Math.max(a.left, b.left),
                d = Math.max(a.top, b.top);
              return new DOMRect(c, d, Math.min(a.right, b.right) - c, Math.min(a.bottom, b.bottom) - d);
            };
            a.prototype.pedigreeCount = function (a, b) {
              for (var c = 0, d = a.parentElement; null != d && d != b;) c++, d = d.parentElement;
              return {
                isAncestor: null != d,
                pedigree: c
              };
            };
            a.prototype.selectTopmost = function (a, b) {
              var c = a.getBoundingClientRect(),
                d = b.getBoundingClientRect(),
                c = this.intersectingRect(c, d),
                d = document.elementFromPoint(c.left + c.width / 2, c.top + c.height / 2);
              if (d == a) return a;
              if (d == b) return b;
              c = this.pedigreeCount(a, d);
              d = this.pedigreeCount(b, d);
              if (c.isAncestor && d.isAncestor) {
                if (c.pedigree < d.pedigree) return a;
                if (d.pedigree < c.pedigree) return b;
              } else {
                if (c.isAncestor) return a;
                if (d.isAncestor) return b;
              }
            };
            a.prototype.checkOverlappingVideos = function (a) {
              var b = this,
                c = a.target.getBoundingClientRect();
              a.overlaps.forEach(function (b) {
                a.target.remoteVideoElement.removeClipRect(b.rect);
              });
              a.overlaps = [];
              this.elements_.forEach(function (d) {
                if (d != a) {
                  var r = d.overlaps.map(function (a) {
                    return a.element;
                  }).indexOf(a.target);
                  -1 != r && (r = d.overlaps.splice(r, 1)[0], d.target.remoteVideoElement.removeClipRect(r.rect));
                  r = d.target.getBoundingClientRect();
                  if (b.rectanglesIntersect(c, r)) {
                    var x = b.selectTopmost(a.target, d.target);
                    x == a.target ? (d.overlaps.push({
                      element: a.target,
                      rect: c
                    }), d.target.remoteVideoElement.addClipRect(c)) : x == d.target && (a.overlaps.push({
                      element: d.target,
                      rect: r
                    }), a.target.remoteVideoElement.addClipRect(r));
                  }
                }
              });
            };
            a.prototype.updateAll = function () {
              var a = this;
              this.elements_.forEach(function (b) {
                var c = b.target.getBoundingClientRect();
                if (void 0 !== c) {
                  var d = b.clientRect;
                  if (void 0 === d || d.x !== c.x || d.y !== c.y || d.width !== c.width || d.height !== c.height) b.clientRect = c, b.callback(c), a.checkOverlappingVideos(b);
                }
              });
            };
            a.prototype.track = function (a, b) {
              var c = this,
                f = a.getBoundingClientRect();
              d.logger.log("Track element frame", a, JSON.stringify(f));
              console.log(a);
              this.elements_.push({
                target: a,
                clientRect: void 0,
                callback: b,
                overlaps: []
              });
              try {
                d.logger.log("[HdxWebRTC.js] Initializing occlusion for new videoElement"), this.clipRects.forEach(function (b) {
                  c.applyOcclusion(a, JSON.parse(b));
                });
              } catch (r) {
                d.logger.log("[HdxWebRTC.js] addOcclusionInit failed! " + r);
              }
              this.running_ || (d.logger.log("Start FrameTracker observer..."), this.observer_.observe(document.body, {
                attributes: !0,
                childList: !0,
                subtree: !0
              }), window.addEventListener("wheel", this.wheelEventHandler), window.addEventListener("keyup", this.keyupEventHandler), this.running_ = !0);
              this.updateAll();
            };
            a.prototype.untrack = function (a) {
              d.logger.log("Untrack element frame", a);
              var b = -1;
              this.elements_.forEach(function (c, d) {
                c.target === a && (b = d);
              });
              0 <= b && (this.elements_.splice(b, 1), 0 === this.elements_.length && (d.logger.log("Stop FrameTracker observer..."), this.observer_.disconnect(), window.removeEventListener("wheel", this.wheelEventHandler), window.removeEventListener("keyup", this.keyupEventHandler), this.running_ = !1));
            };
            a.prototype.applyOcclusion = function (a, b) {
              var c = a.getBoundingClientRect();
              this.rectanglesIntersect(b, c) && void 0 !== a.remoteVideoElement && a.remoteVideoElement.addClipRect(b);
            };
            a.prototype.addOcclusion = function (a) {
              var b = this;
              d.logger.log("[HdxWebRTC.js] Adding occlusion " + JSON.stringify(a));
              d.logger.log("[HdxWebRTC.js] Tracking '" + this.elements_.length + "' elements.");
              this.clipRects.add(JSON.stringify(a));
              this.elements_.forEach(function (c) {
                b.applyOcclusion(c.target, a);
              });
            };
            a.prototype.removeOcclusion = function (a) {
              d.logger.log("[HdxWebRTC.js] Removing occlusion " + JSON.stringify(a));
              d.logger.log("[HdxWebRTC.js] Tracking '" + this.elements_.length + "' elements.");
              this.clipRects["delete"](JSON.stringify(a));
              this.elements_.forEach(function (b) {
                void 0 !== b.target.remoteVideoElement && b.target.remoteVideoElement.removeClipRect(a);
              });
            };
            return a;
          }();
          a.FrameTracker = b;
        },
        247: function (b, a) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var c = function () {
              function a(b) {
                this.parent_ = this.object_ = null;
                this.children_ = [];
                this.object_ = b;
              }
              a.prototype.addChild = function (a) {
                a.parent_ != this && (a.parent_ = this, this.children_.push(a));
              };
              a.prototype.removeChild = function (a) {
                var b = this.children_.indexOf(a);
                this.children_.splice(b, 1);
                a.parent_ = null;
              };
              return a;
            }(),
            d = function () {
              function a() {
                this.root_ = new c(null);
              }
              a.prototype.trackObject = function (a, b) {
                void 0 === b && (b = null);
                if (null === this.findNode(a, this.root_)) {
                  var d = this.findNode(b, this.root_),
                    p = new c(a);
                  d ? d.addChild(p) : this.root_.addChild(p);
                }
              };
              a.prototype.releaseObject = function (a) {
                a = this.findNode(a, this.root_);
                if (null === a || a === this.root_) return !1;
                this.destroyNodeObjectRecurse(a);
                a.parent_.removeChild(a);
                return !0;
              };
              a.prototype.destroyNodeObjectRecurse = function (a) {
                for (var b = 0, c = a.children_; b < c.length; b++) this.destroyNodeObjectRecurse(c[b]);
                a.object_.destroy();
              };
              a.prototype.setParent = function (a, b) {
                var c = this.findNode(a, this.root_);
                if (null === c) return !1;
                var d = this.findNode(b, this.root_);
                if (null === d) return !1;
                if (c.parent_ === d) return !0;
                c.parent_.removeChild(c);
                d.addChild(c);
                return !0;
              };
              a.prototype.reset = function () {
                this.root_.children_ = [];
              };
              a.prototype.findNode = function (a, b) {
                if (b.object_ === a) return b;
                for (var c = null, d = 0, f = b.children_; d < f.length && (c = this.findNode(a, f[d]), null === c); d++);
                return c;
              };
              return a;
            }();
          a.GC = d;
          a.gc = new d();
        },
        946: function (b, a, c) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var d = c(658),
            v = c(851),
            r = c(550),
            n = c(545),
            g = c(394),
            p = c(509),
            f = function () {
              return function (a, b, c, d, m, f, g) {
                this.resolve = a;
                this.reject = b;
                this.iid = c;
                this.oid = d;
                this.cbid = m;
                this.oneShot = f;
                this.mid = g;
              };
            }(),
            e;
          (function (a) {
            a[a.rpc_status_success = 0] = "rpc_status_success";
            a[a.rpc_status_unspecified_error = 1] = "rpc_status_unspecified_error";
            a[a.rpc_status_unexpected = 2] = "rpc_status_unexpected";
            a[a.rpc_status_index_out_of_bounds = 3] = "rpc_status_index_out_of_bounds";
            a[a.rpc_status_missing_parameter = 4] = "rpc_status_missing_parameter";
            a[a.rpc_status_missing_return_value = 5] = "rpc_status_missing_return_value";
            a[a.rpc_status_invalid_object = 6] = "rpc_status_invalid_object";
            a[a.rpc_status_user_exception = 7] = "rpc_status_user_exception";
            a[a.rpc_status_system_error = 8] = "rpc_status_system_error";
          })(e = a.WebrpcStatusCode || (a.WebrpcStatusCode = {}));
          var x;
          (function (a) {
            a[a.NotRedirected = 0] = "NotRedirected";
            a[a.Connecting = 1] = "Connecting";
            a[a.Binding = 2] = "Binding";
            a[a.Redirected = 3] = "Redirected";
          })(x = a.RedirectionStatus || (a.RedirectionStatus = {}));
          b = function () {
            function a() {
              this.pingactive = !1;
              this.status = x.NotRedirected;
              this.reqs = [];
              this.cbs = [];
              this.deferredActions = [];
              this.telemetry_ = new g.Telemetry();
              this.screenshare_ = new p.ScreenShareUtil();
              this.stateChangeNotifcations = [];
              this.vdafeatures_ = [];
            }
            Object.defineProperty(a.prototype, "telemetry", {
              get: function () {
                return this.telemetry_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(a.prototype, "screenshare", {
              get: function () {
                return this.screenshare_;
              },
              enumerable: !0,
              configurable: !0
            });
            a.prototype.stopAppshare = function () {
              var a = window.stopAppshare;
              a && a();
            };
            a.prototype.setRemoteSessionInfoCb = function (a) {
              this.remoteSessionInfoCb = a;
            };
            a.prototype.setFeatures = function (a) {
              this.features = a;
              this.screenshare.onInitComplete();
            };
            a.prototype.getFeatureValue = function (a) {
              var b = this.features.find(function (b) {
                return b.name === a;
              });
              return void 0 !== b ? b.value : !1;
            };
            a.prototype.onRedirectionComplete = function () {
              for (; this.deferredActions && 0 < this.deferredActions.length;) this.deferredActions.shift().post(this.status == x.Redirected);
            };
            a.prototype.connectToService = function () {
              v.logger.log("Redirection status: Connecting...");
              this.status = x.Connecting;
              return new Promise(function (a, b) {
                var c = new WebSocket("wss://127.0.0.1:9002");
                c.onopen = function () {
                  a(c);
                };
                c.onerror = function (a) {
                  v.logger.log("websocket connection error: " + a.type);
                  b(a);
                };
              });
            };
            a.prototype.waitUntilRedirected = function (a) {
              var b = this;
              return new Promise(function (c, d) {
                b.status == x.Redirected ? c() : 0 >= a ? d() : setTimeout(function () {
                  v.logger.log("waitUntilRedirected() timeout. count=" + a);
                  b.status != x.Redirected ? b.waitUntilRedirected(--a).then(function () {
                    c();
                  })["catch"](function () {
                    d();
                  }) : c();
                }, 2E3);
              });
            };
            a.prototype.handleRemoteSessionInfo = function () {
              var a = this;
              v.logger.log("handleRemoteSessionInfo called.");
              var b = this;
              b.remoteSessionInfoCb ? b.remoteSessionInfoCb().then(function (c) {
                v.logger.log("remoteSessionInfo success! info:" + JSON.stringify(c));
                v.logger.log("Redirection status: Redirected");
                b.status = x.Redirected;
                b.pingConnectionEnd();
                (0, window.onVdiClientConnected)();
                a.telemetry.SendTelemetryInit();
                b.onRedirectionComplete();
              })["catch"](function () {
                v.logger.log("remoteSessionInfo failure!");
                b.suspendRedirection(!0);
                b.onRedirectionComplete();
              }) : (v.logger.log("remoteSessionInfoCb is invalid!"), b.suspendRedirection(!0), b.onRedirectionComplete());
            };
            a.prototype.startRedirection = function (a, b) {
              var c = this,
                m = window.onVdiClientDisconnected;
              return new Promise(function (f, g) {
                c.status != x.Redirected ? (v.logger.log("Attempting to start redirection: " + b), !1 === a ? c.deferredActions.push(new d.deferred_action(f, g, b)) : c.connectToService().then(function (a) {
                  v.logger.log("Redirection status: Binding...");
                  c.status = x.Binding;
                  c.websocket = a;
                  c.websocket.onmessage = function (a) {
                    c.onWSMessage(a);
                  };
                  c.websocket.onclose = function (a) {
                    c.onWSClose(a);
                  };
                  f();
                  c.handleRemoteSessionInfo();
                })["catch"](function (a) {
                  v.logger.log("Unable to connect to websocket service!");
                  g();
                  c.suspendRedirection(!0);
                  c.onRedirectionComplete();
                  m(!0);
                })) : (v.logger.log("Redirection already started."), f());
              });
            };
            a.prototype.suspendRedirection = function (a) {
              var b = this;
              v.logger.log("Suspending redirection.");
              (0, window.onVdiClientDisconnected)(!1);
              var c = !1;
              a = window.getCitrixMSTeamsRedir;
              var d = window.getCitrixWebrtcRedir,
                m;
              a ? m = a : d && (m = d);
              m && m().then(function (a) {
                v.logger.log("sucesss on disconnect" + a);
                "1" == a && (c = !0, v.logger.log("Reg key exists while disconnecting"));
                b.status === x.Redirected && 1 == c && (v.logger.log("Calling ping not normal disconnect"), b.pingConnectionBegin(!1));
                v.logger.log("Redirection status: NotRedirected");
                b.status = x.NotRedirected;
              })["catch"](function () {
                v.logger.log("Failure to Read MS Teams redir Reg Key, not retrying...");
              });
              this.dispatchStateChangeNotifications();
            };
            a.prototype.onWSOpen = function () {};
            a.prototype.onWSClose = function (a) {
              v.logger.log("disconnected from websocket service.");
              try {
                this.suspendRedirection(!0);
              } catch (b) {
                v.logger.log("suspendRedirection(): exception closing WebSocket: " + b.message);
              }
            };
            a.prototype.onWSError = function () {
              try {
                this.suspendRedirection(!0);
              } catch (a) {
                v.logger.log("suspendRedirection(): exception on WebSocket error: " + a.message);
              }
            };
            a.prototype.WSSendObjectWrapper = function (a, b, c, d) {
              var m = !0;
              b != r.class_id_t.EngineControl || c != r.method_id_EngineControl_t.ctor && c != r.method_id_EngineControl_t.version && c != r.method_id_EngineControl_t.feature_flags || (m = !1);
              var f = !0;
              if (m && (f = !1, void 0 != this.features)) for (var m = 0, u = this.features; m < u.length; m++) {
                var q = u[m];
                if (!0 === q.value && q.name == a) {
                  f = !0;
                  break;
                }
              }
              return 1 == f ? this.WSSendObject(d) : Promise.reject("Cannot invoke method that is not supported by webrpc: iid(" + b + ") mid(" + c + ")");
            };
            a.prototype.WSSendObject = function (a) {
              var b = this;
              return new Promise(function (c, d) {
                if ("webrtc" == a.v) {
                  var m = a.hdr.proc.iid,
                    g = a.hdr.proc.methodid,
                    u = a.objref.oid;
                  a.hdr.destroy || (m = new f(c, d, m, u, 0, !0, g), b.reqs.push(m));
                  m = JSON.stringify(a);
                  v.logger.trace("WSSendObject: >>> " + r.WebrpcClassLibInfoUtil.composeClassInfoData(a) + " " + m);
                  try {
                    b.websocket.send(m);
                  } catch (q) {
                    v.logger.log("WSSendObject(): exception: " + q.message), d(q.message);
                  }
                } else if ("overlay" == a.v) {
                  m = JSON.stringify(a);
                  v.logger.log("HDXMS: SendOverlayData: >>> " + m + "'");
                  try {
                    b.websocket.send(m);
                  } catch (q) {
                    v.logger.log("WSSendObject(): exception: " + q.message), d(q.message);
                  }
                } else if ("telemetry" == a.v) {
                  m = JSON.stringify(a);
                  v.logger.log("HDXMS: SendTelemetryData: >>> " + m + "'");
                  try {
                    b.websocket.send(m);
                  } catch (q) {
                    v.logger.log("WSSendObject(): exception: " + q.message), d(q.message);
                  }
                } else if ("appsharing" == a.v) {
                  m = JSON.stringify(a);
                  v.logger.log("HDXMS: SendScreenSharingData: >>> " + m + "'");
                  try {
                    b.websocket.send(m);
                  } catch (q) {
                    v.logger.log("WSSendObject(): exception: " + q.message), d(q.message);
                  }
                } else v.logger.log("HDXMS: Unknown protocol: '" + JSON.stringify(a) + "'");
              });
            };
            a.prototype.webrpcStatusCodeToName = function (a) {
              switch (a) {
                case e.rpc_status_success:
                  a = "rpc_status_success";
                  break;
                case e.rpc_status_unspecified_error:
                  a = "rpc_status_unspecified_error";
                  break;
                case e.rpc_status_unexpected:
                  a = "rpc_status_unexpected";
                  break;
                case e.rpc_status_index_out_of_bounds:
                  a = "rpc_status_index_out_of_bounds";
                  break;
                case e.rpc_status_missing_parameter:
                  a = "rpc_status_missing_parameter";
                  break;
                case e.rpc_status_missing_return_value:
                  a = "rpc_status_missing_return_value";
                  break;
                case e.rpc_status_invalid_object:
                  a = "rpc_status_invalid_object";
                  break;
                case e.rpc_status_user_exception:
                  a = "rpc_status_user_exception";
                  break;
                case e.rpc_status_system_error:
                  a = "rpc_status_system_error";
                  break;
                default:
                  a = "unknown";
              }
              return a;
            };
            a.prototype.parceWebrpcError = function (a, b) {
              void 0 === a && (a = b && 0 < b.length ? b[0].category || b[0].code || b[0].message ? e.rpc_status_system_error : e.rpc_status_user_exception : e.rpc_status_unspecified_error);
              var c;
              switch (a) {
                case e.rpc_status_unspecified_error:
                case e.rpc_status_unexpected:
                case e.rpc_status_index_out_of_bounds:
                case e.rpc_status_missing_parameter:
                case e.rpc_status_missing_return_value:
                case e.rpc_status_invalid_object:
                  c = new DOMException(this.webrpcStatusCodeToName(a), this.webrpcStatusCodeToName(a));
                  break;
                case e.rpc_status_user_exception:
                  c = b && 0 < b.length ? new DOMException(b[0], this.webrpcStatusCodeToName(a)) : new DOMException(this.webrpcStatusCodeToName(a), this.webrpcStatusCodeToName(a));
                  break;
                case e.rpc_status_system_error:
                  if (b && 0 < b.length) {
                    c = Object.create(DOMException);
                    var d = {
                      value: null,
                      writable: !0,
                      enumerable: !1,
                      Configurable: !0
                    };
                    d.value = b[0].category;
                    Object.defineProperty(c, "name", d);
                    d.value = b[0].code;
                    Object.defineProperty(c, "code", d);
                    d.value = b[0].message;
                    Object.defineProperty(c, "message", d);
                  } else c = new DOMException(this.webrpcStatusCodeToName(a), this.webrpcStatusCodeToName(a));
              }
              return c;
            };
            a.prototype.onWSMessage = function (a) {
              var b = a.data,
                c;
              try {
                c = JSON.parse(b);
              } catch (q) {
                console.log("invalid JSON!!!");
                console.log(q);
                console.log(b);
                return;
              }
              if ("webrtc" == c.v) {
                v.logger.trace("onWSMessage: <<< " + r.WebrpcClassLibInfoUtil.composeClassInfoData(c) + " " + b);
                var d = c.hdr.proc.iid,
                  m = c.hdr.proc.methodid,
                  f = c.objref.oid;
                a = c.status;
                if (c.hdr.msg_type == n.WsJsonUtil.getMsgType(n.ws_msg_type_t.reply)) b = this.reqs.findIndex(function (a) {
                  return a.iid == d && a.oid == f && a.mid == m;
                }), 0 <= b ? 0 == a ? this.reqs.splice(b, 1).shift().resolve(c) : (c = this.parceWebrpcError(a, c.params), this.reqs.splice(b, 1).shift().reject(c)) : (v.logger.log("HDXMS didnt find this one. (reqs)"), v.logger.log(this.reqs));else if (c.hdr.msg_type == n.WsJsonUtil.getMsgType(n.ws_msg_type_t.event_req)) {
                  var u = c.func.id,
                    b = this.cbs.findIndex(function (a) {
                      return a.iid == d && a.oid == f && a.cbid == u >> 16;
                    });
                  0 <= b ? (0 == (u & 65535) ? this.cbs[b].resolve(c) : (c = this.parceWebrpcError(a, c.params), this.cbs[b].reject(c)), 1 == this.cbs[b].oneShot && this.cbs.splice(b, 1)) : (v.logger.log("HDXMS didnt find this one. (cbs)"), v.logger.log(this.cbs));
                } else v.logger.log("HDXMS Received bogus message: " + b + "'");
              } else if ("telemetry" == c.v) 0 == c.status && (a = c.hdr.command, 2 == (a & 2147483647) && (b = c.hdr.id, this.telemetry.onInitialized(b), v.logger.log("Telemetry init response received")));else if ("features" == c.v) {
                a = c.features;
                if ("feature-support" == c.command) for (v.logger.log("features capabilities received, features:" + a), this.vdafeatures_ = a, b = 0; b < a.length; b++) if (a[b] === r.FEATURE_vda_app_sharing) this.screenshare.onInitialized(!0);
                this.clientViewportMode_ = c.client_viewport_mode;
                v.logger.log("features client_viewport_mode value: " + this.clientViewportMode_);
              } else "appsharing" == c.v ? (a = c.status, 0 == a ? (a = c.hdr.command, b = c.hdr.id, (a & 2147483647) == p.sshare_cmd.GetSources ? (v.logger.log("appsharing GetSources response received"), this.screenshare.onGetSources(b, c.data)) : (a & 2147483647) == p.sshare_cmd.SetActive ? (v.logger.log("appsharing SetActive response received"), this.screenshare.onSetActive(b, c.data)) : (a & 2147483647) == p.sshare_cmd.TopologyChanged ? (v.logger.log("appsharing Window topology changed cmd received"), this.screenshare.onToplogyChanged()) : (v.logger.log("invalid command reply:" + a), this.screenshare.onError(b))) : (v.logger.log("invalid status reply:" + a), b = c.hdr.id, this.screenshare.onError(b))) : v.logger.log("HDXMS: Unknown protocol: " + b + "'");
            };
            a.prototype.clearReqs = function () {
              v.logger.log("clearReqs()");
              this.reqs.forEach(function (a, b) {
                a.reject();
              });
              this.reqs = [];
            };
            a.prototype.registerHandler = function (a, b, c) {
              a = new f(c.resolve.bind(c), c.reject.bind(c), a, b, c.id, c.oneShot, 0);
              this.cbs.push(a);
            };
            a.prototype.unregisterHandler = function (a, b, c) {
              var d = this.cbs.findIndex(function (d) {
                return d.iid == a && d.oid == b && d.cbid == c;
              });
              0 <= d ? this.cbs.splice(d, 1) : (v.logger.log("HDXMS Didnt find this callback in the list!"), console.log(this.cbs));
            };
            a.prototype.isRedirected = function () {
              return this.status === x.Redirected || this.status === x.Binding || this.status === x.Connecting;
            };
            a.prototype.isConnected = function () {
              return this.status == x.Redirected;
            };
            a.prototype.isPingActive = function () {
              return this.pingactive;
            };
            a.prototype.pingConnectionBegin = function (a) {
              v.logger.log("Started timer");
              this.pingactive = !0;
              var b = window.onVdiClientDisconnectedTimer;
              1 == a ? (v.logger.log("checking if we are connected..."), b()) : this.conntimer = setTimeout(function () {
                v.logger.log("checking if we are connected...");
                b();
              }, 15E3);
            };
            a.prototype.pingConnectionEnd = function () {
              this.pingactive = !1;
              clearTimeout(this.conntimer);
            };
            a.prototype.SendTelemetryData_Speaker = function (a) {
              this.telemetry.SendTelemetryData(g.tel_cmd.Data, g.tel_key_SpeakerDeviceUsed, a, 0);
            };
            a.prototype.registerStateChangeNotification = function (a) {
              this.stateChangeNotifcations.push(a);
            };
            a.prototype.unregisterStateChangeNotification = function (a) {
              this.stateChangeNotifcations = this.stateChangeNotifcations.filter(function (b) {
                return b != a;
              });
            };
            a.prototype.dispatchStateChangeNotifications = function () {
              this.stateChangeNotifcations.forEach(function (a) {
                a();
              });
            };
            a.prototype.vdabufferNoLimit = function () {
              for (var a = !1, b = 0, c = this.vdafeatures_; b < c.length; b++) if (c[b] === r.FEATURE_vda_service_no_buffer_limit) {
                a = !0;
                break;
              }
              return a;
            };
            Object.defineProperty(a.prototype, "clientViewportMode", {
              get: function () {
                return this.clientViewportMode_ || "unknown";
              },
              enumerable: !0,
              configurable: !0
            });
            return a;
          }();
          a.HdxMediaStream = b;
          var m = new b();
          a.getRedirector = function () {
            return m;
          };
        },
        985: function (b, a, c) {
          var d = this && this.__extends || function () {
              var a = function (b, c) {
                a = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (a, b) {
                  a.__proto__ = b;
                } || function (a, b) {
                  for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
                };
                return a(b, c);
              };
              return function (b, c) {
                function d() {
                  this.constructor = b;
                }
                a(b, c);
                b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
              };
            }(),
            e = this && this.__spreadArrays || function () {
              for (var a = 0, b = 0, c = arguments.length; b < c; b++) a += arguments[b].length;
              for (var a = Array(a), d = 0, b = 0; b < c; b++) for (var m = arguments[b], g = 0, n = m.length; g < n; g++, d++) a[d] = m[g];
              return a;
            };
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var r = c(658),
            n = c(550),
            g = c(851);
          b = function (a) {
            function b(c, d, m) {
              for (var g = [], f = 3; f < arguments.length; f++) g[f - 3] = arguments[f];
              return a.apply(this, e([c, n.class_id_t.RTCIceCandidate, d, m, null], g)) || this;
            }
            d(b, a);
            Object.defineProperty(b.prototype, "candidate", {
              get: function () {
                return this.candidate_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "sdpMid", {
              get: function () {
                return this.sdpMid_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "sdpMLineIndex", {
              get: function () {
                return this.sdpMLineIndex_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.syncBarrier = function () {
              var a = this;
              g.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("IceCandidate.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, n.method_id_RTCIceCandidate_t.candidate, ""), a.remoteInvoke(!1, n.method_id_RTCIceCandidate_t.sdpMid, ""), a.remoteInvoke(!1, n.method_id_RTCIceCandidate_t.sdpMLineIndex, 0)]);
                }).then(function (c) {
                  c = c.map(function (b) {
                    return a.param0(b);
                  });
                  a.candidate_ = c[0];
                  a.sdpMid_ = c[1];
                  a.sdpMLineIndex_ = c[2];
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier failed!");
                  c(b);
                });
              });
            };
            return b;
          }(r.ProxyObject);
          a.IceCandidate = b;
          b = function (a) {
            function b(c, d) {
              return a.call(this, c, n.class_id_t.RTCIceCandidatePair, d, r.ProxyMode.Remote) || this;
            }
            d(b, a);
            Object.defineProperty(b.prototype, "local", {
              get: function () {
                return this.local_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "remote", {
              get: function () {
                return this.remote_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.syncBarrier = function () {
              var a = this;
              g.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("IceCandidatePair.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, n.method_id_RTCIceCandidatePair_t.local, {}), a.remoteInvoke(!1, n.method_id_RTCIceCandidatePair_t.remote, {})]);
                }).then(function (c) {
                  c = c.map(function (b) {
                    return a.param0(b);
                  });
                  a.local_ = c[0];
                  a.remote_ = c[1];
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier failed!");
                  c(b);
                });
              });
            };
            return b;
          }(r.ProxyObject);
          a.IceCandidatePair = b;
        },
        851: function (b, a) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var c = function () {
            function a(b) {
              this.tracing = !1;
              this.mslogger_ = void 0;
              this.tag = b;
              this.enabled = !0;
            }
            a.prototype.setMSLogger = function (a) {
              this.mslogger_ = a;
            };
            a.prototype.log = function () {
              for (var a = [], b = 0; b < arguments.length; b++) a[b] = arguments[b];
              this.enabled && (void 0 != this.mslogger_ ? this.mslogger_.info(this.tag + " " + a) : console.log(this.tag + " " + a));
            };
            a.prototype.trace = function () {
              for (var a = [], b = 0; b < arguments.length; b++) a[b] = arguments[b];
              this.tracing && this.log.apply(this, a);
            };
            return a;
          }();
          a.Logger = c;
          a.logger = new c("[HdxWebRTC.js]");
          a.logger.enabled = !0;
        },
        360: function (b, a, c) {
          var d = this && this.__extends || function () {
              var a = function (b, c) {
                a = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (a, b) {
                  a.__proto__ = b;
                } || function (a, b) {
                  for (var l in b) b.hasOwnProperty(l) && (a[l] = b[l]);
                };
                return a(b, c);
              };
              return function (b, c) {
                function q() {
                  this.constructor = b;
                }
                a(b, c);
                b.prototype = null === c ? Object.create(c) : (q.prototype = c.prototype, new q());
              };
            }(),
            e = this && this.__awaiter || function (a, b, c, q) {
              function d(a) {
                return a instanceof c ? a : new c(function (b) {
                  b(a);
                });
              }
              return new (c || (c = Promise))(function (c, H) {
                function w(a) {
                  try {
                    m(q.next(a));
                  } catch (b) {
                    H(b);
                  }
                }
                function h(a) {
                  try {
                    m(q["throw"](a));
                  } catch (b) {
                    H(b);
                  }
                }
                function m(a) {
                  a.done ? c(a.value) : d(a.value).then(w, h);
                }
                m((q = q.apply(a, b || [])).next());
              });
            },
            r = this && this.__generator || function (a, b) {
              function c(a) {
                return function (b) {
                  return q([a, b]);
                };
              }
              function q(c) {
                if (w) throw new TypeError("Generator is already executing.");
                for (; d;) try {
                  if (w = 1, h && (m = c[0] & 2 ? h["return"] : c[0] ? h["throw"] || ((m = h["return"]) && m.call(h), 0) : h.next) && !(m = m.call(h, c[1])).done) return m;
                  if (h = 0, m) c = [c[0] & 2, m.value];
                  switch (c[0]) {
                    case 0:
                    case 1:
                      m = c;
                      break;
                    case 4:
                      return d.label++, {
                        value: c[1],
                        done: !1
                      };
                    case 5:
                      d.label++;
                      h = c[1];
                      c = [0];
                      continue;
                    case 7:
                      c = d.ops.pop();
                      d.trys.pop();
                      continue;
                    default:
                      if (!(m = d.trys, m = 0 < m.length && m[m.length - 1]) && (6 === c[0] || 2 === c[0])) {
                        d = 0;
                        continue;
                      }
                      if (3 === c[0] && (!m || c[1] > m[0] && c[1] < m[3])) d.label = c[1];else if (6 === c[0] && d.label < m[1]) d.label = m[1], m = c;else if (m && d.label < m[2]) d.label = m[2], d.ops.push(c);else {
                        m[2] && d.ops.pop();
                        d.trys.pop();
                        continue;
                      }
                  }
                  c = b.call(a, d);
                } catch (K) {
                  c = [6, K], h = 0;
                } finally {
                  w = m = 0;
                }
                if (c[0] & 5) throw c[1];
                return {
                  value: c[0] ? c[1] : void 0,
                  done: !0
                };
              }
              var d = {
                  label: 0,
                  sent: function () {
                    if (m[0] & 1) throw m[1];
                    return m[1];
                  },
                  trys: [],
                  ops: []
                },
                w,
                h,
                m,
                u;
              $jscomp.initSymbol();
              $jscomp.initSymbol();
              $jscomp.initSymbolIterator();
              return u = {
                next: c(0),
                "throw": c(1),
                "return": c(2)
              }, "function" === typeof Symbol && (u[Symbol.iterator] = function () {
                return this;
              }), u;
            },
            n = this && this.__spreadArrays || function () {
              for (var a = 0, b = 0, c = arguments.length; b < c; b++) a += arguments[b].length;
              for (var a = Array(a), q = 0, b = 0; b < c; b++) for (var d = arguments[b], w = 0, h = d.length; w < h; w++, q++) a[q] = d[w];
              return a;
            };
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var g = c(946),
            p = c(144),
            f = c(589),
            k = c(658),
            x = c(985),
            m = c(377),
            D = c(650),
            B = c(24),
            t = c(550),
            h = c(851),
            A = c(517),
            y = c(394),
            E = function (a) {
              function b(c, q, d) {
                c = a.call(this, c, t.class_id_t.RTCIceCandidateEvent, q, k.ProxyMode.Remote) || this;
                c.target = d;
                c.type = "icecandidate";
                return c;
              }
              d(b, a);
              Object.defineProperty(b.prototype, "candidate", {
                get: function () {
                  return this.candidate_;
                },
                enumerable: !0,
                configurable: !0
              });
              b.prototype.syncBarrier = function () {
                var a = this;
                h.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
                return new Promise(function (b, c) {
                  a.waitUntilConnected(a.user_friendly_id() + ".syncBarrier").then(function () {
                    return a.remoteInvoke(!1, t.method_id_RTCIceCandidateEvent_t.candidate, {
                      oid: 0
                    });
                  }).then(function (b) {
                    b = a.param0(b);
                    return !1 === b.is_null ? new x.IceCandidate(a, b.oid, k.ProxyMode.Remote).syncBarrier() : Promise.resolve(null);
                  }).then(function (c) {
                    h.logger.log(a.user_friendly_id() + ".onicecandidate: icecandidate available!");
                    a.candidate_ = c;
                    b(a);
                  })["catch"](function (b) {
                    b = a.logRemoteInvokeError(b, ".onicecandidate() failed!");
                    c(b);
                  });
                });
              };
              return b;
            }(k.ProxyObject);
          a.IceCandidateEvent = E;
          var u = function () {
              function a(b) {
                this.state_ = "new";
                this.candidates_ = [];
                this.pc_ = b;
              }
              a.prototype.pushState = function (a) {
                h.logger.log(this.pc_.user_friendly_id() + ".onicegatheringstatechange: new state is " + a);
                this.state_ = a;
                "gathering" == this.state_ ? (this.candidates_ = [], this.postUpdate()) : this.processRemaining();
              };
              a.prototype.addIceCandidate = function (a) {
                var b = this;
                this.candidates_.push(a);
                a.syncBarrier().then(function (a) {
                  h.logger.log(b.pc_.user_friendly_id() + ".onicecandidate: icecandidate available!");
                  return Promise.all([b.pc_.updateSdpDescription(!0), Promise.resolve(a)]);
                }).then(function (a) {
                  b.postIceCandidate(a[1]);
                });
              };
              a.prototype.postIceCandidate = function (a) {
                h.logger.log(this.pc_.user_friendly_id() + ".onicecandidate: posting ice candidate now!");
                if (null != this.pc_.onicecandidate) this.pc_.onicecandidate(a);else h.logger.log(this.pc_.user_friendly_id() + "onicecandidate is NULL!!!");
                this.candidates_.shift();
                this.processRemaining();
              };
              a.prototype.postUpdate = function () {
                h.logger.log(this.pc_.user_friendly_id() + ".onicegatheringstatechange: posting event now!");
                var a = new z("onicegatheringstatechange", this.pc_);
                this.pc_.onicegatheringstatechange(a);
              };
              a.prototype.processRemaining = function () {
                0 == this.candidates_.length && "complete" == this.state_ ? (this.pc_.onicecandidate({
                  candidate: null,
                  target: this
                }), this.postUpdate()) : h.logger.log(this.pc_.user_friendly_id() + ".onicecandidate: candidates remaining=[" + this.candidates_.map(function (a) {
                  return a.object_id();
                }) + "], state=" + this.state_);
              };
              return a;
            }(),
            q = function () {
              return function (a, b) {
                this.sdp = b;
                this.type = a;
              };
            }();
          a.SessionDescriptionInit = q;
          var w = function (a) {
            function b(c, q, d) {
              for (var w = [], h = 3; h < arguments.length; h++) w[h - 3] = arguments[h];
              return a.apply(this, n([c, t.class_id_t.RTCSessionDescription, q, d, null], w)) || this;
            }
            d(b, a);
            b.prototype.toJSON = function () {
              return {
                type: this.type_,
                sdp: this.sdp_
              };
            };
            Object.defineProperty(b.prototype, "sdp", {
              get: function () {
                return this.sdp_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "type", {
              get: function () {
                return this.type_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.syncBarrier = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected(a.user_friendly_id() + ".syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, t.method_id_RTCSessionDescription_t.type, 0), a.remoteInvoke(!1, t.method_id_RTCSessionDescription_t.sdp, "")]);
                }).then(function (c) {
                  a.type_ = a.convertType(a.param0(c[0]));
                  a.sdp_ = a.param0(c[1]);
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  c(b);
                });
              });
            };
            b.prototype.convertType = function (a) {
              return 0 == a ? "offer" : 1 == a ? "pranswer" : 2 == a ? "answer" : "rollback";
            };
            b.convertC2H = function (a) {
              return "offer" == a ? 0 : "pranswer" == a ? 1 : "answer" == a ? 2 : 3;
            };
            return b;
          }(k.ProxyObject);
          a.SessionDescription = w;
          var z = function () {
              return function (a, b) {
                this.type = a;
                this.target = b;
              };
            }(),
            C = function () {
              return function () {};
            }(),
            F = function () {
              function a(b, c) {
                this.local = b;
                this.remote = c;
              }
              Object.defineProperty(a.prototype, "active", {
                get: function () {
                  var a = !1;
                  if (1 == this.local || 1 == this.remote) a = !0;
                  return a;
                },
                enumerable: !0,
                configurable: !0
              });
              return a;
            }();
          b = function (a) {
            function b(c) {
              var q = a.call(this, null, t.class_id_t.RTCPeerConnection, 0, k.ProxyMode.Local, null, void 0 != c ? c : {}, {}) || this;
              q.timeerstarted_ = !1;
              q.firsttimeremoteoffer_ = !1;
              q.firststable_ = !1;
              q.firsttimelocaloffer_ = !1;
              q.audiocall_ = new F(!1, !1);
              q.videocall_ = new F(!1, !1);
              q.screensharingcall_ = new F(!1, !1);
              q.conferencecall_ = !1;
              q.incomingcall_ = !1;
              q.outgoingcall_ = !1;
              c && c.sdpSemantics && (q.sdpSemantics_ = c.sdpSemantics);
              h.logger.log(q.user_friendly_id() + ".constructor sdpSemantics=" + q.sdpSemantics_);
              if (!t.BUILD_TYPE_SDK && q.isUnified() && !g.getRedirector().getFeatureValue(t.FEATURE_ms_teams_webrtc_1dot0)) throw new DOMException("CWA client does not support unified sdpSemantic", "createPeerConnection");
              q.pendingtransceiver_ = !1;
              q.deferredOfferAnswers = [];
              q.localStreams = [];
              q.remoteStreams = [];
              q.onaddstream_ = null;
              q.signalingState_ = "stable";
              q.iceConnectionState_ = "new";
              q.iceGatheringState_ = "new";
              q.iceQ_ = new u(q);
              q.receivers_ = [];
              q.senders_ = [];
              q.transceivers_ = [];
              q.registerStateChangeNotification(q.onStateChange);
              q.localdatachannel_ = null;
              q.remotedatachannel_ = null;
              return q;
            }
            d(b, a);
            b.prototype.dumpSdp = function (a) {
              h.logger.log(this.user_friendly_id() + ".dumpSdp");
              a && (h.logger.log(this.user_friendly_id() + "  -- type: " + a.type), h.logger.log(this.user_friendly_id() + "  -- sdp: " + a.sdp));
            };
            Object.defineProperty(b.prototype, "localDescription", {
              get: function () {
                h.logger.log(this.user_friendly_id() + ".get_localDescription() called.");
                return this.localDescription_;
              },
              set: function (a) {
                h.logger.log(this.user_friendly_id() + ".set_localDescription() called.");
                this.localDescription_ = a;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "remoteDescription", {
              get: function () {
                h.logger.log(this.user_friendly_id() + ".get_remoteDescription() called.");
                return this.remoteDescription_;
              },
              set: function (a) {
                h.logger.log(this.user_friendly_id() + ".get_remoteDescription() called.");
                this.remoteDescription_ = a;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.isUnified = function () {
              return "unified" == this.sdpSemantics_ || "unified-plan" == this.sdpSemantics_;
            };
            b.prototype.onStateChange = function () {
              var a = new z("iceconnectionstatechange", this);
              if (this.oniceconnectionstatechange_) this.oniceconnectionstatechange_(a);
            };
            b.prototype.addIceCandidate = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".addIceCandidate() called.");
              this.waitUntilConnected(this.user_friendly_id() + ".addIceCandidate").then(function () {
                var c = {
                  candidate: a.candidate,
                  sdpMid: a.sdpMid,
                  sdpMLineIndex: a.sdpMLineIndex
                };
                if (void 0 == c.candidate || null == c.candidate) c.candidate = "";
                void 0 == c.sdpMid && (c.sdpMid = null);
                void 0 == c.sdpMLineIndex && (c.sdpMLineIndex = null);
                return new x.IceCandidate(b, 0, k.ProxyMode.Local, c).syncBarrier();
              }).then(function (a) {
                return b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.addIceCandidate, {
                  oid: a.object_id()
                }, {});
              }).then(function () {
                h.logger.log(b.user_friendly_id() + ".addIceCandidate() success.");
                return b.updateSdpDescription(!1);
              }).then(function () {
                h.logger.log(b.user_friendly_id() + ".addIceCandidate() - sync remote sdp success.");
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, ".addIceCandidate() failed!");
              });
            };
            Object.defineProperty(b.prototype, "onicecandidate", {
              get: function () {
                return this.onicecandidate_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onicecandidate() called.");
                this.onicecandidate_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onicecandidate").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onicecandidate);
                  c.then(function (a) {
                    h.logger.log(b.user_friendly_id() + ".onicecandidate callback received!!!");
                    a = new E(b, b.param0(a).oid, b);
                    null != b.iceQ_ && b.iceQ_.addIceCandidate(a);
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onicecandidate, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onicecandidate() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.convertIceConnectionState = function (a) {
              return 0 == a ? "new" : 1 == a ? "checking" : 2 == a ? "connected" : 3 == a ? "completed" : 4 == a ? "failed" : 5 == a ? "disconnected" : "closed";
            };
            b.prototype.convertConnectionState = function (a) {
              if (0 != a) {
                if (1 == a) return "connecting";
                if (2 == a) return "connected";
                if (3 == a) return "disconnected";
                if (4 == a) return "failed";
                if (5 == a) return "closed";
              }
              return "new";
            };
            Object.defineProperty(b.prototype, "onconnectionstatechange", {
              get: function () {
                return this.onconnectionstatechange_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onconnectionstatechange() called.");
                this.onconnectionstatechange_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onconnectionstatechange").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onconnectionstatechange);
                  c.then(function (a) {
                    h.logger.log(b.user_friendly_id() + ".onconnectionstatechange(): success callback received!!!");
                    b.connectionState_ = b.convertConnectionState(b.param0(a));
                    h.logger.log(b.user_friendly_id() + " connectionState=:" + b.connectionState_);
                    a = new z("connectionstatechange", b);
                    b.onconnectionstatechange_(a);
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onconnectionstatechange, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onconnectionstatechange() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.get_connectionState = function () {
              h.logger.log(this.user_friendly_id() + ".get_connectionState() called, value = " + this.connectionState_);
              return this.isRedirected() ? this.connectionState_ : "failed";
            };
            Object.defineProperty(b.prototype, "oniceconnectionstatechange", {
              get: function () {
                return this.oniceconnectionstatechange_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_oniceconnectionstatechange() called.");
                this.oniceconnectionstatechange_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".oniceconnectionstatechange").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.oniceconnectionstatechange);
                  c.then(function (a) {
                    h.logger.log(b.user_friendly_id() + ".oniceconnectionstatechange(): success callback received!!!");
                    b.iceConnectionState_ = b.convertIceConnectionState(b.param0(a));
                    a = new z("iceconnectionstatechange", b);
                    b.oniceconnectionstatechange_(a);
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.oniceconnectionstatechange, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_oniceconnectionstatechange() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "iceConnectionState", {
              get: function () {
                h.logger.log(this.user_friendly_id() + ".get_iceConnectionState() called, value = " + this.iceConnectionState_);
                return this.isRedirected() ? this.iceConnectionState_ : "failed";
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.convertIceGatheringState = function (a) {
              return 0 == a ? "new" : 1 == a ? "gathering" : "complete";
            };
            Object.defineProperty(b.prototype, "onicegatheringstatechange", {
              get: function () {
                return this.onicegatheringstatechange_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onicegatheringstatechange() called.");
                this.onicegatheringstatechange_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onicegatheringstatechange").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onicegatheringstatechange);
                  c.then(function (a) {
                    h.logger.log(b.user_friendly_id() + ".onicegatheringstatechange(): callback received!!!");
                    b.iceGatheringState_ = b.convertIceGatheringState(b.param0(a));
                    null != b.iceQ_ && b.iceQ_.pushState(b.iceGatheringState_);
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onicegatheringstatechange, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onicegatheringstatechange() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "iceGatheringState", {
              get: function () {
                h.logger.log(this.user_friendly_id() + ".get_iceGatheringState() called, value = " + this.iceGatheringState_);
                return this.iceGatheringState_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.convertSignalState = function (a) {
              return 0 == a ? "stable" : 1 == a ? "have-local-offer" : 2 == a ? "have-local-pranswer" : 3 == a ? "have-remote-offer" : 4 == a ? "have-remote-pranswer" : "closed";
            };
            b.prototype.TelemtryReadings_ = function () {
              "have-local-offer" == this.signalingState_ && 0 == this.firsttimelocaloffer_ && 0 == this.firsttimeremoteoffer_ && (this.outgoingcallstart_ = new Date().getTime(), 0 == this.outgoingcall_ && (this.SendTelemetryData(y.tel_key_PerfCallState, y.tel_CallState.active, 1), this.SendTelemetryData(y.tel_key_PerfCallDirection, y.tel_CallDirection.outgoing, 1), this.outgoingcall_ = !0), this.firsttimelocaloffer_ = !0);
              "have-remote-offer" == this.signalingState_ && 0 == this.firsttimeremoteoffer_ && 0 == this.firsttimelocaloffer_ && (this.incomingcallstart_ = new Date().getTime(), 0 == this.incomingcall_ && (this.SendTelemetryData(y.tel_key_PerfCallState, y.tel_CallState.active, 1), this.SendTelemetryData(y.tel_key_PerfCallDirection, y.tel_CallDirection.incoming, 1), this.incomingcall_ = !0), this.firsttimeremoteoffer_ = !0);
              "stable" == this.signalingState_ && 0 == this.firststable_ && (this.callstartTime_ = new Date().getTime(), this.firststable_ = this.timeerstarted_ = !0);
              if ("stable" == this.signalingState_) {
                for (var a = 0, b = this.localStreams; a < b.length; a++) {
                  var c = b[a];
                  1 <= c.getAudioTracks().length && 0 == this.audiocall_.local && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.audio, 1), this.audiocall_.local = !0);
                  c = c.getVideoTracks();
                  if (1 <= c.length) for (var l = 0, q = c; l < q.length; l++) c = q[l], 1 == c.getSettings().deviceId.includes("display") ? 0 == this.screensharingcall_.local && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.dshare, 1), this.screensharingcall_.local = !0) : 0 == this.videocall_.local && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.video, 1), this.videocall_.local = !0);
                }
                a = 0;
                for (b = this.remoteStreams; a < b.length; a++) if (c = b[a], 1 <= c.getAudioTracks().length && 0 == this.audiocall_.remote && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.audio, 1), this.audiocall_.remote = !0), l = c.getVideoTracks(), 1 <= l.length) for (c = 0; c < l.length; c++) 1 == l[c].id.includes("applicationsharingVideo") ? 0 == this.screensharingcall_.remote && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.dshare, 1), this.screensharingcall_.remote = !0) : 0 == this.videocall_.remote && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.video, 1), this.videocall_.remote = !0);
                2 < this.getReceivers().length && 0 == this.conferencecall_ && (this.SendTelemetryData(y.tel_key_PerfCallType, y.tel_CallType.multi, 1), this.conferencecall_ = !0);
              }
            };
            Object.defineProperty(b.prototype, "onsignalingstatechange", {
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onsignalingstatechange() called.");
                this.onsignalingstatechange_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onsignalingstatechanged").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onsignalingstatechange);
                  c.then(function (a) {
                    h.logger.log(b.user_friendly_id() + ".onsignalingstatechange(): callback received!!!");
                    b.signalingState_ = b.convertSignalState(b.param0(a));
                    a = new z("onsignalingstatechange", b);
                    b.onsignalingstatechange_(a);
                    b.TelemtryReadings_();
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onsignalingstatechange, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onsignalingstatechange() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onsignalingstatechanged", {
              get: function () {
                return this.onsignalingstatechange_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "ontrack", {
              get: function () {
                return this.ontrack_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_ontrack() called.");
                this.ontrack_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".ontrack").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.ontrack);
                  c.then(function (a) {
                    return e(b, void 0, void 0, function () {
                      var b,
                        c,
                        l,
                        q,
                        d,
                        w,
                        K,
                        H,
                        u,
                        t,
                        z,
                        g = this;
                      return r(this, function (n) {
                        h.logger.log(this.user_friendly_id() + ".ontrack(): callback received!!!");
                        b = new C();
                        c = [];
                        l = this.param0(a);
                        void 0 != l.track && !1 === l.track.is_null && (h.logger.log(this.user_friendly_id() + " adding a RemoteMediaTrack with oid:" + l.track.oid), q = new p.RemoteMediaTrack(this, l.track.oid), c.push(q.syncBarrier()));
                        b.track = q;
                        void 0 != l.receiver && !1 === l.receiver.is_null && (d = this.receivers_.find(function (a) {
                          return a.object_id() === l.receiver.oid;
                        }), void 0 === d && (h.logger.log(this.user_friendly_id() + " adding a RtpReceiver with oid:" + l.receiver.oid), d = new f.RtpReceiver(this, l.receiver.oid, k.ProxyMode.Remote, this.isUnified(), q)), c.push(d.syncBarrier()));
                        b.receiver = d;
                        D.RemoteSession.isFeatureWebrtc1dot0Supported() && void 0 != l.transceiver && !1 === l.transceiver.is_null && (w = this.transceivers_.find(function (a) {
                          return a.object_id() === l.transceiver.oid;
                        }), void 0 === w && (h.logger.log(this.user_friendly_id() + " adding a RtpTransceiver with oid:" + l.transceiver.oid), w = new m.RtpTransceiver(this, l.transceiver.oid, k.ProxyMode.Remote, this.isUnified(), "inactive", d), this.transceivers_.push(w)), c.push(w.syncBarrier()));
                        b.transceiver = w;
                        b.streams = [];
                        if (void 0 != l.streams) for (K = function (a) {
                          var l = H.remoteStreams.find(function (b) {
                            return !1 === a.is_null && b.object_id() === a.oid;
                          });
                          void 0 === l && (h.logger.log(H.user_friendly_id() + " adding a RemoteStream with oid:" + a.oid), l = new p.RemoteStream(H, a.oid, k.ProxyMode.Remote), H.remoteStreams.push(l));
                          c.push(l.syncBarrier());
                          b.streams.push(l);
                        }, H = this, u = 0, t = l.streams; u < t.length; u++) z = t[u], K(z);
                        h.logger.log(this.user_friendly_id() + ".ontrack(): .prop.syncBarrier start");
                        Promise.all(c).then(function () {
                          h.logger.log(g.user_friendly_id() + ".ontrack(): notified!!! with evt: " + b);
                          for (var a = 0, c = b.streams; a < c.length; a++) c[a].toggleAudio(!1);
                          g.ontrack_(b);
                        })["catch"](function (a) {
                          g.logRemoteInvokeError(a, ".ontrack(): .prop.syncBarrier failed.");
                        });
                        return [2];
                      });
                    });
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.ontrack, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_ontrack(): failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "signalingState", {
              get: function () {
                h.logger.log(this.user_friendly_id() + ".get_signalingState() called, value = " + this.signalingState_);
                return this.signalingState_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onnegotiationneeded", {
              get: function () {
                return this.onnegotiationneeded_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onnegotiationneeded() called.");
                this.onnegotiationneeded_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onnegotiationneeded").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onnegotiationneeded);
                  c.then(function () {
                    h.logger.log(b.user_friendly_id() + ".onnegotiationneeded(): callback received!!!");
                    var a = new z("negotiationneeded", b);
                    b.onnegotiationneeded_(a);
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onnegotiationneeded, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onnegotiationneeded(): failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.dumpConstraints = function (a) {
              h.logger.log(this.user_friendly_id() + "constraints: " + a);
              void 0 !== a && 0 !== Object.keys(a).length || h.logger.log(this.user_friendly_id() + "constraints either undefined or empty!");
              a && (h.logger.log(this.user_friendly_id() + "  -- video: " + a.offerToReceiveVideo), h.logger.log(this.user_friendly_id() + "  -- audio: " + a.offerToReceiveAudio), h.logger.log(this.user_friendly_id() + "  -- iceRestart: " + a.iceRestart), h.logger.log(this.user_friendly_id() + "  -- voiceActivityDetection: " + a.voiceActivityDetection));
            };
            b.prototype.fix_constraints = function (a) {
              this.dumpConstraints(a);
              var b = {};
              this.isUnified() || (b = {
                audio: !0,
                video: !0
              });
              a && (void 0 !== a.video && (b.video = a.offerToReceiveVideo), void 0 !== a.audio && (b.audio = a.offerToReceiveAudio), void 0 !== a.iceRestart && (b.iceRestart = a.iceRestart), void 0 !== a.voiceActivityDetection && (b.voiceActivityDetection = a.voiceActivityDetection));
              return b;
            };
            b.prototype.createOffer = function (a, b, c) {
              h.logger.log(this.user_friendly_id() + ".createOffer() called.", JSON.stringify(a));
              return this.isUnified() ? void 0 == a ? this.createOffer_v2() : a ? this.createOffer_v2(a) : this.createOffer_v1(a, b, c) : this.createOffer_v1(a, b, c);
            };
            b.prototype.createOffer_v2 = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".createOffer_v2() called.", JSON.stringify(a));
              return new Promise(function (c, l) {
                b.createOffer_v1(function (a) {
                  h.logger.log(b.user_friendly_id() + ".createOffer_v2(): got sdp!!!");
                  a = new q(a.type, a.sdp);
                  c(a);
                }, function (a) {
                  void 0 != a && (a = b.logRemoteInvokeError(a, ".createOffer_v2() failed."), l(a));
                }, a);
              });
            };
            b.prototype.createOffer_v1 = function (a, b, c) {
              var l = this;
              h.logger.log(this.user_friendly_id() + ".createOffer_v1().", JSON.stringify(c));
              var q = [this.waitUntilConnected(this.user_friendly_id() + ".createOffer_v1"), this.waitTransceiverReady(this.user_friendly_id() + ".createOffer_v1")];
              Promise.all(q).then(function () {
                var a = l.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.createOffer);
                l.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.createOffer, a.success, a.fail, l.fix_constraints(c));
                return a.prom();
              }).then(function (a) {
                h.logger.log(l.user_friendly_id() + ".createOffer_v1(): success callback received!!!");
                return new w(l, l.param0(a).oid, k.ProxyMode.Remote).syncBarrier();
              }).then(function (b) {
                a && a(b);
              })["catch"](function (a) {
                void 0 != a && (a = l.logRemoteInvokeError(a, ".createOffer_v1() failed."), b && b(a));
              });
            };
            b.prototype.createAnswer = function (a, b, c) {
              h.logger.log(this.user_friendly_id() + ".createAnswer() called.", JSON.stringify(a));
              return this.isUnified() ? void 0 == a ? this.createAnswer_v2() : a ? this.createAnswer_v2(a) : this.createAnswer_v1(a, b, c) : this.createAnswer_v1(a, b, c);
            };
            b.prototype.createAnswer_v2 = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".createAnswer_v2() called.", JSON.stringify(a));
              return new Promise(function (c, l) {
                b.createAnswer_v1(function (a) {
                  h.logger.log(b.user_friendly_id() + ".createAnswer_v2(): got sdp!!!");
                  a = new q(a.type, a.sdp);
                  c(a);
                }, function (a) {
                  void 0 != a && (a = b.logRemoteInvokeError(a, ".createAnswer_v2() failed."), l(a));
                }, a);
              });
            };
            b.prototype.createAnswer_v1 = function (a, b, c) {
              var l = this;
              h.logger.log(this.user_friendly_id() + ".createAnswer_v1() called.", JSON.stringify(c));
              var q = [this.waitUntilConnected(this.user_friendly_id() + ".createAnswer_v1"), this.waitTransceiverReady(this.user_friendly_id() + ".createAnswer_v1")];
              Promise.all(q).then(function () {
                var a = l.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.createAnswer);
                l.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.createAnswer, a.success, a.fail, l.fix_constraints(c), {});
                return a.prom();
              }).then(function (a) {
                h.logger.log(l.user_friendly_id() + ".createAnswer_v1(): success callback received!!!");
                return new w(l, l.param0(a).oid, k.ProxyMode.Remote).syncBarrier();
              }).then(function (b) {
                a && a(b);
              })["catch"](function (a) {
                a = l.logRemoteInvokeError(a, ".createAnswer_v1() failed.");
                b && b(a.message);
              });
            };
            b.prototype.updateSdpDescription = function (a) {
              return e(this, void 0, void 0, function () {
                var b,
                  c,
                  l,
                  q = this;
                return r(this, function (d) {
                  switch (d.label) {
                    case 0:
                      return h.logger.log(this.user_friendly_id() + ".updateSdpDescription() called."), 1 != a ? [3, 2] : [4, this.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.localDescription, {
                        oid: this.object_id()
                      })];
                    case 1:
                      return b = d.sent(), [3, 4];
                    case 2:
                      return [4, this.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.remoteDescription, {
                        oid: this.object_id()
                      })];
                    case 3:
                      b = d.sent(), d.label = 4;
                    case 4:
                      return c = new w(this, this.param0(b).oid, k.ProxyMode.Remote), [4, c.syncBarrier()["catch"](function (a) {
                        q.logRemoteInvokeError(a, "sdp.syncBarrier() failed!");
                        return null;
                      })];
                    case 5:
                      return l = d.sent(), 1 == a ? this.localDescription_ = l : this.remoteDescription_ = l, [2];
                  }
                });
              });
            };
            b.prototype.setLocalDescription = function (a, b, c) {
              h.logger.log(this.user_friendly_id() + ".setLocalDescription() called.", JSON.stringify(a));
              if (a instanceof q) return this.setLocalDescription_v2(a);
              if (a instanceof RTCSessionDescription && b) return this.setLocalDescription_v1(a, b, c);
              b = void 0;
              a ? b = new q(a.type, a.sdp) : (h.logger.log(this.user_friendly_id() + ".setLocalDescription() empty param1, setting sdp type to rollback"), a = void 0, a = "have-remote-offer" == this.signalingState_ ? "answer" : "have-local-pranswer" == this.signalingState_ || "have-remote-pranswer" == this.signalingState_ ? "pranswer" : "offer", b = new q(a, ""));
              return this.setLocalDescription_v2(b);
            };
            b.prototype.setLocalDescription_v2 = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".setLocalDescription_v2() called.", JSON.stringify(a));
              return new Promise(function (c, l) {
                b.waitUntilConnected(b.user_friendly_id() + ".setLocalDescription_v2").then(function () {
                  return new w(b, 0, k.ProxyMode.Local, {
                    type: w.convertC2H(a.type),
                    sdp: a.sdp
                  }).syncBarrier();
                }).then(function (q) {
                  var d = b.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.setLocalDescription_v2),
                    m = {
                      type: w.convertC2H(a.type),
                      sdp: a.sdp
                    };
                  b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.setLocalDescription_v2, m, d.success, d.fail);
                  d.prom().then(function () {
                    h.logger.log(b.user_friendly_id() + ".setLocalDescription_v2(): success callback received!!!");
                    b.localDescription_ = q;
                    h.logger.log(b.user_friendly_id() + ".setLocalDescription_v2(): updated localDescription_");
                    b.isUnified();
                    Promise.all([]).then(function () {
                      h.logger.log(b.user_friendly_id() + ".setLocalDescription_v2() success.");
                      c();
                    })["catch"](function (a) {
                      a = b.logRemoteInvokeError(a, ".prop.setLocalDescription_v2() failed!");
                      l(a);
                    });
                  })["catch"](function (a) {
                    a = b.logRemoteInvokeError(a, "setLocalDescription_v2() error callback received!");
                    l(a);
                  });
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".setLocalDescription_v2() failed.");
                  l(a);
                });
              });
            };
            b.prototype.setLocalDescription_v1 = function (a, b, c) {
              var l = this;
              h.logger.log(this.user_friendly_id() + ".setLocalDescription_v1() called.");
              this.waitUntilConnected(this.user_friendly_id() + ".setLocalDescription_v1").then(function () {
                return new w(l, 0, k.ProxyMode.Local, {
                  type: w.convertC2H(a.type),
                  sdp: a.sdp
                }).syncBarrier();
              }).then(function (a) {
                var q = l.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.setLocalDescription);
                l.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.setLocalDescription, {
                  oid: a.object_id()
                }, q.success, q.fail);
                q.prom().then(function () {
                  h.logger.log(l.user_friendly_id() + ".setLocalDescription_v1(): success callback received!!!");
                  l.localDescription_ = a;
                  h.logger.log(l.user_friendly_id() + ".setLocalDescription_v1(): updated localDescription_");
                  l.isUnified();
                  Promise.all([]).then(function () {
                    h.logger.log(l.user_friendly_id() + ".setLocalDescription_v1() success.");
                    b && b();
                  })["catch"](function (a) {
                    a = l.logRemoteInvokeError(a, ".prop.setLocalDescription_v1() failed.");
                    c && c(a.message);
                  });
                })["catch"](function (a) {
                  a = l.logRemoteInvokeError(a, ".setLocalDescription_v1() error callback received.");
                  c && c(a.message);
                });
              })["catch"](function (a) {
                a = l.logRemoteInvokeError(a, ".setLocalDescription_v1() failed.");
                c && c(a.message);
              });
            };
            b.prototype.setRemoteDescription = function (a, b, c) {
              h.logger.log(this.user_friendly_id() + ".setRemoteDescription() called.", JSON.stringify(a));
              if (a instanceof q) return this.setRemoteDescription_v2(a);
              if (a instanceof RTCSessionDescription && b) return this.setRemoteDescription_v1(a, b, c);
              b = void 0;
              a ? b = new q(a.type, a.sdp) : (h.logger.log(this.user_friendly_id() + ".setRemoteDescription() empty param1, setting sdp type to rollback"), a = void 0, a = "have-remote-offer" == this.signalingState_ ? "answer" : "have-local-pranswer" == this.signalingState_ || "have-remote-pranswer" == this.signalingState_ ? "pranswer" : "offer", b = new q(a, ""));
              return this.setRemoteDescription_v2(b);
            };
            b.prototype.setRemoteDescription_v2 = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".setRemoteDescription_v2() called.", JSON.stringify(a));
              return new Promise(function (c, l) {
                b.waitUntilConnected(b.user_friendly_id() + ".setRemoteDescription_v2").then(function () {
                  return new w(b, 0, k.ProxyMode.Local, {
                    type: w.convertC2H(a.type),
                    sdp: a.sdp
                  }).syncBarrier();
                }).then(function (q) {
                  var d = b.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.setRemoteDescription_v2),
                    m = {
                      type: w.convertC2H(a.type),
                      sdp: a.sdp
                    };
                  b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.setRemoteDescription_v2, m, d.success, d.fail);
                  d.prom().then(function () {
                    h.logger.log(b.user_friendly_id() + ".setRemoteDescription_v2(): success callback received!!!");
                    b.remoteDescription_ = q;
                    h.logger.log(b.user_friendly_id() + ".setRemoteDescription_v2(): updated remoteDescription_");
                    var a = [];
                    b.isUnified() ? a.push(b.getTransceiversAsync()) : a.push(b.getSendersAsync());
                    Promise.all(a).then(function () {
                      h.logger.log(b.user_friendly_id() + ".setRemoteDescription_v2(): success.");
                      c();
                    })["catch"](function (a) {
                      a = b.logRemoteInvokeError(a, ".prop.setRemoteDescription_v2() failed.");
                      l(a);
                    });
                  })["catch"](function (a) {
                    a = b.logRemoteInvokeError(a, ".setRemoteDescription_v2() error callback received.");
                    l(a);
                  });
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".setRemoteDescription_v2() failed.");
                  l(a);
                });
              });
            };
            b.prototype.setRemoteDescription_v1 = function (a, b, c) {
              var l = this;
              h.logger.log(this.user_friendly_id() + ".setRemoteDescription_v1() called.");
              this.waitUntilConnected(this.user_friendly_id() + ".setRemoteDescription_v1").then(function () {
                return new w(l, 0, k.ProxyMode.Local, {
                  type: w.convertC2H(a.type),
                  sdp: a.sdp
                }).syncBarrier();
              }).then(function (a) {
                var q = l.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.setRemoteDescription);
                l.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.setRemoteDescription, {
                  oid: a.object_id()
                }, q.success, q.fail);
                q.prom().then(function () {
                  h.logger.log(l.user_friendly_id() + ".setRemoteDescription_v1(): success callback received!!!");
                  l.remoteDescription_ = a;
                  h.logger.log(l.user_friendly_id() + ".setRemoteDescription_v1(): updated remoteDescription_");
                  var q = [];
                  l.isUnified() ? q.push(l.getTransceiversAsync()) : q.push(l.getSendersAsync());
                  Promise.all(q).then(function () {
                    h.logger.log(l.user_friendly_id() + ".setRemoteDescription_v1(): success.");
                    b && b();
                  })["catch"](function (a) {
                    a = l.logRemoteInvokeError(a, ".prop.setRemoteDescription_v1() failed.");
                    c && c(a.message);
                  });
                });
              })["catch"](function (a) {
                a = l.logRemoteInvokeError(a, ".setRemoteDescription_v1() failed.");
                c && c(a.message);
              });
            };
            b.prototype.getLocalStreams = function () {
              h.logger.log("PeerConnection.getLocalStreams() called. [oid=" + this.object_id() + "]");
              for (var a = 0, b = this.localStreams; a < b.length; a++) h.logger.log(JSON.stringify(b[a]));
              return this.localStreams;
            };
            b.prototype.getRemoteStreams = function () {
              h.logger.log(this.user_friendly_id() + ".getRemoteStreams() called.");
              for (var a = 0, b = this.remoteStreams; a < b.length; a++) h.logger.log(JSON.stringify(b[a]));
              return this.remoteStreams;
            };
            b.prototype.addTrack = function (a, b) {
              var c = this;
              h.logger.log(this.user_friendly_id() + ".addTrack() called: " + JSON.stringify(b));
              var l = [];
              if (b instanceof p.RemoteStream) l.push(b.id), this.localStreams.push(b);else for (var q = 0; q < b.length; q++) l.push(b[q].id), this.localStreams.push(b[q]);
              var d = new f.RtpSender(this, 0, k.ProxyMode.Pseudo, this.isUnified());
              this.senders_.push(d);
              this.waitUntilConnected(this.user_friendly_id() + ".addTrack").then(function () {
                return c.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.addTrack, {
                  oid: a.object_id()
                }, l);
              }).then(function (a) {
                h.logger.log(c.user_friendly_id() + ".addTrack() success with oid: " + c.param0(a).oid);
                d.bind(c, c.param0(a).oid);
                d.syncBarrier().then(function () {
                  h.logger.log(c.user_friendly_id() + "sender.syncBarrier(): success");
                  c.isUnified() && c.getTransceiversAsync();
                })["catch"](function (a) {
                  c.logRemoteInvokeError(a, "sender.syncBarrier() failed!");
                });
              })["catch"](function (a) {
                c.logRemoteInvokeError(a, "addTrack() failed!");
              });
              h.logger.log(this.user_friendly_id() + ".addTrack() returning: " + d);
              return d;
            };
            b.prototype.removeTrack = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".removeTrack() called.");
              for (var c = 0; c < this.senders_.length; c++) this.senders_[c] == a && this.senders_.splice(c, 1);
              this.waitUntilConnected(this.user_friendly_id() + ".removeTrack").then(function () {
                return b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.removeTrack, {
                  oid: a.object_id()
                });
              }).then(function () {
                h.logger.log(b.user_friendly_id() + ".removeTrack() success.");
                b.isUnified() && b.getTransceiversAsync();
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, "removeTrack() failed!");
              });
            };
            b.prototype.addStream = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".addStream() called: " + JSON.stringify(a));
              this.localStreams.push(a);
              this.waitUntilConnected(this.user_friendly_id() + ".addStream").then(function () {
                return b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.addStream, {
                  oid: a.object_id()
                }, {});
              }).then(function () {
                h.logger.log(b.user_friendly_id() + ".addStream() success.");
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, "addStream() failed.");
              });
            };
            b.prototype.removeStream = function (a) {
              var b = this;
              h.logger.log(this.user_friendly_id() + ".removeStream() called: " + JSON.stringify(a));
              for (var c = 0; c < this.localStreams.length; c++) this.localStreams[c] == a && this.localStreams.splice(c, 1);
              this.waitUntilConnected(this.user_friendly_id() + ".removeStream").then(function () {
                return b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.removeStream, {
                  oid: a.object_id()
                });
              }).then(function () {
                h.logger.log(b.user_friendly_id() + ".removeStream() success.");
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, "removeStream() failed.");
              });
            };
            Object.defineProperty(b.prototype, "onaddstream", {
              get: function () {
                return this.onaddstream_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onaddstream() called.");
                this.onaddstream_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onaddstream").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onaddstream);
                  c.then(function (a) {
                    new p.RemoteStreamEvent(b, b.param0(a).oid).syncBarrier().then(function (a) {
                      h.logger.log(b.user_friendly_id() + ".onaddstream callback received!");
                      void 0 === b.remoteStreams.find(function (b) {
                        return void 0 != a.stream && b.object_id() === a.stream.object_id();
                      }) && b.remoteStreams.push(a.stream);
                      void 0 != b.onaddstream_ && (h.logger.log(b.user_friendly_id() + ".onaddstream notified!!! " + a.stream.id), b.onaddstream_(a));
                    });
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onaddstream, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, "set_onaddstream() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onremovestream", {
              get: function () {
                return this.onremovestream_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_onremovestream() called.");
                this.onremovestream_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onremovestream").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.onremovestream);
                  c.then(function (a) {
                    new p.RemoteStreamEvent(b, b.param0(a).oid).syncBarrier().then(function (a) {
                      h.logger.log(b.user_friendly_id() + ".onremovestream callback received! " + a.stream.id);
                      var c = b.remoteStreams.findIndex(function (b) {
                        return b.id == a.stream.id;
                      });
                      0 <= c && b.remoteStreams.splice(c, 1);
                      b.onremovestream_(a);
                    });
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.onremovestream, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, "set_onremovestream() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.getStats = function (a) {
              var b = this;
              return new Promise(function (c, l) {
                var q = this;
                b.isRedirected() ? b.waitUntilConnected(b.user_friendly_id() + ".getStats").then(function () {
                  var l = b.registerCallbacks(!0, !1, t.method_id_RTCPeerConnection_t.getStats);
                  l.then(function (b) {
                    void 0 !== b.params && 0 !== b.params.length && (a ? (a(A.StatsReport.fromJSON(JSON.parse(b.params[0]))), c()) : c(A.StatsReport.toRTCStatsReport(JSON.parse(b.params[0]))));
                  });
                  return a ? b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.getStats, l.success) : b.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.getStats_v2, l.success);
                })["catch"](function (a) {
                  q && (a = q.logRemoteInvokeError(a, ".getStats() failed!"), l(a));
                }) : (a({}), c());
              });
            };
            b.prototype.SendTelemetryData = function (a, b, c) {
              g.getRedirector().telemetry.SendTelemetryData(y.tel_cmd.Data, a, b, c);
            };
            b.prototype.MillisecondstoDisplayformat_ = function (a) {
              var b, c;
              c = Math.floor(a / 1E3);
              b = Math.floor(c / 60);
              a = Math.floor(b / 60);
              h.logger.log(Math.floor(a / 24) + ":" + a % 24 + ":" + b % 60 + ":" + c % 60);
            };
            b.prototype.CalculateCallDurationandType_ = function () {
              if (1 == this.timeerstarted_) {
                this.timeerstarted_ = !1;
                this.callendTime_ = new Date().getTime();
                var a = this.callendTime_ - this.callstartTime_;
                this.MillisecondstoDisplayformat_(a);
                a = Math.round(a / 1E3);
                h.logger.log("Call Duration " + a);
                1 == this.conferencecall_ ? this.SendTelemetryData(y.tel_key_ConferenceCallDuration, a, 1) : (1 == this.audiocall_.active && this.SendTelemetryData(y.tel_key_AudioCallDuration, a, 1), 1 == this.videocall_.active && this.SendTelemetryData(y.tel_key_VideoCallDuration, a, 1), 1 == this.screensharingcall_.active && this.SendTelemetryData(y.tel_key_ScreensharingCallDuration, a, 1));
                var b;
                1 == this.firsttimelocaloffer_ && (b = this.callstartTime_ - this.outgoingcallstart_);
                1 == this.firsttimeremoteoffer_ && (b = this.callstartTime_ - this.incomingcallstart_);
                this.MillisecondstoDisplayformat_(b);
                b = Math.round(b / 1E3);
                h.logger.log("Call Establish Time " + b);
                1 == this.incomingcall_ ? this.SendTelemetryData(y.tel_key_CallEstIncoming, b, 1) : 1 == this.outgoingcall_ && this.SendTelemetryData(y.tel_key_CallEstOutgoing, b, 1);
                this.SendTelemetryData(y.tel_key_PerfCallState, y.tel_CallState.idle, 1);
              }
            };
            b.prototype.close = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".close() called.");
              this.CalculateCallDurationandType_();
              this.unregisterStateChangeNotification(this.onStateChange);
              this.onnegotiationneeded = this.onsignalingstatechange = this.onicegatheringstatechange = this.oniceconnectionstatechange = this.onicecandidate = this.onaddstream = null;
              this.waitUntilConnected(this.user_friendly_id() + ".close").then(function () {
                return a.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.close);
              }).then(function () {
                a.iceQ_ = null;
                a.release();
                h.logger.log(a.user_friendly_id() + ".close() success.");
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".close() failed.");
                a.iceQ_ = null;
                a.release();
              });
            };
            b.prototype.createDTMFSender = function (a) {
              h.logger.log(this.user_friendly_id() + ".createDTMFSender() called.");
              var b,
                c = this.senders_;
              if (void 0 === c || 0 === c.length) c = this.getSenders();
              void 0 != c && (c = c.find(function (b) {
                return b.track.id === a.id;
              }), void 0 != c && (h.logger.log(this.user_friendly_id() + " returning RtpSender with oid:" + c.object_id()), b = c.dtmf));
              return b;
            };
            b.prototype.getSenders = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".getSenders() called. ");
              if (this.isUnified()) {
                for (var b = [], c = 0, l = this.transceivers_; c < l.length; c++) b.push(l[c].sender);
                this.senders_ = b;
              } else this.getSendersAsync().then(function () {
                h.logger.log(a.user_friendly_id() + ".getSenders() success.");
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".getSenders() failed!");
              });
              h.logger.log(this.user_friendly_id() + ".getSenders() returning:" + this.senders_.length + " items");
              return this.senders_;
            };
            b.prototype.getSendersAsync = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".getSendersAsync() called. " + this.senders_);
              return new Promise(function (b, c) {
                a.waitUntilConnected(a.user_friendly_id() + ".getSendersAsync").then(function () {
                  h.logger.log(a.user_friendly_id() + ".getSendersAsync invoking remote");
                  return a.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.getSenders, []);
                }).then(function (c) {
                  h.logger.log(a.user_friendly_id() + ".getSendersAsync remote success");
                  var l = [],
                    q = [];
                  c.params[0].forEach(function (b) {
                    var c = a.senders_.find(function (a) {
                      return a.object_id() === b.oid;
                    });
                    void 0 === c && (h.logger.log(a.user_friendly_id() + " adding a RtpSender with oid:" + b.oid), c = new f.RtpSender(a, b.oid, k.ProxyMode.Remote, a.isUnified()), q.push(c.syncBarrier()));
                    l.push(c);
                  });
                  Promise.all(q).then(function () {
                    a.senders_ = l;
                    h.logger.log(a.user_friendly_id() + ".getSendersAsync: returning senders with ids [" + a.senders_.map(function (a) {
                      return a.object_id();
                    }) + "]");
                    b(a.senders_);
                  })["catch"](function (c) {
                    a.logRemoteInvokeError(c, ".prop.getSendersAsync() failed.");
                    a.senders_ = [];
                    b(a.senders_);
                  });
                })["catch"](function (c) {
                  a.logRemoteInvokeError(c, ".getSendersAsync() failed.");
                  a.senders_ = [];
                  b(a.senders_);
                });
              });
            };
            b.prototype.getReceivers = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".getReceivers() called. ");
              if (this.isUnified()) {
                for (var b = [], c = 0, l = this.transceivers_; c < l.length; c++) b.push(l[c].receiver);
                this.receivers_ = b;
              } else this.getReceiversAsync().then(function () {
                h.logger.log(a.user_friendly_id() + ".getReceivers() success.");
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".getReceivers() failed!");
              });
              h.logger.log(this.user_friendly_id() + ".getReceivers() returning:" + this.receivers_.length + " items");
              return this.receivers_;
            };
            b.prototype.getReceiversAsync = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".getReceiversAsync() called. " + this.receivers_);
              return new Promise(function (b, c) {
                a.waitUntilConnected(a.user_friendly_id() + ".getReceiversAsync").then(function () {
                  return a.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.getReceivers, []);
                }).then(function (c) {
                  h.logger.log(a.user_friendly_id() + ".getReceiversAsync: remote success.");
                  var l = [],
                    q = [];
                  c.params[0].forEach(function (b) {
                    var c = a.receivers_.find(function (a) {
                      return a.object_id() === b.oid;
                    });
                    void 0 === c && (h.logger.log(a.user_friendly_id() + " adding a RtpReceiver with oid:" + b.oid), c = new f.RtpReceiver(a, b.oid, k.ProxyMode.Remote, a.isUnified()), q.push(c.syncBarrier()));
                    l.push(c);
                  });
                  Promise.all(q).then(function () {
                    a.receivers_ = l;
                    h.logger.log(a.user_friendly_id() + ".getReceiversAsync: returning receiver with ids [" + a.receivers_.map(function (a) {
                      return a.object_id();
                    }) + "]");
                    b(a.receivers_);
                  })["catch"](function (c) {
                    a.logRemoteInvokeError(c, ".prop.getReceiversAsync() failed!");
                    a.receivers_ = [];
                    b(a.receivers_);
                  });
                })["catch"](function (c) {
                  a.logRemoteInvokeError(c, ".getReceiversAsync() failed!");
                  a.receivers_ = [];
                  b(a.receivers_);
                });
              });
            };
            b.prototype.addTransceiver = function (a, b) {
              var c = this;
              h.logger.log(this.user_friendly_id() + ".addTransceiver() called: " + JSON.stringify(a) + " init=" + JSON.stringify(b));
              this.pendingtransceiver_ = !0;
              var l = "sendrecv";
              b && b.direction && (l = b.direction);
              var q = new m.RtpTransceiver(this, 0, k.ProxyMode.Pseudo, this.isUnified(), l);
              this.transceivers_.push(q);
              this.waitUntilConnected(this.user_friendly_id() + ".addTransceiver").then(function () {
                return "string" === typeof a ? c.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.addTransceiverWithKind, a, b) : c.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.addTransceiverWithTrack, {
                  oid: a.object_id()
                }, b);
              }).then(function (a) {
                h.logger.log(c.user_friendly_id() + ".addTransceiver() success with oid: " + c.param0(a).oid);
                q.bind(c, c.param0(a).oid);
                q.syncBarrier().then(function () {
                  h.logger.log(c.user_friendly_id() + ".addTransceiver(): success");
                  c.pendingtransceiver_ = !1;
                })["catch"](function (a) {
                  c.logRemoteInvokeError(a, ".prop.addTransceiver() failed!");
                  c.pendingtransceiver_ = !1;
                });
              })["catch"](function (a) {
                c.logRemoteInvokeError(a, "addTransceiver() failed!");
                c.pendingtransceiver_ = !1;
              });
              h.logger.log(this.user_friendly_id() + ".addTransceiver() returning:");
              return q;
            };
            b.prototype.waitTransceiverReady = function (a) {
              var b = this;
              return new Promise(function (c, l) {
                h.logger.trace(b.user_friendly_id() + ".waitTransceiverReady(): pendingtransceiver_=" + b.pendingtransceiver_);
                if (0 == b.pendingtransceiver_) {
                  for (; b.deferredOfferAnswers && 0 < b.deferredOfferAnswers.length;) b.deferredOfferAnswers.shift().post(!0);
                  c();
                } else b.deferredOfferAnswers.push(new k.deferred_action(c, l, a)), b.checkTransceiver(15, 1E3);
              });
            };
            b.prototype.checkTransceiver = function (a, b) {
              var c = this;
              if (0 >= a) for (h.logger.log(".checkTransceiver() timeout waiting for transceiver ready!"); this.deferredOfferAnswers && 0 < this.deferredOfferAnswers.length;) this.deferredOfferAnswers.shift().post(!1);else setTimeout(function () {
                if (0 == c.pendingtransceiver_) for (; c.deferredOfferAnswers && 0 < c.deferredOfferAnswers.length;) c.deferredOfferAnswers.shift().post(!0);else h.logger.log('.checkTransceiver(): count= "' + a), c.checkTransceiver(--a, b);
              }, b);
            };
            b.prototype.getTransceivers = function () {
              h.logger.log(this.user_friendly_id() + ".getTransceivers() called. ");
              h.logger.log(this.user_friendly_id() + ".getTransceivers() returning:" + this.transceivers_.length + " items");
              return this.transceivers_;
            };
            b.prototype.getTransceiversAsync = function () {
              var a = this;
              h.logger.log(this.user_friendly_id() + ".getTransceiversAsync() called. ");
              return new Promise(function (b, c) {
                a.waitUntilConnected(a.user_friendly_id() + ".getTransceiversAsync").then(function () {
                  return a.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.getTransceivers, []);
                }).then(function (c) {
                  h.logger.log(a.user_friendly_id() + ".getTransceiversAsync() remote success.");
                  var l = [],
                    q = [];
                  c.params[0].forEach(function (b) {
                    var c = a.transceivers_.find(function (a) {
                      return a.object_id() === b.oid;
                    });
                    void 0 === c && (h.logger.log(a.user_friendly_id() + " adding a RtpTransceiver with oid:" + b.oid), c = new m.RtpTransceiver(a, b.oid, k.ProxyMode.Remote, a.isUnified()), q.push(c.syncBarrier()));
                    l.push(c);
                  });
                  Promise.all(q).then(function () {
                    a.transceivers_ = l;
                    h.logger.log(a.user_friendly_id() + ".prop.getTransceiversAsync: returning transceiver with ids [" + a.transceivers_.map(function (a) {
                      return a.object_id();
                    }) + "]");
                    b(a.transceivers_);
                  })["catch"](function (c) {
                    a.logRemoteInvokeError(c, ".prop.getTransceiversAsync() failed!");
                    a.transceivers_ = [];
                    b(a.transceivers_);
                  });
                })["catch"](function (c) {
                  a.logRemoteInvokeError(c, ".getTransceiversAsync() failed!");
                  a.transceivers_ = [];
                  b(a.transceivers_);
                });
              });
            };
            Object.defineProperty(b.prototype, "sctp", {
              get: function () {
                return this.sctp_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "ondatachannel", {
              get: function () {
                return this.ondatachannel_;
              },
              set: function (a) {
                var b = this;
                h.logger.log(this.user_friendly_id() + ".set_ondatachannel() called.");
                this.ondatachannel_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".ondatachannel").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), t.method_id_RTCPeerConnection_t.ondatachannel);
                  c.then(function (a) {
                    h.logger.log(b.user_friendly_id() + ".ondatachannel callback received!!!");
                    if (null === b.remotedatachannel_ || b.remotedatachannel_.object_id() != b.param0(a).oid) b.remotedatachannel_ = new B.RtcDataChannel(b, b.param0(a).oid, k.ProxyMode.Remote), b.remotedatachannel_.syncBarrier().then(function () {
                      h.logger.log(b.user_friendly_id() + "remotedatachannel_.syncBarrier(): success");
                      var a = new Event("ondatachannel");
                      a.channel = b.remotedatachannel_;
                      if (b.localdatachannel_ && !b.localdatachannel_.isdestroyed()) b.localdatachannel_.syncBarrier().then(function () {
                        h.logger.log(b.user_friendly_id() + "ondatachannel(): notifying...");
                        if (b.ondatachannel_) b.ondatachannel_(a);
                      })["catch"](function () {
                        h.logger.log(b.user_friendly_id() + "localdatachannel_.syncBarrier(): failed!");
                      });else if (h.logger.log(b.user_friendly_id() + "ondatachannel(): notifying..."), b.ondatachannel_) b.ondatachannel_(a);
                    })["catch"](function () {
                      h.logger.log(b.user_friendly_id() + "remotedatachannel_.syncBarrier(): failed!");
                    });
                  });
                  return b.remoteInvoke(!0, t.method_id_RTCPeerConnection_t.ondatachannel, c.success);
                })["catch"](function () {
                  h.logger.log(b.user_friendly_id() + ".ondatachannel() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.fixDataChannelConfig = function (a) {
              h.logger.log(this.user_friendly_id() + ".fixDataChannelConfig() called: " + a);
              void 0 == a && (a = {});
              void 0 == a.negotiated && void 0 == a.id && (a.negotiated = !1, a.id = -1);
              return a;
            };
            b.prototype.createDataChannel = function (a, b) {
              var c = this;
              h.logger.log(this.user_friendly_id() + ".createDataChannel() called. label:" + a);
              this.localdatachannel_ = new B.RtcDataChannel(this, 0, k.ProxyMode.Pseudo);
              this.waitUntilConnected(this.user_friendly_id() + ".createDataChannel").then(function () {
                return c.remoteInvoke(!1, t.method_id_RTCPeerConnection_t.createDataChannel, a, c.fixDataChannelConfig(b));
              }).then(function (a) {
                h.logger.log(c.user_friendly_id() + ".createDataChannel() success with oid: " + c.param0(a).oid);
                c.localdatachannel_.bind(c, c.param0(a).oid);
                c.localdatachannel_.syncBarrier().then(function () {
                  h.logger.log(c.user_friendly_id() + "channel.syncBarrier(): success");
                })["catch"](function () {
                  h.logger.log(c.user_friendly_id() + "channel.syncBarrier(): failed!");
                });
              })["catch"](function (a) {
                a = c.param0(a);
                h.logger.log(c.user_friendly_id() + ".createDataChannel() failed with error: " + a);
              });
              h.logger.log(this.user_friendly_id() + ".createDataChannel() returning: " + this.localdatachannel_);
              return this.localdatachannel_;
            };
            return b;
          }(k.ProxyObject);
          a.PeerConnection = b;
        },
        658: function (b, a, c) {
          var d = this && this.__spreadArrays || function () {
            for (var a = 0, b = 0, c = arguments.length; b < c; b++) a += arguments[b].length;
            for (var a = Array(a), d = 0, b = 0; b < c; b++) for (var m = arguments[b], g = 0, u = m.length; g < u; g++, d++) a[d] = m[g];
            return a;
          };
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var e = c(946),
            r = c(851),
            n = c(545),
            g = c(247),
            p = c(550),
            f = function () {
              function a(b, c, d) {
                this.resolve = b;
                this.reject = c;
                this.name_ = d;
              }
              Object.defineProperty(a.prototype, "name", {
                get: function () {
                  return this.name_;
                },
                enumerable: !0,
                configurable: !0
              });
              a.prototype.post = function (a) {
                1 == a ? (r.logger.log('deferred_action.post(): resolving "' + this.name_ + '"'), this.resolve()) : (r.logger.log('deferred_action.post(): rejecting "' + this.name_ + '"'), this.reject());
              };
              a.prototype.postWithResult = function (a, b) {
                1 == a ? (r.logger.log('deferred_action.post(): resolving "' + this.name_ + '"'), this.resolve(b)) : (r.logger.log('deferred_action.post(): rejecting "' + this.name_ + '"'), this.reject());
              };
              return a;
            }();
          a.deferred_action = f;
          var k = function () {
            return function (a, b) {
              this.id = a;
              this.is_null = b;
            };
          }();
          a.rpc_callback = k;
          var x = function () {
            function a(b, c, d) {
              this.success = new k(b << 16, c);
              this.fail = new k(b << 16 | 1, c);
              this.id = b;
              this.oneShot = d;
            }
            a.prototype.resolve = function (a) {
              r.logger.trace("callback.resolve() called. [id=" + this.id + "]");
              null != this.handler && this.handler(a);
            };
            a.prototype.reject = function (a) {
              null != this.err_handler && this.err_handler(a);
            };
            a.prototype.then = function (a) {
              this.handler = a;
            };
            a.prototype.prom = function () {
              var a = this;
              return new Promise(function (b, c) {
                a.handler = b;
                a.err_handler = c;
              });
            };
            return a;
          }();
          a.callback = x;
          var m;
          (function (a) {
            a[a.NotConfigured = 0] = "NotConfigured";
            a[a.Configured = 1] = "Configured";
            a[a.Error = 2] = "Error";
            a[a.Destroyed = 3] = "Destroyed";
          })(m || (m = {}));
          var D;
          (function (a) {
            a[a.Local = 0] = "Local";
            a[a.Remote = 1] = "Remote";
            a[a.Pseudo = 2] = "Pseudo";
          })(D = a.ProxyMode || (a.ProxyMode = {}));
          b = function () {
            function a(b, c, f, x, k) {
              var u = this;
              void 0 === k && (k = null);
              for (var q = [], w = 5; w < arguments.length; w++) q[w - 5] = arguments[w];
              this.hdxms = e.getRedirector();
              this.iid = c;
              this.oid = f;
              this.mode = x;
              this.proxystate = m.NotConfigured;
              this.deferredActions = [];
              this.cbs = new Map();
              x === D.Local ? (w = !1, this.iid === p.class_id_t.EngineControl && (w = !0), this.hdxms.startRedirection(w, this.user_friendly_id()).then(function () {
                u.oid = a.nextId++;
                r.logger.log(u.user_friendly_id() + " assigned local oid:" + u.oid);
                var b = p.WebrpcClassLibInfoUtil.getMethodFeatureByid(c, 0);
                return u.hdxms.WSSendObjectWrapper(b, c, 0, n.WsJsonUtil.createMessageByid.apply(n.WsJsonUtil, d([!1, !1, n.ws_msg_type_t.req, c, 0, u.oid], q)));
              }).then(function (a) {
                r.logger.trace("ProxyObject: setting state to configured. (iid: " + u.iid + " oid: " + u.oid + ")");
                var c = u.oid;
                u.proxystate = m.Configured;
                u.oid = u.param0(a);
                r.logger.log(u.user_friendly_id() + " assigned remote oid for local oid:" + c);
                u.onConnected();
                k && k();
                g.gc.trackObject(u, b);
              })["catch"](function () {
                u.proxystate = m.Error;
                u.onConnected();
              })) : x === D.Remote && (this.proxystate = m.Configured, g.gc.trackObject(this, b));
            }
            a.prototype.bind = function (a, b) {
              r.logger.trace("ProxyObject: binding object. (iid: " + this.iid + " oid: " + b + " mode: " + this.mode + ")");
              if (this.mode === D.Pseudo) {
                this.proxystate = m.Configured;
                var c = this.oid;
                this.oid = b;
                r.logger.log(this.user_friendly_id() + " assigned remote oid for local oid:" + c);
                this.onConnected();
                g.gc.trackObject(this, a);
                this.mode = D.Remote;
              } else this.mode === D.Remote ? r.logger.log("ProxyObject: binding already complete.") : r.logger.log("ProxyObject: binding failure. incorrect mode!");
            };
            a.prototype.reconstructor = function (a, b, c) {
              for (var f = this, e = [], u = 3; u < arguments.length; u++) e[u - 3] = arguments[u];
              this.proxystate = m.NotConfigured;
              this.deferredActions = [];
              u = p.WebrpcClassLibInfoUtil.getMethodFeatureByid(b, 0);
              this.hdxms.WSSendObjectWrapper(u, b, 0, n.WsJsonUtil.createMessageByid.apply(n.WsJsonUtil, d([!1, !1, n.ws_msg_type_t.req, b, 0, this.oid], e))).then(function (b) {
                r.logger.trace("ProxyObject: setting state to configured. (iid: " + f.iid + " oid: " + f.oid + ")");
                var c = f.oid;
                f.proxystate = m.Configured;
                f.oid = f.param0(b);
                r.logger.log(f.user_friendly_id() + " assigned remote oid for local oid:" + c);
                f.onConnected();
                g.gc.trackObject(f, a);
              })["catch"](function () {
                f.proxystate = m.Error;
                f.onConnected();
              });
            };
            a.prototype.setParent = function (a) {
              g.gc.setParent(this, a);
            };
            a.prototype.release = function () {
              r.logger.log(this.user_friendly_id() + ".release() called.");
              g.gc.releaseObject(this);
            };
            a.prototype.destroy = function () {
              r.logger.log(this.user_friendly_id() + ".destroy() called.");
              this.proxystate = m.Destroyed;
              var a = p.WebrpcClassLibInfoUtil.getMethodFeatureByid(this.iid, 0);
              this.hdxms.WSSendObjectWrapper(a, this.iid, 0, n.WsJsonUtil.createMessageByid(!1, !0, n.ws_msg_type_t.req, this.iid, 0, this.oid));
            };
            a.prototype.isdestroyed = function () {
              return this.proxystate == m.Destroyed;
            };
            a.prototype.onConnected = function () {
              for (; this.deferredActions && 0 < this.deferredActions.length;) this.deferredActions.shift().post(this.proxystate == m.Configured);
            };
            a.prototype.isPseudo = function () {
              return this.mode == D.Pseudo;
            };
            a.prototype.checkState = function (a, b) {
              var c = this;
              0 >= a ? (r.logger.log("ProxyObject.checkState() timeout waiting for connection response! failed. (iid: " + c.iid + " oid: " + c.oid + ")"), c.onConnected()) : setTimeout(function () {
                if (c.proxystate == m.Configured) c.onConnected();else if (c.proxystate == m.Error) c.onConnected();else if (c.proxystate == m.Destroyed) c.onConnected();else r.logger.log('ProxyObject.checkState(): count= "' + a + '". (iid: ' + c.iid + " oid: " + c.oid + ")"), c.checkState(--a, b);
              }, b);
            };
            a.prototype.waitUntilConnected = function (a) {
              var b = this;
              return new Promise(function (c, d) {
                b ? (r.logger.trace("ProxyObject.waitUntilConnected(): readyState=" + b.proxystate + ". (iid: " + b.iid + " oid: " + b.oid + ")"), b.proxystate == m.Destroyed ? (b.onConnected(), r.logger.trace("rejecting already destroyed Object:" + b.user_friendly_id()), d("Object already destroyed :" + b.user_friendly_id())) : b.proxystate == m.Configured ? (b.onConnected(), c()) : b.proxystate == m.Error ? (r.logger.trace("ProxyObject.waitUntilConnected(): readyState=" + b.proxystate + ". (iid: " + b.iid + " oid: " + b.oid + ")"), b.onConnected(), d()) : (r.logger.log('ProxyObject.waitUntilConnected(): deferring action "' + a + '". (iid: ' + b.iid + " oid: " + b.oid + ")"), b.deferredActions.push(new f(c, d, a)), b.checkState(15, 1E3))) : d("Invalid Object");
              });
            };
            a.prototype.remoteInvoke = function (a, b) {
              for (var c = [], g = 2; g < arguments.length; g++) c[g - 2] = arguments[g];
              if (this.proxystate == m.Destroyed) return r.logger.trace("rejecting already destroyed Object:" + this.user_friendly_id()), Promise.reject("Cannot invoke destroyed object :" + this.user_friendly_id());
              if (this.proxystate == m.Error) return r.logger.trace("rejecting already error state Object:" + this.user_friendly_id()), Promise.reject("Cannot invoke object in Error state:" + this.user_friendly_id());
              g = p.WebrpcClassLibInfoUtil.getMethodFeatureByid(this.iid, b);
              return this.hdxms.WSSendObjectWrapper(g, this.iid, b, n.WsJsonUtil.createMessageByid.apply(n.WsJsonUtil, d([a, !1, n.ws_msg_type_t.req, this.iid, b, this.oid], c)));
            };
            a.prototype.logRemoteInvokeError = function (a, b) {
              var c = a;
              c ? r.logger.log(this.user_friendly_id() + b + " with error: " + c.message) : this.param0 ? (r.logger.log(this.user_friendly_id() + b + " with error: " + this.param0(a)), c = new DOMException(b + " with error: " + this.param0(a), this.user_friendly_id())) : (r.logger.log(this.user_friendly_id() + b), c = new DOMException(b, this.user_friendly_id()));
              return c;
            };
            a.prototype.registerCallbacks = function (b, c, d) {
              this.unregisterCallbacks(d);
              var m = a.nextcbid++,
                g = new x(m, c, b);
              c || (b || this.cbs.set(d, m), this.hdxms.registerHandler(this.iid, this.oid, g));
              return g;
            };
            a.prototype.unregisterCallbacks = function (a) {
              this.cbs.has(a) ? (this.hdxms.unregisterHandler(this.iid, this.oid, this.cbs.get(a)), this.cbs["delete"](a)) : r.logger.trace(this.cbs);
            };
            a.prototype.object_id = function () {
              return this.oid;
            };
            a.prototype.param0 = function (a) {
              var b = {};
              a && a.params && (b = a.params[0]);
              return b;
            };
            a.prototype.isNullCallback = function (a) {
              return void 0 == a || null == a;
            };
            a.prototype.user_friendly_id = function () {
              return this.constructor.name + "[" + this.oid + "]";
            };
            a.prototype.isRedirected = function () {
              return this.hdxms.isRedirected();
            };
            a.prototype.isValid = function () {
              return !(this.proxystate === m.Error || this.proxystate === m.Destroyed);
            };
            a.prototype.registerStateChangeNotification = function (a) {
              this.hdxms.registerStateChangeNotification(a);
            };
            a.prototype.unregisterStateChangeNotification = function (a) {
              this.hdxms.unregisterStateChangeNotification(a);
            };
            a.nextId = 0;
            a.nextcbid = 0;
            return a;
          }();
          a.ProxyObject = b;
        },
        144: function (b, a, c) {
          function d(a) {
            for (var b = [], c = 0; c < a.length; c++) b.push({
              oid: a[c].object_id()
            });
            return b;
          }
          var e = this && this.__extends || function () {
              var a = function (b, c) {
                a = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (a, b) {
                  a.__proto__ = b;
                } || function (a, b) {
                  for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
                };
                return a(b, c);
              };
              return function (b, c) {
                function d() {
                  this.constructor = b;
                }
                a(b, c);
                b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
              };
            }(),
            r = this && this.__awaiter || function (a, b, c, d) {
              function m(a) {
                return a instanceof c ? a : new c(function (b) {
                  b(a);
                });
              }
              return new (c || (c = Promise))(function (c, q) {
                function l(a) {
                  try {
                    g(d.next(a));
                  } catch (b) {
                    q(b);
                  }
                }
                function h(a) {
                  try {
                    g(d["throw"](a));
                  } catch (b) {
                    q(b);
                  }
                }
                function g(a) {
                  a.done ? c(a.value) : m(a.value).then(l, h);
                }
                g((d = d.apply(a, b || [])).next());
              });
            },
            n = this && this.__generator || function (a, b) {
              function c(a) {
                return function (b) {
                  return d([a, b]);
                };
              }
              function d(c) {
                if (h) throw new TypeError("Generator is already executing.");
                for (; m;) try {
                  if (h = 1, g && (l = c[0] & 2 ? g["return"] : c[0] ? g["throw"] || ((l = g["return"]) && l.call(g), 0) : g.next) && !(l = l.call(g, c[1])).done) return l;
                  if (g = 0, l) c = [c[0] & 2, l.value];
                  switch (c[0]) {
                    case 0:
                    case 1:
                      l = c;
                      break;
                    case 4:
                      return m.label++, {
                        value: c[1],
                        done: !1
                      };
                    case 5:
                      m.label++;
                      g = c[1];
                      c = [0];
                      continue;
                    case 7:
                      c = m.ops.pop();
                      m.trys.pop();
                      continue;
                    default:
                      if (!(l = m.trys, l = 0 < l.length && l[l.length - 1]) && (6 === c[0] || 2 === c[0])) {
                        m = 0;
                        continue;
                      }
                      if (3 === c[0] && (!l || c[1] > l[0] && c[1] < l[3])) m.label = c[1];else if (6 === c[0] && m.label < l[1]) m.label = l[1], l = c;else if (l && m.label < l[2]) m.label = l[2], m.ops.push(c);else {
                        l[2] && m.ops.pop();
                        m.trys.pop();
                        continue;
                      }
                  }
                  c = b.call(a, m);
                } catch (q) {
                  c = [6, q], g = 0;
                } finally {
                  h = l = 0;
                }
                if (c[0] & 5) throw c[1];
                return {
                  value: c[0] ? c[1] : void 0,
                  done: !0
                };
              }
              var m = {
                  label: 0,
                  sent: function () {
                    if (l[0] & 1) throw l[1];
                    return l[1];
                  },
                  trys: [],
                  ops: []
                },
                h,
                g,
                l,
                f;
              $jscomp.initSymbol();
              $jscomp.initSymbol();
              $jscomp.initSymbolIterator();
              return f = {
                next: c(0),
                "throw": c(1),
                "return": c(2)
              }, "function" === typeof Symbol && (f[Symbol.iterator] = function () {
                return this;
              }), f;
            };
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var g = c(550),
            p = c(658),
            f = c(851),
            k = c(946),
            x = c(394),
            m;
          a.enumerateddecices = m;
          var D = function () {
              return function (a, b) {
                this.type = a;
                this.target = b;
              };
            }(),
            B = function () {
              function a() {
                this.is_local_clone = !1;
                this.clone_id = this.clone_count = 0;
              }
              a.prototype.clone = function () {
                this.clone_count++;
                var b = new a();
                b.is_local_clone = !0;
                b.clone_id = this.clone_count;
                return b;
              };
              a.prototype.synchronize = function (a) {
                return r(this, void 0, void 0, function () {
                  return n(this, function (b) {
                    return this.is_local_clone ? [2, a.asyncClone()] : [2, a];
                  });
                });
              };
              return a;
            }(),
            t = function (a) {
              function b(c, d) {
                var m = a.call(this, c, g.class_id_t.MediaStreamTrack, d, p.ProxyMode.Remote) || this;
                m.refCount_ = 0;
                m.refCount_++;
                m.clone_state = new B();
                return m;
              }
              e(b, a);
              b.prototype.dumpInfo = function () {
                f.logger.log(this.user_friendly_id() + ".dumpInfo() [id=" + this.id + "] kind=" + this.kind + " label=" + this.label + " refcount=" + this.refcount);
              };
              Object.defineProperty(b.prototype, "refcount", {
                get: function () {
                  return this.refCount_;
                },
                enumerable: !0,
                configurable: !0
              });
              b.prototype.addRef = function () {
                this.refCount_++;
                f.logger.log(this.user_friendly_id() + ".addRef() called. [id=" + this.id + "] refcount=" + this.refCount_);
              };
              Object.defineProperty(b.prototype, "onended", {
                get: function () {
                  f.logger.log(this.user_friendly_id() + ".get_onended() called. [id=" + this.id + "]");
                  return this.onended_;
                },
                set: function (a) {
                  var b = this;
                  f.logger.log(this.user_friendly_id() + ".set_onended() called. [id=" + this.id + "]");
                  this.onended_ = a;
                  this.waitUntilConnected("MediaStreamTrack.onended").then(function () {
                    var c = b.registerCallbacks(!1, b.isNullCallback(a), g.method_id_MediaStreamTrack_t.onended);
                    c.then(function (a) {
                      f.logger.log(b.user_friendly_id() + "onended event received!!!");
                      a = new D("ended", b);
                      b.readyState_ = "ended";
                      b.onended_(a);
                    });
                    return b.remoteInvoke(!0, g.method_id_MediaStreamTrack_t.onended, c.success);
                  })["catch"](function (a) {
                    b.logRemoteInvokeError(a, ".onended failed!");
                  });
                },
                enumerable: !0,
                configurable: !0
              });
              Object.defineProperty(b.prototype, "onmute", {
                get: function () {
                  f.logger.log(this.user_friendly_id() + ".get_onmute() called. [id=" + this.id + "]");
                  return this.onmute_;
                },
                set: function (a) {
                  var b = this;
                  f.logger.log(this.user_friendly_id() + ".set_onmute() called. [id=" + this.id + "]");
                  this.onmute_ = a;
                  this.waitUntilConnected("MediaStreamTrack.onmute").then(function () {
                    var c = b.registerCallbacks(!1, b.isNullCallback(a), g.method_id_MediaStreamTrack_t.onmute);
                    c.then(function (a) {
                      f.logger.log(b.user_friendly_id() + "onmute event received!!!");
                      a = new D("mute", b);
                      b.muted = !0;
                      b.onmute_(a);
                    });
                    return b.remoteInvoke(!0, g.method_id_MediaStreamTrack_t.onmute, c.success);
                  })["catch"](function (a) {
                    b.logRemoteInvokeError(a, ".onmute failed!");
                  });
                },
                enumerable: !0,
                configurable: !0
              });
              Object.defineProperty(b.prototype, "onunmute", {
                get: function () {
                  f.logger.log(this.user_friendly_id() + ".get_onunmute() called. [id=" + this.id + "]");
                  return this.onunmute_;
                },
                set: function (a) {
                  var b = this;
                  f.logger.log(this.user_friendly_id() + ".set_onunmute() called. [id=" + this.id + "]");
                  this.onunmute_ = a;
                  this.waitUntilConnected("MediaStreamTrack.onunmute").then(function () {
                    var c = b.registerCallbacks(!1, b.isNullCallback(a), g.method_id_MediaStreamTrack_t.onunmute);
                    c.then(function (a) {
                      f.logger.log("onunmute event received!!!");
                      a = new D("unmute", b);
                      b.muted = !1;
                      b.onunmute_(a);
                    });
                    return b.remoteInvoke(!0, g.method_id_MediaStreamTrack_t.onunmute, c.success);
                  })["catch"](function (a) {
                    b.logRemoteInvokeError(a, ".onunmute failed!");
                  });
                },
                enumerable: !0,
                configurable: !0
              });
              Object.defineProperty(b.prototype, "onstop", {
                set: function (a) {
                  this.onstop_ = a;
                },
                enumerable: !0,
                configurable: !0
              });
              Object.defineProperty(b.prototype, "enabled", {
                get: function () {
                  f.logger.log(this.user_friendly_id() + ".get_enabled() called. [id=" + this.id + ", value=" + this.enabled_ + "]");
                  return this.enabled_;
                },
                set: function (a) {
                  f.logger.log(this.user_friendly_id() + ".set_enabled() called. [id=" + this.id + ", value=" + a + "]");
                  this.enabled_ = a;
                  this.remoteInvoke(!0, g.method_id_MediaStreamTrack_t.enabled, a);
                },
                enumerable: !0,
                configurable: !0
              });
              Object.defineProperty(b.prototype, "readyState", {
                get: function () {
                  f.logger.log(this.user_friendly_id() + ".get_readyState() called. [id=" + this.id + "]");
                  return this.readyState_;
                },
                enumerable: !0,
                configurable: !0
              });
              b.prototype.asyncClone = function () {
                return r(this, void 0, void 0, function () {
                  var a, c, d;
                  return n(this, function (m) {
                    switch (m.label) {
                      case 0:
                        return [4, this.waitUntilConnected("RemoteMediaTrack.asyncClone")];
                      case 1:
                        return m.sent(), [4, this.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.clone, [])];
                      case 2:
                        return a = m.sent(), c = this.param0(a), d = new b(this, c.oid), [2, d.syncBarrier()];
                    }
                  });
                });
              };
              b.prototype.clone = function () {
                f.logger.log(this.user_friendly_id() + ".clone() called. [id=" + this.id + "]");
                var a = this.clone_state.clone(),
                  c = new b(this, this.object_id());
                c.id = this.id + "." + a.clone_id.toString();
                c.label = this.label;
                c.kind = this.kind;
                c.enabled_ = this.enabled_;
                c.muted = this.muted;
                c.readyState_ = this.readyState_;
                c.trackSettings_ = this.trackSettings_;
                c.clone_state = a;
                c.constraints_ = this.constraints_;
                c.capabilities_ = this.capabilities_;
                return c;
              };
              b.prototype.stop = function () {
                var a = this;
                f.logger.log(this.user_friendly_id() + ".stop() called. [id=" + this.id + "] refcount=" + this.refCount_);
                this.readyState_ = "ended";
                if (0 < this.refCount_ && (this.refCount_--, 0 === this.refCount_ && (f.logger.log(this.user_friendly_id() + ".stop() called. [id=" + this.id + "] remote invoking..."), this.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.stop)["catch"](function (b) {
                  a.logRemoteInvokeError(b, ".stop failed!");
                }), "video" == this.kind && "remoteapp-track" == this.label && k.getRedirector().stopAppshare(), null !== this.onstop_ && void 0 != this.onstop_))) this.onstop_();
              };
              b.prototype.getCapabilities = function () {
                return this.capabilities_;
              };
              b.prototype.getConstraints = function () {
                return this.constraints_;
              };
              b.prototype.getSettings = function () {
                return "audio" == this.kind ? function (a) {
                  return {
                    deviceId: a.deviceId,
                    echoCancellation: a.echoCancellation
                  };
                }(this.trackSettings_) : function (a) {
                  return {
                    aspectRatio: a.aspectRatio,
                    deviceId: a.deviceId,
                    frameRate: a.frameRate,
                    height: a.height,
                    width: a.width
                  };
                }(this.trackSettings_);
              };
              b.prototype.applyConstraints = function (a) {
                var b = this;
                f.logger.log(this.user_friendly_id() + ".applyConstraints() called.");
                return new Promise(function (c, d) {
                  b.waitUntilConnected("MediaStreamTrack.applyConstraints").then(function () {
                    return Promise.all([b.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.applyConstraints, a), b.syncBarrier()]);
                  })["catch"](function () {
                    d({
                      name: "OverconstrainedError",
                      message: "Failed to apply constraints."
                    });
                  }).then(function () {
                    b.constraints_ = a;
                    return b.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.getConstraints);
                  }).then(function (a) {
                    b.constraints_ = b.param0(a);
                  })["catch"](function (a) {
                    b.logRemoteInvokeError(a, ".syncBarrier() remote client does not support getConstraints method. Ignore it");
                  }).then(function () {
                    return c();
                  });
                });
              };
              b.convertReadyState = function (a) {
                return 0 == a ? "live" : "ended";
              };
              b.prototype.syncBarrier = function () {
                var a = this;
                f.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
                return new Promise(function (c, d) {
                  a.waitUntilConnected("MediaStreamTrack.syncBarrier").then(function () {
                    return Promise.all([a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.kind, ""), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.id, ""), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.label, ""), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.enabled, !1), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.muted, !1), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.readyState, 0), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.getSettings), a.remoteInvoke(!1, g.method_id_MediaStreamTrack_t.getCapabilities)]);
                  }).then(function (d) {
                    var m = 0;
                    d = d.map(function (b) {
                      return a.param0(b);
                    });
                    a.kind = d[0];
                    a.id = d[1];
                    a.label = d[2];
                    a.enabled_ = d[3];
                    a.muted = d[4];
                    m = d[5];
                    a.trackSettings_ = d[6];
                    a.capabilities_ = d[7];
                    a.readyState_ = b.convertReadyState(m);
                    c(a);
                  })["catch"](function (b) {
                    b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                    d(b);
                  });
                });
              };
              return b;
            }(p.ProxyObject);
          a.RemoteMediaTrack = t;
          var h = function () {
              return function () {};
            }(),
            A = function (a) {
              function b(c, m, h, f) {
                void 0 === h && (h = p.ProxyMode.Local);
                void 0 === f && (f = []);
                c = a.call(this, c, g.class_id_t.MediaStream, m, h, null, d(f)) || this;
                c.clone_state = new B();
                c.tracks_ = f;
                return c;
              }
              e(b, a);
              b.prototype.dumpInfo = function () {
                f.logger.log(this.user_friendly_id() + ".dumpInfo() [id=" + this.id + "] active=" + this.active_ + " num tracks=" + this.tracks_.length);
                for (var a = 0, b = this.tracks_; a < b.length; a++) {
                  var c = b[a];
                  c && c.dumpInfo();
                }
              };
              b.prototype.toggleAudio = function (a) {
                f.logger.log(this.user_friendly_id() + ".toggleAudio() called: " + a);
                for (var b = 0, c = this.getAudioTracks(); b < c.length; b++) c[b].enabled = a;
              };
              b.prototype.toJSON = function () {
                var a = new h();
                a.id = this.id;
                a.active = this.active_;
                a.oid = this.object_id();
                return "RemoteStream:" + JSON.stringify(a);
              };
              Object.defineProperty(b.prototype, "active", {
                get: function () {
                  f.logger.log(this.user_friendly_id() + ".get active() called. [id=" + this.id + "] active=" + this.active_);
                  return this.active_;
                },
                enumerable: !0,
                configurable: !0
              });
              b.prototype.getAudioTracks = function () {
                f.logger.log(this.user_friendly_id() + ".getAudioTracks() called. [id=" + this.id + "]");
                for (var a = [], b = 0, c = this.tracks_; b < c.length; b++) {
                  var d = c[b];
                  "audio" == d.kind && a.push(d);
                }
                return a;
              };
              b.prototype.getVideoTracks = function () {
                f.logger.log(this.user_friendly_id() + ".getVideoTracks() called. [id=" + this.id + "]");
                for (var a = [], b = 0, c = this.tracks_; b < c.length; b++) {
                  var d = c[b];
                  "video" == d.kind && a.push(d);
                }
                return a;
              };
              b.prototype.getTracks = function () {
                f.logger.log(this.user_friendly_id() + ".getTracks() called. [id=" + this.id + "]");
                return this.tracks_;
              };
              b.prototype.getTrackById = function (a) {
                f.logger.log(this.user_friendly_id() + ".getTrackById() called. [id=" + this.id + "]");
                for (var b = 0, c = this.tracks_; b < c.length; b++) {
                  var d = c[b];
                  if (d.id == a) return d;
                }
              };
              b.prototype.addTrack = function (a) {
                var b = this;
                f.logger.log(this.user_friendly_id() + ".addTrack() called. [id=" + this.id + "]");
                this.tracks_.push(a);
                a && a.dumpInfo();
                var c = this;
                this.waitUntilConnected("MediaStream.addTrack").then(function () {
                  f.logger.log(c.user_friendly_id() + ".addTrack remote invoking");
                  return c.remoteInvoke(!1, g.method_id_MediaStream_t.addTrack, {
                    oid: a.object_id()
                  });
                }).then(function () {
                  f.logger.log(c.user_friendly_id() + ".addTrack success");
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".addTrack failed!");
                });
              };
              b.prototype.removeTrack = function (a) {
                var b = this;
                f.logger.log(this.user_friendly_id() + ".removeTrack() called. [id=" + this.id + "]");
                var c = this.tracks_.indexOf(a);
                this.tracks_.splice(c, 1);
                var d = this;
                this.waitUntilConnected("MediaStream.removeTrack").then(function () {
                  f.logger.log(d.user_friendly_id() + ".removeTrack remote invoking");
                  return d.remoteInvoke(!1, g.method_id_MediaStream_t.removeTrack, {
                    oid: a.object_id()
                  });
                }).then(function () {
                  f.logger.log(d.user_friendly_id() + ".removeTrack success");
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".removeTrack failed!");
                });
              };
              b.prototype.asyncClone = function () {
                return r(this, void 0, void 0, function () {
                  var a, c, d;
                  return n(this, function (m) {
                    switch (m.label) {
                      case 0:
                        return f.logger.log(this.user_friendly_id() + ".asyncClone() called. [id=" + this.id + "]"), [4, this.waitUntilConnected("asyncClone")];
                      case 1:
                        return m.sent(), [4, this.remoteInvoke(!1, g.method_id_MediaStream_t.clone, [])];
                      case 2:
                        return a = m.sent(), console.log(a), c = this.param0(a), d = new b(this, c.oid, p.ProxyMode.Remote), [2, d.syncBarrier()];
                    }
                  });
                });
              };
              b.prototype.clone = function () {
                f.logger.log(this.user_friendly_id() + ".clone() called. [id=" + this.id + "]");
                var a = this.clone_state.clone(),
                  c = new b(this, this.object_id(), p.ProxyMode.Remote);
                c.id = this.id + "." + a.clone_id.toString();
                this.tracks_.forEach(function (a) {
                  a.addRef();
                });
                c.tracks_ = this.tracks_;
                c.clone_state = a;
                return c;
              };
              b.prototype.syncBarrier = function () {
                var a = this;
                f.logger.log(this.user_friendly_id() + ".syncBarrier() called. [id=" + this.id + "]");
                return new Promise(function (b, c) {
                  a.waitUntilConnected("MediaStream.syncBarrier").then(function () {
                    return Promise.all([a.remoteInvoke(!1, g.method_id_MediaStream_t.id, ""), a.remoteInvoke(!1, g.method_id_MediaStream_t.active, !1), a.remoteInvoke(!1, g.method_id_MediaStream_t.getTracks, [])]);
                  }).then(function (b) {
                    f.logger.log(a.user_friendly_id() + ".syncBarrier() remote success");
                    b = b.map(function (b) {
                      return a.param0(b);
                    });
                    a.id = b[0];
                    a.active_ = b[1];
                    b = b[2];
                    for (var c = [], l = function (b) {
                        var l = a.tracks_.find(function (a) {
                          return a.object_id() === b.oid;
                        });
                        void 0 === l && (f.logger.log(a.user_friendly_id() + " adding a RemoteMediaTrack with oid:" + b.oid), l = new t(a, b.oid));
                        c.push(l.syncBarrier());
                      }, d = 0; d < b.length; d++) l(b[d]);
                    return Promise.all(c);
                  }).then(function (c) {
                    a.tracks_ = [];
                    c.forEach(function (b) {
                      b.onstop = function () {
                        var b = !0;
                        a.tracks_.forEach(function (a) {
                          "ended" != a.readyState && (b = !1);
                        });
                        b && a.release();
                      };
                      a.tracks_.push(b);
                    });
                    b(a);
                  })["catch"](function (b) {
                    a.logRemoteInvokeError(b, ".syncBarrier failed!");
                    c();
                  });
                });
              };
              return b;
            }(p.ProxyObject);
          a.RemoteStream = A;
          b = function (a) {
            function b(c, d) {
              return a.call(this, c, g.class_id_t.MediaStreamEvent, d, p.ProxyMode.Remote) || this;
            }
            e(b, a);
            b.prototype.syncBarrier = function () {
              var a = this;
              f.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("MediaStreamEvent.syncBarrier").then(function () {
                  return a.remoteInvoke(!1, g.method_id_MediaStreamEvent_t.stream, {
                    oid: 0
                  });
                }).then(function (b) {
                  return new A(a, b.params[0].oid, p.ProxyMode.Remote).syncBarrier();
                }).then(function (c) {
                  a.stream = c;
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  c(b);
                });
              });
            };
            return b;
          }(p.ProxyObject);
          a.RemoteStreamEvent = b;
          var y = function (a) {
            function b(c) {
              return a.call(this, null, g.class_id_t.MediaDeviceInfo, c, p.ProxyMode.Remote) || this;
            }
            e(b, a);
            b.prototype.convertKind = function (a) {
              return 0 == a ? "audioinput" : 1 == a ? "audiooutput" : "videoinput";
            };
            b.prototype.syncBarrier = function () {
              var a = this;
              f.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("RemoteDeviceInfo.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, g.method_id_MediaDeviceInfo_t.deviceId, ""), a.remoteInvoke(!1, g.method_id_MediaDeviceInfo_t.kind, 0), a.remoteInvoke(!1, g.method_id_MediaDeviceInfo_t.label, ""), a.remoteInvoke(!1, g.method_id_MediaDeviceInfo_t.groupId, "")]);
                }).then(function (c) {
                  a.kind = a.convertKind(a.param0(c.splice(1, 1)[0]));
                  c = c.map(function (b) {
                    return a.param0(b);
                  });
                  a.deviceId = c[0];
                  a.label = c[1];
                  a.groupId = c[2];
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  c(b);
                });
              });
            };
            return b;
          }(p.ProxyObject);
          a.RemoteDeviceInfo = y;
          b = function (b) {
            function c() {
              var a = b.call(this, null, g.class_id_t.MediaDevices, 0, p.ProxyMode.Local, function () {
                a.setDeviceChangeCallback();
              }) || this;
              a.devices_ = [];
              a.pendingEnumerateDevice_ = [];
              return a;
            }
            e(c, b);
            Object.defineProperty(c.prototype, "panelid", {
              set: function (a) {
                this.panelid_ = a;
              },
              enumerable: !0,
              configurable: !0
            });
            c.prototype.clearPanelId = function () {
              this.panelid_ = -1;
            };
            c.prototype.enumerateDevices = function () {
              var a = this;
              return 0 < this.devices_.length && 0 == this.pendingEnumerateDevice_.length ? new Promise(function (b, c) {
                f.logger.log(a.user_friendly_id() + ".enumerateDevices: returning cached devices with ids [" + a.devices_.map(function (a) {
                  return a.object_id();
                }) + "]");
                b(a.devices_);
              }) : this.enumerateDevicesPrivate(!1);
            };
            c.prototype.postEnumerateDevicesResult = function () {
              for (var a = !0, b = 0, c = 0, d = this.pendingEnumerateDevice_; c < d.length; c++) {
                var m = d[c];
                if (0 == a && "enumerateDevicesPrivate-remote" == m.name) break;
                m.postWithResult(!0, this.devices_);
                b++;
                a = !1;
              }
              0 < b && this.pendingEnumerateDevice_.splice(0, b);
            };
            c.prototype.enumerateDevicesPrivate = function (b) {
              var c = this;
              f.logger.log(this.user_friendly_id() + ".enumerateDevicesPrivate() called. refresh:" + b + " pending:" + this.pendingEnumerateDevice_.length);
              return new Promise(function (d, h) {
                1 == b || 0 == c.pendingEnumerateDevice_.length ? (c.pendingEnumerateDevice_.push(new p.deferred_action(d, h, "enumerateDevicesPrivate-remote")), c.waitUntilConnected("RemoteDevices.enumerateDevicesPrivate").then(function () {
                  f.logger.log(c.user_friendly_id() + ".enumerateDevicesPrivate() remote invoking...");
                  return c.remoteInvoke(!1, g.method_id_MediaDevices_t.enumerateDevices, []);
                }).then(function (a) {
                  var b = [];
                  a.params[0].forEach(function (a) {
                    var d = c.devices_.find(function (b) {
                      return b.object_id() === a.oid;
                    });
                    void 0 === d ? (d = new y(a.oid), b.push(d.syncBarrier())) : b.push(d);
                  });
                  return Promise.all(b);
                }).then(function (b) {
                  c.devices_.forEach(function (a) {
                    for (var c = !0, d = 0; d < b.length; d++) {
                      var q = b[d];
                      if (a.object_id() === q.object_id()) {
                        c = !1;
                        break;
                      }
                    }
                    c && a.release();
                  });
                  c.devices_ = b;
                  a.enumerateddecices = m = b;
                  f.logger.log(c.user_friendly_id() + ".enumerateDevicesPrivate: resolving enumerated devices with ids [" + b.map(function (a) {
                    return a.object_id();
                  }) + "]");
                  c.postEnumerateDevicesResult();
                })["catch"](function (b) {
                  c.devices_ = [];
                  a.enumerateddecices = m = [];
                  c.logRemoteInvokeError(b, ".enumerateDevicesPrivate() failed, resolving with empty list.");
                  c.postEnumerateDevicesResult();
                })) : (c.pendingEnumerateDevice_.push(new p.deferred_action(d, h, "enumerateDevicesPrivate")), f.logger.log(c.user_friendly_id() + ".enumerateDevicesPrivate() not remoting this call..."));
              });
            };
            c.prototype.getDisplayMedia = function (a) {
              var b = this;
              return new Promise(function (c, d) {
                b.waitUntilConnected("RemoteDevices.getDisplayMedia").then(function () {
                  return b.IsPanelIdValid();
                }).then(function () {
                  void 0 !== a.video && null !== a.video && void 0 !== b.panelid_ && (a.video.deviceId = b.panelid_);
                  var c = b.prepareDisplayConstraints(a);
                  return b.remoteInvoke(!1, g.method_id_MediaDevices_t.getDisplayMedia, c);
                }).then(function (a) {
                  return new A(null, a.params[0].oid, p.ProxyMode.Remote).syncBarrier();
                }).then(function (a) {
                  c(a);
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".getDisplayMedia() failed!");
                  d(a);
                });
              });
            };
            c.prototype.setDeviceChangeCallback = function () {
              var a = this;
              f.logger.log(this.user_friendly_id() + ".set_DeviceChangeCallback() called.");
              this.waitUntilConnected("MediaDevices.ondevicechange").then(function () {
                var b = a.registerCallbacks(!1, !1, g.method_id_MediaDevices_t.ondevicechange);
                b.then(function () {
                  f.logger.log(a.user_friendly_id() + ".ondevicechange(): callback received!!!");
                  a.enumerateDevicesPrivate(!0).then(function () {
                    navigator.mediaDevices.dispatchEvent(new CustomEvent("devicechange"));
                  })["catch"](function () {
                    navigator.mediaDevices.dispatchEvent(new CustomEvent("devicechange"));
                  });
                });
                return a.remoteInvoke(!0, g.method_id_MediaDevices_t.ondevicechange, b.success);
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".set_ondevicechange() failed!");
              });
            };
            c.prototype.prepareDisplayConstraints = function (a) {
              if (k.getRedirector().getFeatureValue(g.FEATURE_ms_teams_common_media_constraints)) return a;
              var b = {
                frameRate: 15,
                width: {
                  max: 1920
                },
                height: {
                  max: 1080
                }
              };
              void 0 !== a.video && null !== a.video && (a = a.video, void 0 !== a.frameRate && void 0 !== a.width && void 0 !== a.height && (b.frameRate = a.frameRate, b.width.max = a.width.max || a.width, b.height.max = a.height.max || a.height));
              return {
                video: b
              };
            };
            c.prototype.IsPanelIdValid = function () {
              var a = this;
              return new Promise(function (b, c) {
                if (-1 !== a.panelid_) f.logger.log(a.user_friendly_id() + ".IsPanelIdValid() resolving with panelid_:" + a.panelid_), b();else var d = 0,
                  m = setInterval(function () {
                    f.logger.log(a.user_friendly_id() + ".IsPanelIdValid() waiting panelid_:" + a.panelid_);
                    50 <= d ? (c(), clearInterval(m), f.logger.log(a.user_friendly_id() + ".IsPanelIdValid(): PanelId is invalid.")) : (++d, -1 != a.panelid_ && (b(), clearInterval(m), f.logger.log(a.user_friendly_id() + ".IsPanelIdValid(): PanelId is valid.")));
                  }, 10);
              });
            };
            return c;
          }(p.ProxyObject);
          a.RemoteDevices = b;
          b = function (a) {
            function b() {
              return a.call(this, null, g.class_id_t.NavigatorUserMedia, 0, p.ProxyMode.Local) || this;
            }
            e(b, a);
            b.getCapabilities = function (a) {
              f.logger.log(this.constructor.name + ".getCapabilities() called:" + a + " caps:" + b.caps_);
              return b.caps_[a];
            };
            b.resetcaps = function () {
              b.caps_ = {};
            };
            b.prototype.getCapabilities = function () {
              var a = this;
              f.logger.log(this.user_friendly_id() + ".getCapabilities() called: ");
              return new Promise(function (c, d) {
                a.waitUntilConnected(a.user_friendly_id() + ".getCapabilities").then(function () {
                  return Promise.all([a.remoteInvoke(!1, g.method_id_NavigatorUserMedia_t.getCapabilities, "audio"), a.remoteInvoke(!1, g.method_id_NavigatorUserMedia_t.getCapabilities, "video")]);
                }).then(function (d) {
                  b.caps_.audio = a.param0(d[0]);
                  b.caps_.video = a.param0(d[1]);
                  c(b.caps_);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".getCapabilities() failed!");
                  d(b);
                });
              });
            };
            b.prototype.setCodecCapabilities = function (a) {
              var b = this;
              f.logger.log(this.user_friendly_id() + ".setCodecCapabilities : set codecCapabilities to " + JSON.stringify(a));
              return new Promise(function (c, d) {
                b.waitUntilConnected("NavigatorUserMedia.setCodecCapabilities").then(function () {
                  return b.remoteInvoke(!1, g.method_id_NavigatorUserMedia_t.setCodecCapabilities, a);
                }).then(function () {
                  f.logger.log(b.user_friendly_id() + ".setCodecCapabilities() success.");
                  c(!0);
                  b.getCapabilities();
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".setCodecCapabilities() failed!");
                  d(a);
                });
              });
            };
            b.prototype.webkitGetUserMedia = function (a, b, c) {
              return this.getUserMedia(a, b, c);
            };
            b.prototype.LogTelemetryDevice_ = function (a) {
              try {
                if ("undefined" !== typeof a.audio) {
                  var b = a.audio.deviceId,
                    c;
                  m.forEach(function (a) {
                    b == a.deviceId && (c = a.label);
                  });
                  f.logger.log(c);
                  this.SendTelemetryData(x.tel_key_AudioDeviceUsed, c, 0);
                }
                if ("undefined" !== typeof a.video) {
                  var d = a.video.mandatory.sourceId,
                    h;
                  m.forEach(function (a) {
                    d == a.deviceId && (h = a.label);
                  });
                  f.logger.log(h);
                  this.SendTelemetryData(x.tel_key_VideoDeviceUsed, h, 0);
                }
              } catch (l) {
                f.logger.log(l);
              }
            };
            b.prototype.getUserMedia = function (a, b, c) {
              f.logger.log(this.user_friendly_id() + ".getUserMedia() called: " + JSON.stringify(a));
              return b && c ? this.getUserMedia_v1(a, b, c) : this.getUserMedia_v2(a);
            };
            b.prototype.getUserMedia_v2 = function (a) {
              var b = this;
              f.logger.log(this.user_friendly_id() + ".getUserMedia_v2() called: " + JSON.stringify(a));
              return new Promise(function (c, d) {
                b.getUserMediaPrivate(a, function (a) {
                  f.logger.log(b.user_friendly_id() + "getUserMedia_v2: resolving stream");
                  c(a);
                }, function (a) {
                  f.logger.log(b.user_friendly_id() + "getUserMedia_v2: rejecting stream");
                  d(a);
                });
              });
            };
            b.prototype.getUserMedia_v1 = function (a, b, c) {
              f.logger.log(this.user_friendly_id() + ".getUserMedia_v1() called: " + JSON.stringify(a));
              return this.getUserMediaPrivate(a, b, c);
            };
            b.prototype.getUserMediaPrivate = function (a, b, c) {
              var d = this;
              this.waitUntilConnected("NavigatorUserMedia.getUserMediaPrivate").then(function () {
                var b = d.registerCallbacks(!0, !1, g.method_id_NavigatorUserMedia_t.getUserMedia);
                a && "undefined" !== typeof a.audio && 0 == Object.keys(a.audio).length && (a.audio = {
                  dummy: 1
                });
                if (a && "undefined" !== typeof a.video) {
                  var c = a.video;
                  void 0 == c.mandatory.maxFrameRate && (c.mandatory.maxFrameRate = 30);
                  void 0 == c.mandatory.minWidth && (c.mandatory.minWidth = 360);
                  void 0 == c.mandatory.maxWidth && (c.mandatory.maxWidth = 1920);
                  void 0 == c.mandatory.minHeight && (c.mandatory.minHeight = 180);
                  void 0 == c.mandatory.maxHeight && (c.mandatory.maxHeight = 1080);
                }
                d.remoteInvoke(!1, g.method_id_NavigatorUserMedia_t.getUserMedia, a, b.success, b.fail);
                return b.prom();
              }).then(function (a) {
                f.logger.log(d.user_friendly_id() + ".getUserMediaPrivate: received success callback!");
                return new A(null, d.param0(a).oid, p.ProxyMode.Remote).syncBarrier();
              }).then(function (m) {
                f.logger.log(d.user_friendly_id() + ".getUserMediaPrivate: MediaStream ready to deliver", JSON.stringify(m));
                0 == m.getTracks().length ? (f.logger.log(d.user_friendly_id() + ".getUserMediaPrivate: reporting no tracks as error."), c({
                  constraintName: "",
                  name: "OverconstrainedError",
                  message: ""
                })) : (d.LogTelemetryDevice_(a), b(m));
              })["catch"](function (a) {
                d.logRemoteInvokeError(a, ".getUserMediaPrivate() failed!");
                k.getRedirector().getFeatureValue(g.FEATURE_ms_teams_1912) ? d.param0 && a ? c(d.param0(a)) : c({
                  constraintName: "",
                  name: "OverconstrainedError",
                  message: ""
                }) : c({
                  constraintName: "",
                  name: "OverconstrainedError",
                  message: ""
                });
              });
            };
            b.prototype.SendTelemetryData = function (a, b, c) {
              k.getRedirector().telemetry.SendTelemetryData(x.tel_cmd.Data, a, b, c);
            };
            b.caps_ = {};
            return b;
          }(p.ProxyObject);
          a.NavigatorUserMedia = b;
        },
        650: function (b, a, c) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var d = c(946),
            e = c(550),
            r = c(9),
            n = c(851),
            g = c(550),
            p = c(394),
            f;
          (function (a) {
            a[a.Unknown = 0] = "Unknown";
            a[a.Windows = 1] = "Windows";
            a[a.Linux = 2] = "Linux";
          })(f = a.RemoteType || (a.RemoteType = {}));
          var k = function () {
            return function () {};
          }();
          a.SessionInfo = k;
          b = function () {
            function a() {
              var b = this;
              this.isremote_ = !1;
              this.isremote_ = !0;
              this.type_ = f.Windows;
              this.address_ = "0.0.0.0";
              this.sessioninfo_ = null;
              d.getRedirector().setRemoteSessionInfoCb(function () {
                return b.remoteSessionInfo();
              });
              this.enginecontrol_ = new r.EngineControl();
            }
            a.prototype.release = function () {
              d.getRedirector().setRemoteSessionInfoCb(null);
            };
            a.prototype.user_friendly_id = function () {
              return "[RemoteSession]";
            };
            a.prototype.getFeatureFlags = function () {
              var a = {};
              null !== this.enginecontrol_ && null !== this.enginecontrol_.features_ && void 0 !== this.enginecontrol_.features_ && this.enginecontrol_.features_.forEach(function (b) {
                a[b.name] = b.value;
              });
              return a;
            };
            a.prototype.isFeatureSupported = function (a) {
              if ("video" === a) return !0;
              if (!(a in g.featureNameMap)) return !1;
              a = g.featureNameMap[a];
              for (var b = this.getFeatureFlags(), c = 0; c < a.length; c++) if (!(a[c] in b) || !0 !== b[a[c]]) return !1;
              return !0;
            };
            a.isFeaturePstnSupported = function () {
              return a.pstn_;
            };
            a.isFeatureDtmfSupported = function () {
              return a.dtmfswitch_;
            };
            a.isFeaturAppshareSupported = function () {
              return a.appshare_;
            };
            a.isFeatureWebrtc1dot0Supported = function () {
              return a.webrtc1dot0_;
            };
            a.isFeatureDataChannelSupported = function () {
              return a.datachannel_;
            };
            a.isFeatureVdNoBufferLimitSupported = function () {
              return a.vdnobuflimit_;
            };
            a.prototype.getSessionInfo = function () {
              n.logger.log(this.user_friendly_id() + ".getSessionInfo() called.");
              return null != this.sessioninfo_ ? Promise.resolve(this.sessioninfo_) : Promise.reject();
            };
            a.prototype.remoteSessionInfo = function () {
              var b = this,
                c = this;
              n.logger.log(c.user_friendly_id() + ".remoteSessionInfo() called.");
              return new Promise(function (g, f) {
                c.enginecontrol_.syncBarrier().then(function (d) {
                  n.logger.log(c.user_friendly_id() + "enginecontrol info received!");
                  c.sessioninfo_ = new k();
                  c.sessioninfo_.type_script = e.HDXMS_VERSION;
                  c.sessioninfo_.webrpc = d.version_.major.toString() + "." + d.version_.minor.toString() + "." + d.version_.revision.toString() + "." + d.version_.build.toString();
                  if (void 0 != d.versions_ && null != d.versions_) {
                    c.SendTelemetryData(p.tel_key_VerTypeScript, e.HDXMS_VERSION, 0);
                    for (var f = 0, t = 0, E = d.versions_; t < E.length; t++) {
                      var u = E[t],
                        u = u.major.toString() + "." + u.minor.toString() + "." + u.revision.toString() + "." + u.build.toString();
                      switch (f) {
                        case r.VersionType.Webrpc:
                          c.sessioninfo_.webrpc = u;
                          c.SendTelemetryData(p.tel_key_VerWebrpc, u, 0);
                          break;
                        case r.VersionType.WebrtcCodecs:
                          c.sessioninfo_.webrtc_codecs = u;
                          c.SendTelemetryData(p.tel_key_VerWebrtcCodecs, u, 0);
                          break;
                        case r.VersionType.Receiver:
                          c.sessioninfo_.receiver = u;
                          c.SendTelemetryData(p.tel_key_VerReceiver, u, 0);
                          break;
                        case r.VersionType.Vda:
                          c.sessioninfo_.vda = u;
                          c.SendTelemetryData(p.tel_key_VerVda, u, 0);
                          break;
                        case r.VersionType.Endpoint:
                          c.sessioninfo_.endpoint = u;
                          c.SendTelemetryData(p.tel_key_VerEndpoint, u, 0);
                          break;
                        default:
                          n.logger.log(c.user_friendly_id() + "Unknown version type!");
                      }
                      f++;
                    }
                  }
                  void 0 != d.osinfo_ && null != d.osinfo_ && (c.sessioninfo_.osinfo = d.osinfo_, d.osinfo_.family.includes("Darwin") && d.osinfo_.edition.includes("Mac") ? c.sessioninfo_.clientPlatform = "Mac" : c.sessioninfo_.clientPlatform = d.osinfo_.family, c.SendTelemetryData(p.tel_key_OSFamily, d.osinfo_.family, 0), c.SendTelemetryData(p.tel_key_OSVersion, d.osinfo_.version, 0), c.SendTelemetryData(p.tel_key_OSArchitecture, d.osinfo_.architecture, 0), c.SendTelemetryData(p.tel_key_OSDistro, d.osinfo_.distro, 0), c.SendTelemetryData(p.tel_key_OSEdition, d.osinfo_.edition, 0));
                  void 0 != d.endpointid_ && null != d.endpointid_ && (c.sessioninfo_.endpointId = d.endpointid_.machine_id);
                  a.pstn_ = b.isFeatureSupported(e.Features.FEATURE_public_pstn);
                  a.dtmfswitch_ = b.isFeatureSupported(e.Features.FEATURE_public_dtmf);
                  a.appshare_ = b.isFeatureSupported(e.Features.FEATURE_public_app_sharing);
                  a.webrtc1dot0_ = b.isFeatureSupported(e.Features.FEATURE_public_webrtc1dot0);
                  a.datachannel_ = b.isFeatureSupported(e.Features.FEATURE_public_data_channel);
                  a.vdnobuflimit_ = b.isFeatureSupported(e.Features.FEATURE_public_vdnobuflimit);
                  g(c.sessioninfo_);
                  c.enginecontrol_.release();
                })["catch"](function () {
                  d.getRedirector().isPingActive() ? c.retrySessionInfo() : (f(), c.enginecontrol_.release(), c.enginecontrol_ = null);
                });
              });
            };
            a.prototype.retrySessionInfo = function () {
              var a = this;
              setTimeout(function () {
                n.logger.log("checking if we are connected...");
                a.enginecontrol_.bind();
                d.getRedirector().handleRemoteSessionInfo();
              }, 15E3);
            };
            a.prototype.SendTelemetryData = function (a, b, c) {
              d.getRedirector().telemetry.SendTelemetryData(p.tel_cmd.Data, a, b, c);
            };
            a.pstn_ = !1;
            a.dtmfswitch_ = !1;
            a.appshare_ = !1;
            a.webrtc1dot0_ = !1;
            a.datachannel_ = !1;
            a.vdnobuflimit_ = !1;
            return a;
          }();
          a.RemoteSession = b;
        },
        24: function (b, a, c) {
          var d = this && this.__extends || function () {
            var a = function (b, c) {
              a = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (a, b) {
                a.__proto__ = b;
              } || function (a, b) {
                for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
              };
              return a(b, c);
            };
            return function (b, c) {
              function d() {
                this.constructor = b;
              }
              a(b, c);
              b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
            };
          }();
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var e = c(658),
            r = c(550),
            n = c(851),
            g = c(589),
            p;
          (function (a) {
            a[a["new"] = 0] = "new";
            a[a.connecting = 1] = "connecting";
            a[a.connected = 2] = "connected";
            a[a.closed = 3] = "closed";
            a[a.max = 4] = "max";
          })(p || (p = {}));
          b = function (a) {
            function b(c, d) {
              var g = a.call(this, c, r.class_id_t.RTCSctpTransport, d, e.ProxyMode.Remote) || this;
              n.logger.log(g.user_friendly_id() + ".constructor");
              return g;
            }
            d(b, a);
            b.prototype.syncBarrier = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("RTCSctpTransport.syncBarrier").then(function () {
                  n.logger.log(a.user_friendly_id() + ".syncBarrierBase success.");
                  return Promise.all([a.remoteInvoke(!1, r.method_id_RTCSctpTransport_t.transport, {}), a.remoteInvoke(!1, r.method_id_RTCSctpTransport_t.state, ""), a.remoteInvoke(!1, r.method_id_RTCSctpTransport_t.maxMessageSize, 0), a.remoteInvoke(!1, r.method_id_RTCSctpTransport_t.maxChannels, 0)]);
                }).then(function (c) {
                  var d;
                  d = c.map(function (b) {
                    return a.param0(b);
                  });
                  c = d[0];
                  a.sctpstate_ = d[1];
                  a.maxMessageSize_ = d[2];
                  a.maxChannels_ = d[3];
                  d = a.transport_;
                  void 0 == c || !1 !== c.is_null || null !== a.transport_ && a.transport_.object_id() == c.oid || (d = new g.DtlsTransport(a, c.oid));
                  d.syncBarrier().then(function (c) {
                    n.logger.log(a.user_friendly_id() + "transport.syncBarrier(): success");
                    a.transport_ = c;
                    b(a);
                  })["catch"](function () {
                    n.logger.log(a.user_friendly_id() + "transport.syncBarrier(): failed!");
                    a.transport_ = null;
                    b(a);
                  });
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  c(b);
                });
              });
            };
            Object.defineProperty(b.prototype, "transport", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_transport() called: " + this.transport_);
                return this.transport_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "state", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_state() called: " + this.sctpstate_);
                return this.sctpstate_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "maxMessageSize", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_maxMessageSize() called: " + this.maxMessageSize_);
                return this.maxMessageSize_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "maxChannels", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_maxChannels() called: " + this.maxChannels_);
                return this.maxChannels_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onstatechange", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onstatechange() called: " + this.onstatechange_);
                return this.onstatechange_;
              },
              set: function (a) {
                var c = this;
                n.logger.log(this.user_friendly_id() + ".set_onstatechange() called.");
                this.onstatechange_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onstatechange").then(function () {
                  var d = c.registerCallbacks(!1, c.isNullCallback(a), r.method_id_RTCSctpTransport_t.onstatechange);
                  d.then(function (a) {
                    n.logger.log(c.user_friendly_id() + ".onstatechange callback received!!!");
                    c.sctpstate_ = b.convertState(c.param0(a));
                    n.logger.log(c.user_friendly_id() + "sctpstate_: " + c.sctpstate_);
                    a = new Event("onstatechange");
                    c.onstatechange_(a);
                  });
                  return c.remoteInvoke(!0, r.method_id_RTCSctpTransport_t.onstatechange, d.success);
                })["catch"](function () {
                  n.logger.log(c.user_friendly_id() + ".onstatechange() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.convertState = function (a) {
              return a == p["new"] ? "closed" : a == p.connecting ? "connecting" : a == p.connected ? "connected" : "closed";
            };
            return b;
          }(e.ProxyObject);
          a.RTCSctpTransport = b;
          var f;
          (function (a) {
            a[a.connecting = 0] = "connecting";
            a[a.open = 1] = "open";
            a[a.closing = 2] = "closing";
            a[a.closed = 3] = "closed";
          })(f || (f = {}));
          b = function (a) {
            function b(c, d, g) {
              c = a.call(this, c, r.class_id_t.RTCDataChannel, d, g) || this;
              c.binaryType_ = "blob";
              n.logger.log(c.user_friendly_id() + ".constructor");
              return c;
            }
            d(b, a);
            b.prototype.syncBarrier = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("RtcDataChannel.syncBarrier").then(function () {
                  n.logger.log(a.user_friendly_id() + ".syncBarrier remote invoking.");
                  return Promise.all([a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.label, ""), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.ordered, !0), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.maxPacketLifeTime, 0), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.maxRetransmits, 0), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.protocol, ""), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.negotiated, !1), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.id, 0), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.readyState, ""), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.bufferedAmount, 0), a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.bufferedAmountLowThreshold, 0)]);
                }).then(function (c) {
                  n.logger.log(a.user_friendly_id() + ".syncBarrier success.");
                  var d;
                  c = c.map(function (b) {
                    return a.param0(b);
                  });
                  a.label_ = c[0];
                  a.ordered_ = c[1];
                  a.maxPacketLifeTime_ = c[2];
                  a.maxRetransmits_ = c[3];
                  a.protocol_ = c[4];
                  a.negotiated_ = c[5];
                  a.id_ = c[6];
                  d = c[7];
                  a.bufferedAmount_ = c[8];
                  a.bufferedAmountLowThreshold_ = c[9];
                  a.readyState_ = a.toRTCDataChannelState(d);
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  c(b);
                });
              });
            };
            Object.defineProperty(b.prototype, "label", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_label() called: " + this.label_);
                return this.label_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "ordered", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_ordered() called: " + this.ordered_);
                return this.ordered_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "maxPacketLifeTime", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_maxPacketLifeTime() called: " + this.maxPacketLifeTime_);
                return this.maxPacketLifeTime_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "maxRetransmits", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_maxRetransmits() called: " + this.maxRetransmits_);
                return this.maxRetransmits_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "protocol", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_protocol() called: " + this.protocol_);
                return this.protocol_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "negotiated", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_negotiated() called: " + this.negotiated_);
                return this.negotiated_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "id", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_id() called: " + this.id_);
                return this.id_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "readyState", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_readyState() called: " + this.readyState_);
                return this.readyState_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "bufferedAmount", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_bufferedAmount() called: " + this.bufferedAmount_);
                return this.bufferedAmount_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "bufferedAmountLowThreshold", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_bufferedAmountLowThreshold() called: " + this.bufferedAmountLowThreshold_);
                return this.bufferedAmountLowThreshold_;
              },
              set: function (a) {
                n.logger.log(this.user_friendly_id() + ".get_bufferedAmountLowThreshold() called: " + a);
                this.bufferedAmountLowThreshold_ = a;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "binaryType", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_binaryType() called: " + this.binaryType_);
                return this.binaryType_;
              },
              set: function (a) {
                n.logger.log(this.user_friendly_id() + ".set_binaryType() called: " + a);
                this.binaryType_ = "blob" == a || "arraybuffer" == a ? a : "blob";
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onopen", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onopen() called.");
                return this.onopen_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_onopen() called.");
                this.onopen_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onopen").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), r.method_id_RTCDataChannel_t.onopen);
                  c.then(function (a) {
                    n.logger.log(b.user_friendly_id() + ".onopen callback received!!!");
                    b.syncBarrier().then(function () {
                      n.logger.log(b.user_friendly_id() + ".onopen notifying...");
                      var a = new Event("open", {});
                      Object.defineProperty(a, "target", {
                        writable: !1,
                        value: b
                      });
                      b.onopen_(a);
                    })["catch"](function () {
                      n.logger.log(b.user_friendly_id() + ".syncBarrier(): failed!");
                    });
                  });
                  return b.remoteInvoke(!0, r.method_id_RTCDataChannel_t.onopen, c.success);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".onopen() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onbufferedamountlow", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onbufferedamountlow() called.");
                return this.onbufferedamountlow_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_onbufferedamountlow() called.");
                this.onbufferedamountlow_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onbufferedamountlow").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), r.method_id_RTCDataChannel_t.onbufferedamountlow);
                  c.then(function (a) {
                    n.logger.log(b.user_friendly_id() + ".onbufferedamountlow callback received!!!");
                    a = new Event("onbufferedamountlow");
                    Object.defineProperty(a, "target", {
                      writable: !1,
                      value: b
                    });
                    b.onbufferedamountlow_(a);
                  });
                  return b.remoteInvoke(!0, r.method_id_RTCDataChannel_t.onbufferedamountlow, c.success);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".onbufferedamountlows() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onerror", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onerror() called.");
                return this.onerror_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_onerror() called.");
                this.onerror_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onerror").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), r.method_id_RTCDataChannel_t.onerror);
                  c.then(function (a) {
                    n.logger.log(b.user_friendly_id() + ".onerror callback received!");
                    a = b.param0(a);
                    n.logger.log(b.user_friendly_id() + "error: " + a);
                    a = new Event("onerror");
                    Object.defineProperty(a, "target", {
                      writable: !1,
                      value: b
                    });
                    b.onerror_(a);
                  });
                  return b.remoteInvoke(!0, r.method_id_RTCDataChannel_t.onerror, c.success);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".onerror() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onclosing", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onclosing() called.");
                return this.onclosing_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_onclosing() called.");
                this.onclosing_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onclosing").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), r.method_id_RTCDataChannel_t.onclosing);
                  c.then(function (a) {
                    n.logger.log(b.user_friendly_id() + ".onclosing callback received!!!");
                    a = new Event("onclosing");
                    Object.defineProperty(a, "target", {
                      writable: !1,
                      value: b
                    });
                    b.onclosing_(a);
                  });
                  return b.remoteInvoke(!0, r.method_id_RTCDataChannel_t.onclosing, c.success);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".onclosing() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onclose", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onclose() called.");
                return this.onclose_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_onclose() called.");
                this.onclose_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onclose").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), r.method_id_RTCDataChannel_t.onclose);
                  c.then(function (a) {
                    n.logger.log(b.user_friendly_id() + ".onclose callback received!!!");
                    a = new Event("onclose");
                    Object.defineProperty(a, "target", {
                      writable: !1,
                      value: b
                    });
                    b.onclose_(a);
                  });
                  return b.remoteInvoke(!0, r.method_id_RTCDataChannel_t.onclose, c.success);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".onclose() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onmessage", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_onmessage() called.");
                return this.onmessage_;
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_onmessage() called.");
                this.onmessage_ = a;
                this.waitUntilConnected(this.user_friendly_id() + ".onmessage").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), r.method_id_RTCDataChannel_t.onmessage);
                  c.then(function (a) {
                    n.logger.log(b.user_friendly_id() + ".onmessage callback received!!!");
                    var c = b.param0(a);
                    a = new Event("onmessage");
                    c.binary ? a.data = c.data_ab : (c = atob(c.data_sz), a.data = c);
                    b.onmessage_(a);
                  });
                  return b.remoteInvoke(!0, r.method_id_RTCDataChannel_t.onmessage, c.success);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".onmessage() failed.");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.close = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".close() called.");
              this.waitUntilConnected("RTCDataChannel.close").then(function () {
                return a.remoteInvoke(!1, r.method_id_RTCDataChannel_t.close);
              }).then(function () {
                n.logger.log(a.user_friendly_id() + ".close: success.");
              })["catch"](function () {
                n.logger.log(a.user_friendly_id() + ".close: failed.");
              });
            };
            b.prototype.toByteArray = function (a) {
              var b = [];
              a = new Uint8Array(a instanceof ArrayBuffer ? a : a.buffer);
              for (var c in a) b.push(a[c]);
              return b;
            };
            b.prototype.send = function (a) {
              var b = this;
              n.logger.log(this.user_friendly_id() + ".send() called.");
              this.waitUntilConnected("RTCDataChannel.send").then(function () {
                if ("string" === typeof a) return n.logger.log(b.user_friendly_id() + "data(string): " + a), b.remoteInvoke(!1, r.method_id_RTCDataChannel_t.send_text, a);
                if (a instanceof Blob) a.arrayBuffer().then(function (a) {
                  a = b.toByteArray(a);
                  return b.remoteInvoke(!1, r.method_id_RTCDataChannel_t.send_binary, a);
                })["catch"](function () {
                  n.logger.log(b.user_friendly_id() + ".arrayBuffer(): failed.");
                });else {
                  var c = b.toByteArray(a);
                  return b.remoteInvoke(!1, r.method_id_RTCDataChannel_t.send_binary, c);
                }
              }).then(function () {
                n.logger.log(b.user_friendly_id() + ".send: success.");
              })["catch"](function () {
                n.logger.log(b.user_friendly_id() + ".send: failed.");
              });
            };
            b.prototype.toRTCDataChannelState = function (a) {
              var b = "closed";
              a == f.connecting ? b = "connecting" : a == f.open ? b = "open" : a == f.closing ? b = "closing" : a == f.closed && (b = "closed");
              return b;
            };
            return b;
          }(e.ProxyObject);
          a.RtcDataChannel = b;
        },
        589: function (b, a, c) {
          var d = this && this.__extends || function () {
              var a = function (b, c) {
                a = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (a, b) {
                  a.__proto__ = b;
                } || function (a, b) {
                  for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
                };
                return a(b, c);
              };
              return function (b, c) {
                function d() {
                  this.constructor = b;
                }
                a(b, c);
                b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
              };
            }(),
            e = this && this.__awaiter || function (a, b, c, d) {
              function g(a) {
                return a instanceof c ? a : new c(function (b) {
                  b(a);
                });
              }
              return new (c || (c = Promise))(function (c, q) {
                function l(a) {
                  try {
                    f(d.next(a));
                  } catch (b) {
                    q(b);
                  }
                }
                function h(a) {
                  try {
                    f(d["throw"](a));
                  } catch (b) {
                    q(b);
                  }
                }
                function f(a) {
                  a.done ? c(a.value) : g(a.value).then(l, h);
                }
                f((d = d.apply(a, b || [])).next());
              });
            },
            r = this && this.__generator || function (a, b) {
              function c(a) {
                return function (b) {
                  return d([a, b]);
                };
              }
              function d(c) {
                if (h) throw new TypeError("Generator is already executing.");
                for (; g;) try {
                  if (h = 1, f && (l = c[0] & 2 ? f["return"] : c[0] ? f["throw"] || ((l = f["return"]) && l.call(f), 0) : f.next) && !(l = l.call(f, c[1])).done) return l;
                  if (f = 0, l) c = [c[0] & 2, l.value];
                  switch (c[0]) {
                    case 0:
                    case 1:
                      l = c;
                      break;
                    case 4:
                      return g.label++, {
                        value: c[1],
                        done: !1
                      };
                    case 5:
                      g.label++;
                      f = c[1];
                      c = [0];
                      continue;
                    case 7:
                      c = g.ops.pop();
                      g.trys.pop();
                      continue;
                    default:
                      if (!(l = g.trys, l = 0 < l.length && l[l.length - 1]) && (6 === c[0] || 2 === c[0])) {
                        g = 0;
                        continue;
                      }
                      if (3 === c[0] && (!l || c[1] > l[0] && c[1] < l[3])) g.label = c[1];else if (6 === c[0] && g.label < l[1]) g.label = l[1], l = c;else if (l && g.label < l[2]) g.label = l[2], g.ops.push(c);else {
                        l[2] && g.ops.pop();
                        g.trys.pop();
                        continue;
                      }
                  }
                  c = b.call(a, g);
                } catch (q) {
                  c = [6, q], f = 0;
                } finally {
                  h = l = 0;
                }
                if (c[0] & 5) throw c[1];
                return {
                  value: c[0] ? c[1] : void 0,
                  done: !0
                };
              }
              var g = {
                  label: 0,
                  sent: function () {
                    if (l[0] & 1) throw l[1];
                    return l[1];
                  },
                  trys: [],
                  ops: []
                },
                h,
                f,
                l,
                e;
              $jscomp.initSymbol();
              $jscomp.initSymbol();
              $jscomp.initSymbolIterator();
              return e = {
                next: c(0),
                "throw": c(1),
                "return": c(2)
              }, "function" === typeof Symbol && (e[Symbol.iterator] = function () {
                return this;
              }), e;
            };
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var n = c(658),
            g = c(550),
            p = c(851),
            f = c(144),
            k = c(517),
            x = c(650),
            m = function (a) {
              function b(c, d) {
                var f = a.call(this, c, g.class_id_t.RTCDTMFToneChangeEvent, d, n.ProxyMode.Remote) || this;
                p.logger.log(f.user_friendly_id() + ".constructor");
                return f;
              }
              d(b, a);
              b.prototype.syncBarrier = function () {
                return e(this, void 0, void 0, function () {
                  var a,
                    b,
                    c = this;
                  return r(this, function (d) {
                    switch (d.label) {
                      case 0:
                        return p.logger.log(this.user_friendly_id() + ".syncBarrier() called."), [4, this.waitUntilConnected("DTMFToneChangeEvent.syncBarrier")];
                      case 1:
                        return d.sent(), [4, Promise.all([this.remoteInvoke(!1, g.method_id_RTCDTMFToneChangeEvent_t.tone, ""), this.remoteInvoke(!1, g.method_id_RTCDTMFToneChangeEvent_t.tone_buffer, "")])];
                      case 2:
                        return a = d.sent(), b = a.map(function (a) {
                          return c.param0(a);
                        }), this.tone = b[0], this.tone_buffer_ = b[1], [2, this];
                    }
                  });
                });
              };
              Object.defineProperty(b.prototype, "tone_buffer", {
                get: function () {
                  return this.tone_buffer_;
                },
                enumerable: !0,
                configurable: !0
              });
              return b;
            }(n.ProxyObject);
          a.DTMFToneChangeEvent = m;
          var D = function (a) {
            function b(c, d) {
              var f = a.call(this, c, g.class_id_t.RTCDTMFSender, d, n.ProxyMode.Remote) || this;
              p.logger.log(f.user_friendly_id() + ".constructor");
              f.canInsertDTMF = !0;
              f.toneBuffer_ = "";
              return f;
            }
            d(b, a);
            b.prototype.insertDTMF = function (a, b, c) {
              var d = this;
              void 0 === b && (b = 100);
              void 0 === c && (c = 70);
              p.logger.log(this.user_friendly_id() + ".insertDTMF() called, tones: " + a);
              this.waitUntilConnected("DtmfSender.insertDTMF").then(function () {
                return d.remoteInvoke(!1, g.method_id_RTCDTMFSender_t.insertDTMF, a, b, c);
              }).then(function () {
                p.logger.log(d.user_friendly_id() + ".insertDTMF() success, tones: " + a);
              })["catch"](function (a) {
                d.logRemoteInvokeError(a, ".insertDTMF() failed!");
              });
            };
            Object.defineProperty(b.prototype, "ontonechange", {
              get: function () {
                return this.ontonechange_;
              },
              set: function (a) {
                var b = this;
                p.logger.log(this.user_friendly_id() + ".set_ontonechange() called.");
                this.ontonechange_ = a;
                this.waitUntilConnected("DtmfSender.ontonechange").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), g.method_id_RTCDTMFSender_t.ontonechange);
                  c.then(function (a) {
                    p.logger.log(b.user_friendly_id() + ".ontonechange callback received!");
                    new m(b, b.param0(a).oid).syncBarrier().then(function (a) {
                      p.logger.log(b.user_friendly_id() + "tone: " + a.tone + " tone_buffer: " + a.tone_buffer);
                      b.toneBuffer_ = a.tone_buffer;
                      b.ontonechange_(a);
                    })["catch"](function (a) {
                      b.logRemoteInvokeError(a, ".toneEvt.syncBarrier() failed!");
                    });
                  });
                  return b.remoteInvoke(!0, g.method_id_RTCDTMFSender_t.ontonechange, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_ontonechange() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "toneBuffer", {
              get: function () {
                p.logger.log(this.user_friendly_id() + ".toneBuffer() called.");
                return this.toneBuffer_;
              },
              enumerable: !0,
              configurable: !0
            });
            return b;
          }(n.ProxyObject);
          a.DtmfSender = D;
          var B = function (a) {
            function b(c, d) {
              var f = a.call(this, c, g.class_id_t.RTCIceTransport, d, n.ProxyMode.Remote) || this;
              p.logger.log(f.user_friendly_id() + ".constructor");
              f.selectedPair = null;
              f.localCandidates_ = [];
              f.remoteCandidates_ = [];
              return f;
            }
            d(b, a);
            b.prototype.syncBarrier = function () {
              var a = this;
              p.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (c, d) {
                a.waitUntilConnected("IceTransport.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, g.method_id_RTCIceTransport_t.role, 0), a.remoteInvoke(!1, g.method_id_RTCIceTransport_t.component, 0), a.remoteInvoke(!1, g.method_id_RTCIceTransport_t.state, 0), a.remoteInvoke(!1, g.method_id_RTCIceTransport_t.gatheringState, 0)]);
                }).then(function (d) {
                  p.logger.log(a.user_friendly_id() + ".syncBarrier success.");
                  var g = 0,
                    l = 0;
                  d = d.map(function (b) {
                    return a.param0(b);
                  });
                  a.role_ = d[0];
                  a.component_ = d[1];
                  g = d[2];
                  l = d[3];
                  a.state_ = b.convertState(g);
                  a.gatheringState_ = b.convertGatheringState(l);
                  c(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  d(b);
                });
              });
            };
            b.prototype.syncCandidates = function () {
              var a = this;
              p.logger.log(this.user_friendly_id() + ".syncCandidates() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("IceTransport.syncCandidates").then(function () {
                  return Promise.all([a.remoteInvoke(!1, g.method_id_RTCIceTransport_t.localcandidates, []), a.remoteInvoke(!1, g.method_id_RTCIceTransport_t.remotecandidates, [])]);
                }).then(function (c) {
                  p.logger.log(a.user_friendly_id() + ".syncCandidates success.");
                  c = c.map(function (b) {
                    return a.param0(b);
                  });
                  a.localCandidates_ = c[0];
                  a.remoteCandidates_ = c[1];
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncCandidates() failed!");
                  c(b);
                });
              });
            };
            Object.defineProperty(b.prototype, "role", {
              get: function () {
                return this.role_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "component", {
              get: function () {
                return this.component_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "State", {
              get: function () {
                return this.state_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "gatheringState", {
              get: function () {
                return this.gatheringState_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onstatechange", {
              get: function () {
                return this.onstatechange_;
              },
              set: function (a) {
                var c = this;
                p.logger.log(this.user_friendly_id() + ".set_onstatechange() called.");
                this.onstatechange_ = a;
                this.waitUntilConnected("IceTransport.onstatechange").then(function () {
                  var d = c.registerCallbacks(!1, c.isNullCallback(a), g.method_id_RTCIceTransport_t.onstatechange);
                  d.then(function (a) {
                    p.logger.log(c.user_friendly_id() + ".onstatechange callback received!");
                    c.syncCandidates().then(function (a) {
                      p.logger.log(c.user_friendly_id() + "received updated ice candidates!");
                    });
                    c.state_ = b.convertState(c.param0(a));
                    p.logger.log(c.user_friendly_id() + "state: " + c.state_);
                    c.onstatechange_();
                  });
                  return c.remoteInvoke(!0, g.method_id_RTCIceTransport_t.onstatechange, d.success);
                })["catch"](function (a) {
                  c.logRemoteInvokeError(a, ".set_onstatechange failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "ongatheringstatechange", {
              get: function () {
                return this.ongatheringstatechange_;
              },
              set: function (a) {
                var c = this;
                p.logger.log(this.user_friendly_id() + ".set_ongatheringstatechange() called.");
                this.ongatheringstatechange_ = a;
                this.waitUntilConnected("IceTransport.ongatheringstatechange").then(function () {
                  var d = c.registerCallbacks(!1, c.isNullCallback(a), g.method_id_RTCIceTransport_t.ongatheringstatechange);
                  d.then(function (a) {
                    p.logger.log(c.user_friendly_id() + ".ongatheringstatechange callback received!");
                    c.syncCandidates().then(function (a) {
                      p.logger.log(c.user_friendly_id() + "received updated ice candidates!");
                    });
                    c.gatheringState_ = b.convertGatheringState(c.param0(a));
                    p.logger.log(c.user_friendly_id() + "gatheringState: " + c.gatheringState_);
                    c.ongatheringstatechange_();
                  });
                  return c.remoteInvoke(!0, g.method_id_RTCIceTransport_t.ongatheringstatechange, d.success);
                })["catch"](function (a) {
                  c.logRemoteInvokeError(a, ".set_ongatheringstatechange failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onselectedcandidatepairchange", {
              get: function () {
                return this.onselectedcandidatepairchange_;
              },
              set: function (a) {
                var b = this;
                p.logger.log(this.user_friendly_id() + ".set_onselectedcandidatepairchange() called.");
                this.onselectedcandidatepairchange_ = a;
                this.waitUntilConnected("IceTransport.onselectedcandidatepairchange").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), g.method_id_RTCIceTransport_t.onselectedcandidatepairchange);
                  c.then(function (a) {
                    p.logger.log(b.user_friendly_id() + ".onselectedcandidatepairchange callback received!");
                    b.syncCandidates().then(function (a) {
                      p.logger.log(b.user_friendly_id() + "received updated ice candidates!");
                    });
                    b.selectedPair = b.param0(a);
                    p.logger.log(b.user_friendly_id() + "selectedPair: " + b.selectedPair);
                    b.onselectedcandidatepairchange_();
                  });
                  return b.remoteInvoke(!0, g.method_id_RTCIceTransport_t.onselectedcandidatepairchange, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onselectedcandidatepairchange failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.getLocalCandidates = function () {
              return this.localCandidates_;
            };
            b.prototype.getRemoteCandidates = function () {
              return this.remoteCandidates_;
            };
            b.prototype.getLocalParameters = function () {
              return null;
            };
            b.prototype.getRemoteParameters = function () {
              return null;
            };
            b.prototype.getSelectedCandidatePair = function () {
              return this.selectedPair;
            };
            b.convertState = function (a) {
              return 0 == a ? "new" : 1 == a ? "checking" : 2 == a ? "connected" : 3 == a ? "completed" : 4 == a ? "failed" : 5 == a ? "disconnected" : "closed";
            };
            b.convertGatheringState = function (a) {
              return 0 == a ? "new" : 1 == a ? "gathering" : "complete";
            };
            return b;
          }(n.ProxyObject);
          a.IceTransport = B;
          var t;
          (function (a) {
            a[a["new"] = 0] = "new";
            a[a.connecting = 1] = "connecting";
            a[a.connected = 2] = "connected";
            a[a.closed = 3] = "closed";
            a[a.failed = 4] = "failed";
            a[a.max = 5] = "max";
          })(t || (t = {}));
          var h = function (a) {
            function b(c, d) {
              var f = a.call(this, c, g.class_id_t.RTCDtlsTransport, d, n.ProxyMode.Remote) || this;
              p.logger.log(f.user_friendly_id() + ".constructor");
              f.state_ = "new";
              f.transport_ = null;
              f.remoteCertificates_ = [];
              return f;
            }
            d(b, a);
            b.prototype.dumpInfo = function () {
              p.logger.log("DtlsTransport[" + this.object_id() + "].dumpInfo():");
              p.logger.log("    - state:" + this.state_);
              p.logger.log("    - transport:" + this.transport_);
            };
            b.prototype.syncBarrier = function () {
              var a = this;
              p.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (c, d) {
                a.waitUntilConnected("DtlsTransport.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, g.method_id_RTCDtlsTransport_t.transport, {}), a.remoteInvoke(!1, g.method_id_RTCDtlsTransport_t.state, 0), a.remoteInvoke(!1, g.method_id_RTCDtlsTransport_t.getRemoteCertificates, [])]);
                }).then(function (g) {
                  var f;
                  p.logger.log(a.user_friendly_id() + ".syncBarrier remote success.");
                  var l;
                  f = g.map(function (b) {
                    return a.param0(b);
                  });
                  g = f[0];
                  l = f[1];
                  a.remoteCertificates_ = f[2];
                  a.state_ = b.convertState(l);
                  f = [];
                  void 0 == g || 0 != g.is_null || null !== a.transport_ && a.transport_.object_id() == g.oid || (a.transport_ = new B(a, g.oid), f.push(a.transport_.syncBarrier()));
                  Promise.all(f).then(function () {
                    p.logger.log(a.user_friendly_id() + ".syncBarrier success");
                    c(a);
                  })["catch"](function (b) {
                    b = a.logRemoteInvokeError(b, ".prop.syncBarrier failed!");
                    d(b);
                  });
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier failed!");
                  d(b);
                });
              });
            };
            Object.defineProperty(b.prototype, "transport", {
              get: function () {
                return this.transport_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "state", {
              get: function () {
                p.logger.log(this.user_friendly_id() + ".get_state() called: " + this.state_);
                return this.state_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.getRemoteCertificates = function () {
              return this.remoteCertificates_;
            };
            Object.defineProperty(b.prototype, "onstatechange", {
              get: function () {
                return this.onstatechange_;
              },
              set: function (a) {
                var c = this;
                p.logger.log(this.user_friendly_id() + ".set_onstatechange() called.");
                this.onstatechange_ = a;
                this.waitUntilConnected("DtlsTransport.onstatechange").then(function () {
                  var d = c.registerCallbacks(!1, c.isNullCallback(a), g.method_id_RTCDtlsTransport_t.onstatechange);
                  d.then(function (a) {
                    p.logger.log(c.user_friendly_id() + ".onstatechange callback received!");
                    c.state_ = b.convertState(c.param0(a));
                    p.logger.log(c.user_friendly_id() + "state_: " + c.state_);
                    c.onstatechange_();
                  });
                  return c.remoteInvoke(!0, g.method_id_RTCDtlsTransport_t.onstatechange, d.success);
                })["catch"](function (a) {
                  c.logRemoteInvokeError(a, ".set_onstatechange failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onerror", {
              get: function () {
                return this.onerror_;
              },
              set: function (a) {
                var b = this;
                p.logger.log(this.user_friendly_id() + ".set_onerror() called.");
                this.onerror_ = a;
                this.waitUntilConnected("DtlsTransport.onerror").then(function () {
                  var c = b.registerCallbacks(!1, b.isNullCallback(a), g.method_id_RTCDtlsTransport_t.onerror);
                  c.then(function (a) {
                    p.logger.log(b.user_friendly_id() + ".onerror callback received!");
                    a = b.param0(a);
                    p.logger.log(b.user_friendly_id() + "error: " + a);
                    b.onerror_(a);
                  });
                  return b.remoteInvoke(!0, g.method_id_RTCDtlsTransport_t.onerror, c.success);
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_onerror failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            b.convertState = function (a) {
              return a == t["new"] ? "new" : a == t.connecting ? "connecting" : a == t.connected ? "connected" : a == t.closed ? "closed" : "failed";
            };
            return b;
          }(n.ProxyObject);
          a.DtlsTransport = h;
          b = function (a) {
            function b(c, d, g, f) {
              c = a.call(this, c, d, g, f) || this;
              p.logger.log(c.user_friendly_id() + ".constructor base");
              c.track_ = null;
              c.transport_ = null;
              c.rtcpTransport_ = null;
              return c;
            }
            d(b, a);
            b.prototype.syncBarrierBase = function () {
              var a = this;
              p.logger.log(this.user_friendly_id() + ".syncBarrierBase() called.");
              return new Promise(function (b, c) {
                var d, e, l;
                a instanceof A ? (d = g.method_id_RTCRtpSender_t.track, e = g.method_id_RTCRtpSender_t.transport, l = g.method_id_RTCRtpSender_t.rtcpTransport) : a instanceof y && (d = g.method_id_RTCRtpReceiver_t.track, e = g.method_id_RTCRtpReceiver_t.transport, l = g.method_id_RTCRtpReceiver_t.rtcpTransport);
                a.waitUntilConnected("RtpSenderReceiver.syncBarrierBase").then(function () {
                  return x.RemoteSession.isFeaturePstnSupported() && x.RemoteSession.isFeatureDtmfSupported() ? Promise.all([a.remoteInvoke(!1, d, {
                    oid: a.object_id()
                  }), a.remoteInvoke(!1, e, {
                    oid: a.object_id()
                  }), a.remoteInvoke(!1, l, {
                    oid: a.object_id()
                  })]) : Promise.all([a.remoteInvoke(!1, d, {
                    oid: a.object_id()
                  })]);
                }).then(function (d) {
                  var l;
                  p.logger.log(a.user_friendly_id() + ".syncBarrierBase remote success.");
                  var g;
                  l = d.map(function (b) {
                    return a.param0(b);
                  });
                  d = l[0];
                  g = l[1];
                  l = l[2];
                  var e = [];
                  void 0 != d && !1 === d.is_null && (null === a.track_ || a.track_.object_id() != d.oid ? a.track_ = new f.RemoteMediaTrack(a, d.oid) : a.track_.bind(a, d.oid), e.push(a.track.syncBarrier()));
                  void 0 == g || !1 !== g.is_null || null !== a.transport_ && a.transport_.object_id() == g.oid || (a.transport_ = new h(a, g.oid), e.push(a.transport_.syncBarrier()));
                  void 0 == l || !1 !== l.is_null || null !== a.rtcpTransport_ && a.rtcpTransport_.object_id() == l.oid || (a.rtcpTransport_ = new h(a, l.oid), e.push(a.rtcpTransport_.syncBarrier()));
                  Promise.all(e).then(function () {
                    p.logger.log(a.user_friendly_id() + ".prop.syncBarrierBase success");
                    b(a);
                  })["catch"](function (b) {
                    b = a.logRemoteInvokeError(b, ".prop.syncBarrierBase failed!");
                    c(b);
                  });
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrierBase() failed!");
                  c(b);
                });
              });
            };
            Object.defineProperty(b.prototype, "transport", {
              get: function () {
                p.logger.log(this.user_friendly_id() + ".get transport() called.");
                return this.transport_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "rtcpTransport", {
              get: function () {
                p.logger.log(this.user_friendly_id() + ".get rtcpTransport() called.");
                return this.rtcpTransport_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "track", {
              get: function () {
                return this.track_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.reinitTrack = function (a) {
              this.track_ = a;
            };
            b.prototype.getStats = function () {
              p.logger.log(this.user_friendly_id() + ".getStats() called.");
              var a = this;
              return new Promise(function (b, c) {
                var d = this;
                a.isRedirected() ? a.waitUntilConnected("RtpReceiver.getStats").then(function () {
                  var c;
                  d instanceof A ? c = g.method_id_RTCRtpSender_t.getStats : d instanceof y && (c = g.method_id_RTCRtpReceiver_t.getStats);
                  var l = a.registerCallbacks(!0, !1, c);
                  l.then(function (a) {
                    void 0 !== a.params && 0 !== a.params.length && b(k.StatsReport.fromJSON(JSON.parse(a.params[0])));
                  });
                  return a.remoteInvoke(!1, c, l.success);
                })["catch"](function (a) {
                  a = d.logRemoteInvokeError(a, ".getStats() failed!");
                  c(a);
                }) : (p.logger.log(a.user_friendly_id() + ".getStats(): not in active redirection!"), b());
              });
            };
            return b;
          }(n.ProxyObject);
          a.RtpSenderReceiver = b;
          var A = function (a) {
            function b(c, d, f, h) {
              c = a.call(this, c, g.class_id_t.RTCRtpSender, d, f) || this;
              p.logger.log(c.user_friendly_id() + ".constructor");
              c.dtmf_ = null;
              c.params_ = null;
              c.unified_ = h;
              return c;
            }
            d(b, a);
            b.prototype.dumpInfo = function () {
              p.logger.log("RtpSender[" + this.object_id() + "].dumpInfo():");
              this.track && this.track.dumpInfo();
            };
            b.prototype.syncBarrier = function () {
              var b = this;
              p.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (c, d) {
                b.waitUntilConnected("RtpSender.syncBarrier").then(function () {
                  return a.prototype.syncBarrierBase.call(b);
                }).then(function () {
                  p.logger.log(b.user_friendly_id() + ".syncBarrierBase success.");
                  return x.RemoteSession.isFeaturePstnSupported() && x.RemoteSession.isFeatureDtmfSupported() ? Promise.all([b.remoteInvoke(!1, g.method_id_RTCRtpSender_t.dtmf, {
                    oid: b.object_id()
                  }), b.remoteInvoke(!1, g.method_id_RTCRtpSender_t.getParameters, {
                    oid: b.object_id()
                  })]) : Promise.all([]);
                }).then(function (a) {
                  p.logger.log(b.user_friendly_id() + ".syncBarrier success.");
                  var d;
                  a = a.map(function (a) {
                    return b.param0(a);
                  });
                  d = a[0];
                  b.params_ = a[1];
                  void 0 == d || !1 !== d.is_null || null !== b.dtmf_ && b.dtmf_.object_id() == d.oid || (b.dtmf_ = new D(b, d.oid));
                  c(b);
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".syncBarrier failed!");
                  d(a);
                });
              });
            };
            b.getCapabilities = function (a) {
              p.logger.log(this.constructor.name + ".getCapabilities() called.");
              return f.NavigatorUserMedia.getCapabilities(a);
            };
            Object.defineProperty(b.prototype, "dtmf", {
              get: function () {
                p.logger.log(this.user_friendly_id() + ".get dtmf() called.");
                return this.dtmf_;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.setParameters = function (a) {
              var b = this;
              p.logger.log(this.user_friendly_id() + ".setParameters() called.");
              return new Promise(function (c, d) {
                b.waitUntilConnected("RtpSender.setParameters").then(function () {
                  return Promise.all([b.remoteInvoke(!1, g.method_id_RTCRtpSender_t.setParameters, a)]);
                }).then(function (d) {
                  p.logger.log(b.user_friendly_id() + ".setParameters(): success.");
                  c();
                  b.params_ = a;
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".setParameters() failed!");
                  d(a);
                });
              });
            };
            b.prototype.getParameters = function () {
              var a = this;
              p.logger.log(this.user_friendly_id() + ".getParameters() called.");
              this.waitUntilConnected(this.user_friendly_id() + ".getParameters").then(function () {
                p.logger.log(a.user_friendly_id() + ".getParameters() remote invoking");
                return a.remoteInvoke(!1, g.method_id_RTCRtpSender_t.getParameters, {
                  oid: a.object_id()
                });
              }).then(function (b) {
                p.logger.log(a.user_friendly_id() + ".getParameters() success");
                a.params_ = a.param0(b);
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".getParameters() failed!");
              });
              p.logger.log(this.user_friendly_id() + ".getParameters() returning: " + this.params_);
              return this.params_;
            };
            b.prototype.replaceTrack = function (a) {
              var b = this;
              p.logger.log(this.user_friendly_id() + ".replaceTrack() called. track_:" + this.track_ + ", withTrack:" + a);
              return new Promise(function (c, d) {
                b.waitUntilConnected("RtpSender.replaceTrack").then(function () {
                  if (a) return Promise.all([b.remoteInvoke(!1, g.method_id_RTCRtpSender_t.replaceTrack, {
                    oid: a.object_id()
                  })]);
                  if (b.unified_) return Promise.all([b.remoteInvoke(!1, g.method_id_RTCRtpSender_t.replaceTrack, {
                    oid: 0
                  })]);
                  p.logger.log(b.user_friendly_id() + ".replaceTrack(): failed with null track!");
                  d();
                }).then(function (d) {
                  p.logger.log(b.user_friendly_id() + ".replaceTrack(): success.");
                  c();
                  b.reinitTrack(a);
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".replaceTrack() failed!");
                  d(a);
                });
              });
            };
            return b;
          }(b);
          a.RtpSender = A;
          var y = function (a) {
            function b(c, d, f, h, e) {
              c = a.call(this, c, g.class_id_t.RTCRtpReceiver, d, f) || this;
              p.logger.log(c.user_friendly_id() + ".constructor");
              c.contribsources_ = [];
              c.syncsources_ = [];
              c.params_ = null;
              c.unified_ = h;
              e && (c.track_ = e);
              return c;
            }
            d(b, a);
            b.prototype.dumpInfo = function () {
              p.logger.log("RtpReceiver[" + this.object_id() + "].dumpInfo():");
              this.track && this.track.dumpInfo();
              this.transport && this.transport.dumpInfo();
            };
            b.prototype.syncBarrier = function () {
              var b = this;
              p.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (c, d) {
                b.waitUntilConnected("RtpReceiver.syncBarrier").then(function () {
                  return a.prototype.syncBarrierBase.call(b);
                }).then(function () {
                  p.logger.log(b.user_friendly_id() + ".syncBarrierBase success.");
                  return x.RemoteSession.isFeaturePstnSupported() && x.RemoteSession.isFeatureDtmfSupported() ? Promise.all([b.remoteInvoke(!1, g.method_id_RTCRtpReceiver_t.getContributingSources, []), b.remoteInvoke(!1, g.method_id_RTCRtpReceiver_t.getSynchronizationSources, []), b.remoteInvoke(!1, g.method_id_RTCRtpReceiver_t.getParameters, {
                    oid: b.object_id()
                  })]) : Promise.all([b.remoteInvoke(!1, g.method_id_RTCRtpReceiver_t.getContributingSources, [])]);
                }).then(function (a) {
                  p.logger.log(b.user_friendly_id() + ".syncBarrier success.");
                  a = a.map(function (a) {
                    return b.param0(a);
                  });
                  b.contribsources_ = a[0];
                  b.syncsources_ = a[1];
                  b.params_ = a[2];
                  c(b);
                })["catch"](function (a) {
                  a = b.logRemoteInvokeError(a, ".syncBarrier() failed!");
                  d(a);
                });
              });
            };
            b.getCapabilities = function (a) {
              p.logger.log(this.constructor.name + ".getCapabilities() called.");
              return f.NavigatorUserMedia.getCapabilities(a);
            };
            b.prototype.getContributingSources = function () {
              var a = this;
              p.logger.log(this.user_friendly_id() + ".getContributingSources() called. " + JSON.stringify(this.contribsources_));
              this.waitUntilConnected("RtpReceiver.getContributingSources").then(function () {
                return Promise.all([a.remoteInvoke(!1, g.method_id_RTCRtpReceiver_t.getContributingSources, [])]);
              }).then(function (b) {
                a.contribsources_ = b.map(function (b) {
                  return a.param0(b);
                })[0];
                p.logger.log(a.user_friendly_id(), ".getContributingSources() success: " + JSON.stringify(a.contribsources_));
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".getContributingSources() failed!");
                a.contribsources_ = [];
              });
              return this.contribsources_;
            };
            b.prototype.getParameters = function () {
              p.logger.log(this.user_friendly_id() + ".getParameters() called.");
              return this.params_;
            };
            b.prototype.getSynchronizationSources = function () {
              p.logger.log(this.user_friendly_id() + ".getSynchronizationSources() called.");
              return this.syncsources_;
            };
            return b;
          }(b);
          a.RtpReceiver = y;
        },
        377: function (b, a, c) {
          var d = this && this.__extends || function () {
            var a = function (b, c) {
              a = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (a, b) {
                a.__proto__ = b;
              } || function (a, b) {
                for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
              };
              return a(b, c);
            };
            return function (b, c) {
              function d() {
                this.constructor = b;
              }
              a(b, c);
              b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
            };
          }();
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var e = c(658),
            r = c(550),
            n = c(851),
            g = c(589);
          b = function () {
            function a() {
              this.direction = "sendrecv";
              this.sendEncodings = [];
              this.streams = [];
              n.logger.log(this.user_friendly_id() + ".constructor");
            }
            a.prototype.user_friendly_id = function () {
              return this.constructor.name;
            };
            return a;
          }();
          a.RtpTransceiverInit = b;
          var p;
          (function (a) {
            a[a.kSendRecv = 0] = "kSendRecv";
            a[a.kSendOnly = 1] = "kSendOnly";
            a[a.kRecvOnly = 2] = "kRecvOnly";
            a[a.kInactive = 3] = "kInactive";
          })(p || (p = {}));
          b = function (a) {
            function b(c, d, k, G, t, h) {
              c = a.call(this, c, r.class_id_t.RTCRtpTransceiver, d, k) || this;
              n.logger.log(c.user_friendly_id() + ".constructor");
              c.unified_ = G;
              c.sender_ = new g.RtpSender(c, 0, e.ProxyMode.Pseudo, G);
              c.receiver_ = h ? h : new g.RtpReceiver(c, 0, e.ProxyMode.Pseudo, G);
              t ? (c.direction_ = c.toRtpTransceiverDirection(t), c.currentDirection_ = c.toRtpTransceiverDirection(t)) : (c.direction_ = p.kSendRecv, c.currentDirection_ = p.kSendRecv);
              return c;
            }
            d(b, a);
            b.prototype.dumpInfo = function () {
              n.logger.log(this.user_friendly_id() + ".dumpInfo() [id=" + this.mid + "] direction=" + this.toRTCRtpTransceiverDirection(this.direction_), " currentDirection=" + this.toRTCRtpTransceiverDirection(this.currentDirection_));
              this.sender && this.sender.dumpInfo();
              this.receiver && this.receiver.dumpInfo();
            };
            b.prototype.syncBarrier = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".syncBarrier() called.");
              return new Promise(function (b, c) {
                a.waitUntilConnected("RtpTransceiver.syncBarrier").then(function () {
                  return Promise.all([a.remoteInvoke(!1, r.method_id_RTCRtpTransceiver_t.mid, {
                    oid: a.object_id()
                  }), a.remoteInvoke(!1, r.method_id_RTCRtpTransceiver_t.direction, {
                    oid: a.object_id()
                  }), a.remoteInvoke(!1, r.method_id_RTCRtpTransceiver_t.currentDirection, {
                    oid: a.object_id()
                  }), a.remoteInvoke(!1, r.method_id_RTCRtpTransceiver_t.sender, {
                    oid: a.object_id()
                  }), a.remoteInvoke(!1, r.method_id_RTCRtpTransceiver_t.receiver, {
                    oid: a.object_id()
                  })]);
                }).then(function (c) {
                  var d;
                  n.logger.log(a.user_friendly_id() + ".syncBarrier remote success.");
                  d = c.map(function (b) {
                    return a.param0(b);
                  });
                  a.mid_ = d[0];
                  a.direction_ = d[1];
                  a.currentDirection_ = d[2];
                  c = d[3];
                  d = d[4];
                  var g = [];
                  void 0 != c && !1 === c.is_null && (a.sender_.bind(a, c.oid), g.push(a.sender_.syncBarrier()));
                  void 0 != d && !1 === d.is_null && (a.receiver_.bind(a, d.oid), g.push(a.receiver_.syncBarrier()));
                  if (0 == g.length) n.logger.log(a.user_friendly_id() + ".syncBarrier success"), b(a);else return n.logger.log(a.user_friendly_id() + ".prop.syncBarrier start"), Promise.all(g);
                }).then(function () {
                  n.logger.log(a.user_friendly_id() + ".syncBarrier success");
                  b(a);
                })["catch"](function (b) {
                  b = a.logRemoteInvokeError(b, ".syncBarrier() failed!");
                  c(b);
                });
              });
            };
            Object.defineProperty(b.prototype, "mid", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_mid() called: " + this.mid_);
                return this.mid_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "sender", {
              get: function () {
                return this.sender_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "receiver", {
              get: function () {
                return this.receiver_;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "direction", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_direction() called. " + this.toRTCRtpTransceiverDirection(this.direction_));
                return this.toRTCRtpTransceiverDirection(this.direction_);
              },
              set: function (a) {
                var b = this;
                n.logger.log(this.user_friendly_id() + ".set_direction() called. " + a);
                this.direction_ = this.toRtpTransceiverDirection(a);
                this.waitUntilConnected("RtpTransceiver.set_direction").then(function () {
                  return b.remoteInvoke(!0, r.method_id_RTCRtpTransceiver_t.direction, b.toRtpTransceiverDirection(a));
                }).then(function () {
                  n.logger.log(b.user_friendly_id() + ".set_direction: success.");
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_direction() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "currentDirection", {
              get: function () {
                n.logger.log(this.user_friendly_id() + ".get_currentDirection() called. " + this.toRTCRtpTransceiverDirection(this.direction_));
                return this.toRTCRtpTransceiverDirection(this.currentDirection_);
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.stop = function () {
              var a = this;
              n.logger.log(this.user_friendly_id() + ".stop() called.");
              this.waitUntilConnected("RtpTransceiver.stop").then(function () {
                return a.remoteInvoke(!0, r.method_id_RTCRtpTransceiver_t.stop);
              }).then(function () {
                n.logger.log(a.user_friendly_id() + ".stop: success.");
              })["catch"](function (b) {
                a.logRemoteInvokeError(b, ".stop() failed!");
              });
            };
            b.prototype.setCodecPreferences = function (a) {
              var b = this;
              n.logger.log(this.user_friendly_id() + ".setCodecPreferences() called.");
              this.waitUntilConnected("RtpTransceiver.setCodecPreferences").then(function () {
                return b.remoteInvoke(!0, r.method_id_RTCRtpTransceiver_t.setCodecPreferences, a);
              }).then(function () {
                n.logger.log(b.user_friendly_id() + ".setCodecPreferences: success.");
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, ".setCodecPreferences() failed!");
              });
            };
            b.prototype.toRtpTransceiverDirection = function (a) {
              var b = p.kSendRecv;
              switch (a) {
                case "inactive":
                  b = p.kInactive;
                  break;
                case "recvonly":
                  b = p.kRecvOnly;
                  break;
                case "sendonly":
                  b = p.kSendOnly;
                  break;
                case "sendrecv":
                  b = p.kSendRecv;
                  break;
                default:
                  b = p.kInactive;
              }
              return b;
            };
            b.prototype.toRTCRtpTransceiverDirection = function (a) {
              var b = "sendrecv";
              switch (a) {
                default:
                  b = "inactive";
                  break;
                case p.kRecvOnly:
                  b = "recvonly";
                  break;
                case p.kSendOnly:
                  b = "sendonly";
                  break;
                case p.kSendRecv:
                  b = "sendrecv";
              }
              return b;
            };
            return b;
          }(e.ProxyObject);
          a.RtpTransceiver = b;
        },
        509: function (b, a) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          (function (a) {
            a[a.Unknown = 0] = "Unknown";
            a[a.Cap = 1] = "Cap";
            a[a.GetSources = 2] = "GetSources";
            a[a.SetActive = 3] = "SetActive";
            a[a.TopologyChanged = 4] = "TopologyChanged";
          })(a.sshare_cmd || (a.sshare_cmd = {}));
          (function (a) {
            a[a.Unknown = 0] = "Unknown";
            a[a.Initialized = 1] = "Initialized";
            a[a.Error = 2] = "Error";
          })(a.sshare_state || (a.sshare_state = {}));
          var c = function () {
            function a() {}
            a.prototype.onInitialized = function (a) {};
            a.prototype.onInitComplete = function () {};
            a.prototype.onError = function (a) {};
            a.prototype.onGetSources = function (a, b) {};
            a.prototype.onSetActive = function (a, b) {};
            a.prototype.onToplogyChanged = function () {};
            return a;
          }();
          a.ScreenShareUtil = c;
        },
        517: function (b, a) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var c = function () {
            function a() {
              this.items = [];
            }
            a.fromJSON = function (b) {
              for (var c = new a(), g = 0; g < b.length; g++) {
                var e = d.fromJSON(b[g]);
                c.items.push(e);
              }
              return c;
            };
            a.toRTCStatsReport = function (a) {
              return a;
            };
            a.prototype.toJSON = function () {
              return JSON.stringify(this.items);
            };
            a.prototype.result = function () {
              return this.items;
            };
            return a;
          }();
          a.StatsReport = c;
          var d = function () {
            function a() {
              this.names_ = [];
              this.stat_ = new Map();
              this.id = "";
              this.timestamp = 0;
              this.type = "";
            }
            a.fromJSON = function (b) {
              var c = new a();
              c.id = b.id || "";
              c.timestamp = b.timestamp || "";
              c.type = b.type || "";
              Object.keys(b).forEach(function (a) {
                "id" !== a && "timestamp" !== a && "type" !== a && (c.names_.push(a), c.stat_.set(a, b[a]));
              });
              return c;
            };
            a.prototype.toJSON = function () {
              return JSON.stringify({
                id: this.id,
                timestamp: this.timestamp,
                type: this.type,
                stat: this.stat_
              });
            };
            a.prototype.names = function () {
              return this.names_;
            };
            a.prototype.stat = function (a) {
              return this.stat_.get(a);
            };
            return a;
          }();
          a.Stats = d;
        },
        394: function (b, a, c) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var d = c(946),
            e = c(851);
          (function (a) {
            a[a.unknown = 0] = "unknown";
            a[a.active = 1] = "active";
            a[a.idle = 2] = "idle";
          })(a.tel_CallState || (a.tel_CallState = {}));
          (function (a) {
            a[a.unknown = 0] = "unknown";
            a[a.incoming = 1] = "incoming";
            a[a.outgoing = 2] = "outgoing";
          })(a.tel_CallDirection || (a.tel_CallDirection = {}));
          (function (a) {
            a[a.unknown = 0] = "unknown";
            a[a.audio = 1] = "audio";
            a[a.video = 2] = "video";
            a[a.multi = 3] = "multi";
            a[a.dshare = 4] = "dshare";
          })(a.tel_CallType || (a.tel_CallType = {}));
          var r;
          (function (a) {
            a[a.Unknown = 0] = "Unknown";
            a[a.Cap = 1] = "Cap";
            a[a.Init = 2] = "Init";
            a[a.Data = 3] = "Data";
          })(r = a.tel_cmd || (a.tel_cmd = {}));
          a.tel_key_ConferenceCallDuration = "ConferenceCallDuration";
          a.tel_key_AudioCallDuration = "AudioCallDuration";
          a.tel_key_VideoCallDuration = "VideoCallDuration";
          a.tel_key_ScreensharingCallDuration = "ScreensharingCallDuration";
          a.tel_key_CallEstIncoming = "CallEstIncoming";
          a.tel_key_CallEstOutgoing = "CallEstOutgoing";
          a.tel_key_AudioDeviceUsed = "AudioDeviceUsed";
          a.tel_key_VideoDeviceUsed = "VideoDeviceUsed";
          a.tel_key_SpeakerDeviceUsed = "SpeakerDeviceUsed";
          a.tel_key_PerfCallDirection = "PerfCallDirection";
          a.tel_key_PerfCallState = "PerfCallState";
          a.tel_key_PerfCallType = "PerfCallType";
          a.tel_key_VerWebrpc = "VerWebrpc";
          a.tel_key_VerWebrtcCodecs = "VerWebrtcCodecs";
          a.tel_key_VerReceiver = "VerReceiver";
          a.tel_key_VerVda = "VerVda";
          a.tel_key_VerEndpoint = "VerEndpoint";
          a.tel_key_VerTypeScript = "VerTypeScript";
          a.tel_key_OSFamily = "OSFamily";
          a.tel_key_OSVersion = "OSVersion";
          a.tel_key_OSArchitecture = "OSArchitecture";
          a.tel_key_OSDistro = "OSDistro";
          a.tel_key_OSEdition = "OSEdition";
          var n = function () {
            function a(b, c, d, g) {
              this.cmd = b;
              this.key = c;
              this.value = d;
              this.flags = g;
            }
            a.prototype.SendTelemetryData = function (a) {
              a.SendTelemetryData(this.cmd, this.key, this.value, this.flags);
            };
            return a;
          }();
          b = function () {
            function a() {
              this.id = 0;
              this.deferredData = [];
            }
            a.prototype.reset = function () {
              this.id = 0;
              this.deferredData = [];
            };
            a.prototype.onInitialized = function (a) {
              for (this.id = a; this.deferredData && 0 < this.deferredData.length;) this.deferredData.shift().SendTelemetryData(this);
            };
            a.prototype.SendTelemetryInit = function () {
              0 < this.id && this.reset();
              try {
                d.getRedirector().WSSendObject({
                  v: "telemetry",
                  hdr: {
                    command: r.Init,
                    id: 0
                  },
                  init: {
                    domain: "HDXMM Teams",
                    subdomain: "Teams",
                    feature: "msteams",
                    version: "1.1.1.1"
                  }
                });
              } catch (a) {
                e.logger.log(a);
              }
            };
            a.prototype.SendTelemetryData = function (a, b, c, g) {
              if (a != r.Data) e.logger.log("invalid telemetry command!");else if (0 == this.id) this.deferredData.push(new n(a, b, c, g));else try {
                d.getRedirector().WSSendObject({
                  v: "telemetry",
                  hdr: {
                    command: a,
                    id: this.id
                  },
                  data: {
                    key: b,
                    value: c,
                    flags: g
                  }
                });
              } catch (m) {
                e.logger.log(m);
              }
            };
            return a;
          }();
          a.Telemetry = b;
        },
        307: function (b, a, c) {
          var d = c(550).Features,
            e = c(360),
            r = c(144),
            n = c(679),
            g = c(945),
            p = c(368),
            f = c(851).logger,
            k = c(650),
            x = c(247).gc,
            m = c(946);
          (function (a, b) {
            a.CitrixWebRTC = b();
          })("undefined" !== typeof self ? self : this, function () {
            function a(b) {
              m.getRedirector().SendTelemetryData_Speaker(b);
            }
            function b() {
              var a = window.getCitrixWebrtcRedir;
              void 0 !== a ? a().then(function (a) {
                f.log("sucesss on connect, getCitrixWebrtcRedir reg value:" + a);
                "1" === a && null === I && (f.log("supported client"), I = new k.RemoteSession());
              })["catch"](function () {
                f.log("Failure to Read Webrtc redir Reg Key");
                h();
              }) : (f.log("window.getCitrixWebrtcRedir() method is not available yet"), h());
            }
            function c(a) {
              if ("1" === a) f.log("Supported client"), m.getRedirector().pingConnectionBegin(!0);else if ("0" === a) {
                f.log("VDI Event: Unsupported client reported");
                try {
                  F({
                    event: "vdiClientDisconnected",
                    reason: "endpointUnsupported",
                    msg: "Unsupported endpoint connected"
                  });
                } catch (b) {
                  f.log("onVMEvent(): exception: " + b.message);
                }
              } else f.log("Citrix Webrtc Redir Reg Key value is incorrect");
            }
            function h() {
              !1 === H && (f.log("starting MS Reg retry..."), H = !0, A(10));
            }
            function A(a) {
              if (0 >= a) {
                H = !1;
                f.log("VDI Event: Reg Key not Updated after timer reported, Fallback");
                try {
                  F({
                    event: "vdiClientDisconnected",
                    reason: "failure",
                    msg: "Citrix Webrtc Redir Reg Key not Present"
                  });
                } catch (b) {
                  f.log("onVMEvent(): exception: " + b.message);
                }
              } else {
                var d = window.getCitrixWebrtcRedir;
                void 0 !== d ? d().then(function (b) {
                  f.log("CitrixMSTeamsRedir reg value:" + b);
                  "0" === b || "1" === b ? (c(b), H = !1) : (f.log("MS Teams Redir Reg key not updated - Start timer"), setTimeout(function () {
                    f.log("Timer waiting for registry to be updated count :" + a);
                    A(--a);
                  }, 1E3));
                })["catch"](function () {
                  f.log("Failure to Read MS Teams redir Reg Key - Start timer");
                  setTimeout(function () {
                    f.log("Timer waiting for registry to be updated count :" + a);
                    A(--a);
                  }, 1E3);
                }) : (f.log("window.getCitrixWebrtcRedir() method is not available yet"), setTimeout(function () {
                  f.log("Timer waiting for registry to be updated count :" + a);
                  A(--a);
                }, 1E3));
              }
            }
            function y() {
              f.log("VDI: sendSessionInfo");
              I && I.getSessionInfo().then(function (a) {
                f.log("getSessionInfo success! info:" + JSON.stringify(a));
                try {
                  F({
                    event: "vdiClientConnected",
                    version: a
                  });
                } catch (b) {
                  f.log("onVMEvent(): exception: " + b.message);
                }
              })["catch"](function () {
                f.log("getSessionInfo failure! session is not fully connected yet...");
              });
            }
            var E = e.PeerConnection,
              u = new r.NavigatorUserMedia(),
              q = r.NavigatorUserMedia.getCapabilities,
              w = new r.RemoteDevices(),
              z = new p.FrameTracker(),
              C = 0,
              F = window.VMEventCallback,
              l = !1;
            window.onVdiClientDisconnected = function (a) {
              f.log("VDI Event: vdiClientDisconnected");
              f.log("VDI : cleanup");
              m.getRedirector().clearReqs();
              r.NavigatorUserMedia.resetcaps();
              z = w = u = null;
              I && I.release();
              I = null;
              x.reset();
              f.log("VDI : cleanup done");
              if (!0 === a && !1 === l) {
                f.log("VDI Event: vdiClientDisconnected with failure reported");
                l = !0;
                try {
                  F({
                    event: "vdiClientDisconnected",
                    reason: "failure",
                    msg: "Websocket Connection Failure"
                  });
                } catch (b) {
                  f.log("onVMEvent(): exception: " + b.message);
                }
              } else {
                l = !1;
                try {
                  F({
                    event: "vdiClientDisconnected",
                    reason: "endpointDisconnected"
                  });
                } catch (b) {
                  f.log("onVMEvent(): exception: " + b.message);
                }
              }
            };
            var I = new k.RemoteSession();
            window.onVdiClientDisconnectedTimer = function () {
              f.log("VDI Event: onVdiClientDisconnectedTimer");
              null === I && (I = new k.RemoteSession());
            };
            window.onVdiClientConnected = function () {
              f.log("VDI Event: vdiClientConnected");
              p.FrameTracker.sendOverlayInfo();
              null !== w && w.isValid() || (w = new r.RemoteDevices());
              null !== u && u.isValid() || (u = new r.NavigatorUserMedia());
              u.getCapabilities().then(function (a) {
                f.log(".getCapabilities() success " + a);
              })["catch"](function () {
                f.log(".getCapabilities() failure");
              });
              y();
              navigator.mediaDevices.dispatchEvent(new CustomEvent("devicechange"));
            };
            var H = !1;
            return {
              Features: d,
              CitrixPeerConnection: E,
              getUserMedia: function (a, c, d) {
                b();
                f.log("VDI Shim getUserMedia");
                null !== u && u.isValid() || (u = new r.NavigatorUserMedia());
                return u.webkitGetUserMedia(a, c, d);
              },
              getDisplayMedia: function (a) {
                b();
                f.log("VDI Shim getDisplayMedia");
                null !== w && w.isValid() || (w = new r.RemoteDevices());
                return w.getDisplayMedia(a);
              },
              enumerateDevices: function () {
                b();
                null !== w && w.isValid() || (w = new r.RemoteDevices());
                return w.enumerateDevices();
              },
              mapVideoElement: function (a) {
                f.log("VDI New Video Element Created, Creating Mapping to VDA");
                null === z && (z = new p.FrameTracker());
                void 0 !== a.remoteVideoElement ? f.log("Video element is already configured!") : (b(), Object.defineProperty(a, "remoteVideoElement", {
                  writable: !0,
                  value: null
                }), a.id || (a.id = "ctx-vid-" + C++), a.remoteVideoElement = new n.VideoElement(a.id), a.remoteVideoElement.onloadedmetadata = function () {
                  var b = new Event("loadedmetadata");
                  a.dispatchEvent(b);
                }, a.remoteVideoElement.ontimeupdate = function () {
                  var b = new Event("timeupdate");
                  a.dispatchEvent(b);
                }, a.remoteVideoElement.onconnectionstatechange = function () {
                  "connected" === a.remoteVideoElement.connectionState ? z.track(a, function (b) {
                    a.remoteVideoElement.setFrame(b);
                  }) : z.untrack(a);
                }, Object.defineProperty(a, "sinkId", {
                  get: function () {
                    return a.remoteVideoElement.sinkId;
                  },
                  set: function (b) {
                    f.log("VDI Shim set video element SinkId value = " + b);
                    a.remoteVideoElement.sinkId = b;
                  }
                }), Object.defineProperty(a, "srcObject", {
                  get: function () {
                    return a.remoteVideoElement.srcObject;
                  },
                  set: function (b) {
                    f.log("VDI Shim set video element srcObject");
                    a.remoteVideoElement.srcObject = b;
                  }
                }), Object.defineProperty(a, "videoWidth", {
                  get: function () {
                    return a.remoteVideoElement.videoWidth;
                  }
                }), Object.defineProperty(a, "videoHeight", {
                  get: function () {
                    return a.remoteVideoElement.videoHeight;
                  }
                }));
              },
              mapAudioElement: function (c) {
                f.log("VDI New Audio Element Created, Creating Mapping to VDA");
                if (void 0 !== c.remoteAudioElement) f.log("Audio element is already configured!");else {
                  b();
                  Object.defineProperty(c, "remoteAudioElement", {
                    writable: !0,
                    value: null
                  });
                  c.remoteAudioElement = new g.AudioElement();
                  var d = c.remoteAudioElement.play;
                  c.play = function () {
                    f.log("VDI Shim remote audio play");
                    return d.apply(c.remoteAudioElement, arguments);
                  };
                  var l = c.remoteAudioElement.pause;
                  c.pause = function () {
                    f.log("VDI Shim remote audio pause");
                    return l.apply(c.remoteAudioElement, arguments);
                  };
                  Object.defineProperty(c, "sinkId", {
                    get: function () {
                      return c.remoteAudioElement.sinkId;
                    },
                    set: function (a) {
                      f.log("VDI Shim set audio element SinkId value = " + a);
                      c.setSinkId(a).then(function () {
                        f.log("VDI Shim set audio element SinkId success");
                      })["catch"](function () {
                        f.log("VDI Shim set audio element SinkId failure");
                      });
                    }
                  });
                  c.setSinkId = function (b) {
                    f.log("VDI Shim set audio element SinkId value = " + b);
                    var d = c.remoteAudioElement.setSinkId(b),
                      l;
                    r.enumerateddecices.forEach(function (a) {
                      b === a.deviceId && (l = a.label);
                    });
                    a(l);
                    return d;
                  };
                  Object.defineProperty(c, "srcObject", {
                    get: function () {
                      return c.remoteAudioElement.srcObject;
                    },
                    set: function (a) {
                      f.log("VDI Shim set audio element srcObject " + JSON.stringify(a));
                      c.remoteAudioElement.srcObject = a;
                    }
                  });
                }
              },
              setVMEventCallback: function (a) {
                F = a;
                m.getRedirector().isConnected() && !window.VMEventCallback && y();
                window.VMEventCallback = null;
                f.log("VDI Event Callback Set");
              },
              addClipRect: function (a) {
                f.log("VDI Adding Occlusion " + JSON.stringify(a));
                null === z && (z = new p.FrameTracker());
                z.addOcclusion(a);
              },
              removeClipRect: function (a) {
                f.log("VDI Removing Occlusion " + JSON.stringify(a));
                null === z && (z = new p.FrameTracker());
                z.removeOcclusion(a);
              },
              initLog: function (a) {
                f.setMSLogger(a);
                f.log("VDI init logger");
              },
              isFeatureOn: function (a) {
                return null === I ? !1 : I.isFeatureSupported(a);
              },
              onConnectionChange: function (a) {
                f.log("VDI : onConnectionChange to " + a);
                !1 === a ? f.log("Disconnecting from the VDA") : (f.log("Connecting to the VDA"), a = window.getCitrixWebrtcRedir, void 0 !== a ? a().then(function (a) {
                  f.log("Sucesss on connect, CitrixMSTeamsRedir reg value:" + a);
                  "0" === a || "1" === a ? c(a) : (f.log("MS Teams Redir Reg key not updated yet"), h());
                })["catch"](function () {
                  f.log("Failure to Read MS Teams redir Reg Key");
                  h();
                }) : (f.log("window.getCitrixWebrtcRedir() method is not available yet"), h()));
              },
              setCodecCapabilities: function (a) {
                f.log("VDI Shim setCodecCapabilities");
                null !== u && u.isValid() || (u = new r.NavigatorUserMedia());
                return u.setCodecCapabilities(a);
              },
              createMediaStream: function (a) {
                f.log("VDI Shim createMediaStream");
                b();
                return new r.RemoteStream(null, 0, 0, a);
              },
              getCapabilities: function (a) {
                b();
                f.log("VDI Shim getCapabilities");
                null !== u && u.isValid() || (u = new r.NavigatorUserMedia(), q = r.NavigatorUserMedia.getCapabilities);
                return q.apply(u, arguments);
              },
              destroyVideoElement: function (a, b) {
                f.log("VDI Shim destroyVideoElement: ");
                if (a) {
                  var c = a.remoteVideoElement;
                  c && c.dispose();
                  a.remoteVideoElement = void 0;
                }
              },
              destroyAudioElement: function (a, b, c) {
                f.log("VDI Shim destroyAudioElement: ");
                a && ((b = a.remoteAudioElement) && b.dispose(), a.remoteAudioElement = void 0);
              }
            };
          });
        },
        679: function (b, a, c) {
          var d = this && this.__extends || function () {
            var a = function (b, c) {
              a = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (a, b) {
                a.__proto__ = b;
              } || function (a, b) {
                for (var c in b) b.hasOwnProperty(c) && (a[c] = b[c]);
              };
              return a(b, c);
            };
            return function (b, c) {
              function d() {
                this.constructor = b;
              }
              a(b, c);
              b.prototype = null === c ? Object.create(c) : (d.prototype = c.prototype, new d());
            };
          }();
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var e = c(658),
            k = c(550),
            n = c(851),
            g = c(946),
            p = c(550),
            f = function () {
              return function (a) {
                this.x = Math.round(a.x) * window.devicePixelRatio;
                this.y = Math.round(a.y) * window.devicePixelRatio;
                this.width = Math.round(a.width) * window.devicePixelRatio;
                this.height = Math.round(a.height) * window.devicePixelRatio;
              };
            }();
          a.VideoRect = f;
          var J;
          (function (a) {
            a[a.pixels = 0] = "pixels";
            a[a.percent = 1] = "percent";
          })(J || (J = {}));
          var x = function () {
              function a(b) {
                this.value = parseInt(b);
                this.units = this.detectUnits(b);
              }
              a.prototype.detectUnits = function (a) {
                return -1 === a.toLowerCase().indexOf("px") ? J.pixels : J.percent;
              };
              return a;
            }(),
            m;
          (function (a) {
            a[a.fill = 0] = "fill";
            a[a.contain = 1] = "contain";
            a[a.cover = 2] = "cover";
          })(m || (m = {}));
          var D = function () {
              return function (a, b) {
                this.x = a;
                this.y = b;
              };
            }(),
            B = function () {
              function a(b, c, d) {
                this.fit = this.convertFit(b);
                this.position = new D(c, d);
              }
              a.prototype.convertFit = function (a) {
                return "fill" == a ? m.fill : "contain" == a ? m.contain : "cover" == a ? m.cover : m.fill;
              };
              return a;
            }();
          b = function (a) {
            function b(c) {
              var d = a.call(this, null, k.class_id_t.VideoElement, 0, e.ProxyMode.Local) || this;
              d.srcObject_ = null;
              d.sinkId_ = "";
              d.videoWidth = 0;
              d.videoHeight = 0;
              d.isLoaded = !1;
              d.connectionState = "disconnected";
              d.styleObserver = null;
              d.pendingRelease_ = !1;
              d.activeConnectionEvent_ = null;
              d.connectionEventQueue_ = [];
              d.elementId = c;
              return d;
            }
            d(b, a);
            b.prototype.dispose = function () {
              n.logger.log("VideoElement.dispose (elementId: " + this.elementId + " oid: " + this.object_id() + ")");
              this.pendingRelease_ = !0;
              this.srcObject = this.ontimeupdate = this.onloadedmetadata = null;
            };
            b.prototype.setState = function (a) {
              this.connectionState = a;
              if (this.onconnectionstatechange_) this.onconnectionstatechange_();
            };
            Object.defineProperty(b.prototype, "sinkId", {
              get: function () {
                return this.sinkId_;
              },
              set: function (a) {
                var b = this;
                this.waitUntilConnected("VideoElement.sinkId").then(function () {
                  return b.remoteInvoke(!0, k.method_id_VideoElement_t.sinkId, a);
                }).then(function () {
                  b.sinkId_ = a;
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".set_sinkId() failed!");
                });
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "srcObject", {
              get: function () {
                return this.srcObject_;
              },
              set: function (a) {
                n.logger.log(this.user_friendly_id() + ".srcObject: set srcObject... this.srcObject:" + this.srcObject + " obj:" + a);
                if (this.srcObject_ !== a) {
                  var b = g.getRedirector().getFeatureValue(p.FEATURE_ms_teams_1911);
                  null !== this.srcObject_ && (null === a && b && this.disconnect(), b || this.disconnect(), this.isLoaded = !1);
                  this.srcObject_ = a;
                  null !== this.srcObject_ && this.connectTo(this.srcObject_);
                }
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onconnectionstatechange", {
              get: function () {
                return this.onconnectionstatechange_;
              },
              set: function (a) {
                n.logger.log(this.user_friendly_id() + ".set_onconnectionstatechange() called.");
                this.onconnectionstatechange_ = a;
              },
              enumerable: !0,
              configurable: !0
            });
            Object.defineProperty(b.prototype, "onloadedmetadata", {
              set: function (a) {
                n.logger.log(this.user_friendly_id() + ".set_onloadedmetadata() called.");
                this.onloadedmetadata_ = a;
              },
              enumerable: !0,
              configurable: !0
            });
            b.prototype.setupOnVideoFrameChanged = function () {
              var a = this,
                b = this.registerCallbacks(!1, !1, k.method_id_VideoElement_t.onvideoframechanged);
              b.then(function (b) {
                n.logger.log(a.user_friendly_id() + ".onvideoframechanged", b.params);
                a.videoWidth = b.params[0] || 0;
                a.videoHeight = b.params[1] || 0;
                a.isLoaded || (a.isLoaded = !0, a.onloadedmetadata_ && a.onloadedmetadata_());
              });
              this.remoteInvoke(!0, k.method_id_VideoElement_t.onvideoframechanged, b.success);
            };
            b.prototype.processConnectionEvent = function () {
              var a = this;
              if (0 !== this.connectionEventQueue_.length && !this.activeConnectionEvent_) {
                var b = this.connectionEventQueue_.pop();
                "connectTo" == b.operation ? this.activeConnectionEvent_ = this.connectToAsync(b.param) : "disconnect" == b.operation && (this.activeConnectionEvent_ = this.disconnectAsync());
                this.activeConnectionEvent_.then(function () {
                  a.activeConnectionEvent_ = void 0;
                  a.processConnectionEvent();
                })["catch"](function () {
                  n.logger.log(a.user_friendly_id() + " : Failed to handle connection event! ");
                  a.activeConnectionEvent_ = void 0;
                  a.processConnectionEvent();
                });
              }
            };
            b.prototype.connectTo = function (a) {
              this.connectionEventQueue_.push({
                operation: "connectTo",
                param: a
              });
              this.processConnectionEvent();
            };
            b.prototype.disconnect = function () {
              this.connectionEventQueue_.push({
                operation: "disconnect",
                param: null
              });
              this.processConnectionEvent();
            };
            b.prototype.connectToAsync = function (a) {
              var b = this;
              return new Promise(function (c, d) {
                n.logger.log(b.user_friendly_id() + ".connectTo: connect media stream with id = " + a.id + ", clone_id = " + a.clone_state.clone_id);
                b.streamId_ = a.id;
                b.waitUntilConnected("VideoElement.connectTo").then(function () {
                  return a.waitUntilConnected("MediaStream.connectTo");
                }).then(function () {
                  b.setupOnVideoFrameChanged();
                  return a.clone_state.synchronize(a);
                }).then(function (a) {
                  n.logger.log(b.user_friendly_id() + ".connectTo: remote invoking");
                  var c = b.registerCallbacks(!0, !1, k.method_id_VideoElement_t.connectTo);
                  return Promise.all([b.remoteInvoke(!1, k.method_id_VideoElement_t.connectTo, {
                    oid: a.object_id()
                  }, c.success, c.fail), c.prom()]);
                }).then(function (a) {
                  n.logger.log(b.user_friendly_id() + ".connectTo: remote media stream is connected!");
                  b.setState("connected");
                  b.watch();
                  b.updateTimer = setInterval(function () {
                    b.ontimeupdate && b.ontimeupdate();
                  }, 250);
                  (a = window.document.getElementById(b.elementId)) && b.updateStyle(a);
                  c();
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".connectTo: failed to connect!");
                  d();
                });
              });
            };
            b.prototype.disconnectAsync = function () {
              var a = this;
              return new Promise(function (b, c) {
                n.logger.log(a.user_friendly_id() + ".disconnect: disconnecting stream : " + a.streamId_);
                a.unwatch();
                a.waitUntilConnected("VideoElement.disconnect").then(function () {
                  a.updateTimer && clearInterval(a.updateTimer);
                  var b = a.registerCallbacks(!1, !0, k.method_id_VideoElement_t.onvideoframechanged);
                  a.remoteInvoke(!0, k.method_id_VideoElement_t.onvideoframechanged, b.success);
                  return a.remoteInvoke(!1, k.method_id_VideoElement_t.disconnect);
                }).then(function () {
                  n.logger.log(a.user_friendly_id() + ".disconnect: remote media stream is disconnected!");
                  a.setState("disconnected");
                  1 == a.pendingRelease_ && (a.pendingRelease_ = !1, a.onconnectionstatechange = null, a.release());
                  b();
                })["catch"](function (b) {
                  a.logRemoteInvokeError(b, ".disconnect: failed to connect!");
                  c();
                });
              });
            };
            b.prototype.setFrame = function (a) {
              var b = this;
              n.logger.log(this.user_friendly_id() + ".setFrame: set video frame to", a.x, a.y, a.width, a.height);
              this.waitUntilConnected("VideoElement.setFrame").then(function () {
                var c = new f(a);
                return b.remoteInvoke(!1, k.method_id_VideoElement_t.setFrame, c);
              }).then(function () {
                n.logger.log(b.user_friendly_id() + ".setFrame: success!");
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, ".setFrame: failed to connect!");
              });
            };
            b.prototype.addClipRect = function (a) {
              var b = this;
              n.logger.log(this.user_friendly_id() + ".addClipRect: ", JSON.stringify(a));
              this.waitUntilConnected("VideoElement.addClipRect").then(function () {
                var c = new f(a);
                return b.remoteInvoke(!1, k.method_id_VideoElement_t.addClipRect, c);
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, ".addClipRect failed!");
              });
            };
            b.prototype.removeClipRect = function (a) {
              var b = this;
              n.logger.log(this.user_friendly_id() + ".removeClipRect: ", JSON.stringify(a));
              this.waitUntilConnected("VideoElement.removeClipRect").then(function () {
                var c = new f(a);
                return b.remoteInvoke(!1, k.method_id_VideoElement_t.removeClipRect, c);
              })["catch"](function (a) {
                b.logRemoteInvokeError(a, ".removeClipRect failed!");
              });
            };
            b.prototype.watch = function () {
              var a = this;
              if (g.getRedirector().getFeatureValue(p.FEATURE_ms_teams_video_placement)) {
                var b = window.document.getElementById(this.elementId);
                b && (this.unwatch(), this.styleObserver = new MutationObserver(function (b) {
                  b.forEach(function (b) {
                    "style" == b.attributeName ? a.updateStyle(b.target) : a.elementId = b.target.id;
                  });
                }), this.styleObserver.observe(b, {
                  attributes: !0,
                  attributeOldValue: !0,
                  attributeFilter: ["style", "id"]
                }));
              }
            };
            b.prototype.unwatch = function () {
              this.styleObserver && (this.styleObserver.disconnect(), this.styleObserver = null);
            };
            b.prototype.updateStyle = function (a) {
              if ("connected" == this.connectionState) {
                var b = window.getComputedStyle(a).getPropertyValue("object-fit"),
                  c = window.getComputedStyle(a).getPropertyValue("object-position").split(" ");
                a = new x(c[0]);
                c = new x(c[1]);
                this.placement = new B(b, a, c);
              } else n.logger.log(this.user_friendly_id() + ".updateStyle: video element is not connected");
            };
            Object.defineProperty(b.prototype, "placement", {
              get: function () {
                return this.placement_;
              },
              set: function (a) {
                var b = this;
                g.getRedirector().getFeatureValue(p.FEATURE_ms_teams_video_placement) ? this.waitUntilConnected("VideoElement.placement").then(function () {
                  return b.remoteInvoke(!0, k.method_id_VideoElement_t.placement, a);
                }).then(function () {
                  b.placement_ = a;
                })["catch"](function (a) {
                  b.logRemoteInvokeError(a, ".placement setter: failed to connect!");
                }) : n.logger.log(this.user_friendly_id() + ".placement: video placement feature is not supported on a client");
              },
              enumerable: !0,
              configurable: !0
            });
            return b;
          }(e.ProxyObject);
          a.VideoElement = b;
        },
        269: function (b, a) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          a.FEATURE_ms_teams_redirection = "ms_teams_redirection";
          a.FEATURE_unsupported = "unsupported";
          var c = function () {
            return function (a, b, c, d) {
              this.major = a;
              this.minor = b;
              this.revision = c;
              this.build = d;
            };
          }();
          a.VersionData = c;
          c = function () {
            return function () {};
          }();
          a.FeatureData = c;
          c = function () {
            return function (a, b) {
              this.fature = a;
              this.version = b;
            };
          }();
          a.WebrpcFeatureInfo = c;
          c = function () {
            return function (a, b, c, d, g) {
              this.family = a;
              this.version = b;
              this.architecture = c;
              this.distro = d;
              this.edition = g;
            };
          }();
          a.OSInfo = c;
          c = function () {
            return function (a, b) {
              this.machine_id = a;
              this.user_id = b;
            };
          }();
          a.EndpointId = c;
          c = function () {
            return function (b, c, d, e, g) {
              void 0 === g && (g = a.FEATURE_ms_teams_redirection);
              this.iid = b;
              this.mid = c;
              this.name = d;
              this.isprop = e;
              this.feature = g;
            };
          }();
          a.WebrpcMethodInfo = c;
          c = function () {
            return function (a, b, c) {
              this.id = a;
              this.name = b;
              this.methods = c;
            };
          }();
          a.WebrpcClassInfo = c;
          c = function () {
            return function (a, b) {
              this.name = a;
              this.classes = b;
            };
          }();
          a.WebrpcClassLibInfo = c;
        },
        550: function (b, a, c) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var d = c(187);
          (function (b) {
            for (var c in b) a.hasOwnProperty(c) || (a[c] = b[c]);
          })(c(187));
          b = function () {
            function a() {}
            a.getInterfaceByid = function (a) {
              for (var b = 0, c = d.class_lib_info.classes; b < c.length; b++) {
                var e = c[b];
                if (e.id == a) return e;
              }
              return null;
            };
            a.getMethodByid = function (a, b) {
              var c = this.getInterfaceByid(a);
              if (null != c) for (var d = 0, c = c.methods; d < c.length; d++) {
                var f = c[d];
                if (f.mid == b) return f;
              }
              return null;
            };
            a.getMethodFeatureByid = function (a, b) {
              var c = this.getInterfaceByid(a);
              if (null != c) for (var d = 0, c = c.methods; d < c.length; d++) {
                var f = c[d];
                if (f.mid == b) return f.feature;
              }
              return null;
            };
            a.composeClassInfoData = function (a) {
              a = a.hdr;
              if (void 0 == a) return "*** Invalid packet: Couldn't find hdr object ***";
              var b = a.proc;
              if (void 0 == b) return "";
              a = b.iid;
              for (var b = b.methodid, c = 0, e = d.class_lib_info.classes; c < e.length; c++) {
                var f = e[c];
                if (f.id == a) for (var k = 0, v = f.methods; k < v.length; k++) {
                  var m = v[k];
                  if (m.mid == b) return f.name + "::" + m.name;
                }
              }
              return "";
            };
            return a;
          }();
          a.WebrpcClassLibInfoUtil = b;
        },
        187: function (b, a, c) {
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          b = c(269);
          c = c(269);
          a.VersionData = c.VersionData;
          a.FeatureData = c.FeatureData;
          a.OSInfo = c.OSInfo;
          a.EndpointId = c.EndpointId;
          a.BUILD_TYPE_SDK = !0;
          a.HDXMS_VERSION = "2.0.0.4";
          a.FEATURE_vda_service_no_buffer_limit = "wsservice_no_buffer_limit";
          a.FEATURE_vda_app_sharing = "webrtc_app_sharing";
          a.FEATURE_vda_multi_window = "webrtc_multi_window";
          a.FEATURE_ms_teams_desktop_sharing = "ms_teams_desktop_sharing";
          a.FEATURE_ms_teams_speaking_indicator = "ms_teams_speaking_indicator";
          a.FEATURE_ms_teams_common_media_constraints = "ms_teams_common_media_constraints";
          a.FEATURE_ms_teams_1911 = "ms_teams_1911";
          a.FEATURE_ms_teams_pstn = "ms_teams_pstn";
          a.FEATURE_ms_teams_1912 = "ms_teams_1912";
          a.FEATURE_ms_teams_mstrack_constraints = "ms_teams_mstrack_constraints";
          a.FEATURE_ms_teams_osinfo = "ms_teams_osinfo";
          a.FEATURE_ms_teams_endpoint_id = "ms_teams_endpoint_id";
          a.FEATURE_ms_teams_remote_audio_notifications = "ms_teams_remote_audio_notifications";
          a.FEATURE_ms_teams_device_group_id = "ms_teams_device_group_id";
          a.FEATURE_ms_teams_dtmf = "ms_teams_dtmf";
          a.FEATURE_ms_teams_video_placement = "ms_teams_video_placement";
          a.FEATURE_ms_teams_codec_capability = "ms_teams_codec_capability";
          a.FEATURE_ms_teams_multi_window = "ms_teams_multi_windows";
          a.FEATURE_ms_teams_webrtc_1dot0 = "ms_teams_webrtc_1.0";
          a.FEATURE_ms_teams_data_channel = "ms_teams_data_channel";
          a.FEATURE_ms_teams_no_vd_buffer_limit = "ms_teams_no_vd_buffer_limit";
          new b.WebrpcFeatureInfo(b.FEATURE_ms_teams_redirection, new b.VersionData(1, 1, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_desktop_sharing, new b.VersionData(1, 2, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_speaking_indicator, new b.VersionData(1, 2, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_common_media_constraints, new b.VersionData(1, 4, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_1911, new b.VersionData(1, 4, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_1912, new b.VersionData(1, 5, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_mstrack_constraints, new b.VersionData(1, 6, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_pstn, new b.VersionData(1, 6, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_osinfo, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_endpoint_id, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_remote_audio_notifications, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_device_group_id, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_codec_capability, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_dtmf, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_video_placement, new b.VersionData(1, 7, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_webrtc_1dot0, new b.VersionData(1, 8, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_data_channel, new b.VersionData(1, 8, 0, 0));
          new b.WebrpcFeatureInfo(a.FEATURE_ms_teams_multi_window, new b.VersionData(1, 14, 0, 0));
          c = function () {
            function a() {}
            a.FEATURE_public_screenshare = "screenshare";
            a.FEATURE_public_redirection = "redirection";
            a.FEATURE_public_speaking_indicator = "speaking_indicator";
            a.FEATURE_public_pstn = "pstn";
            a.FEATURE_public_osinfo = "osinfo";
            a.FEATURE_public_endpoint_id = "endpointid";
            a.FEATURE_public_remote_audio_notifications = "remoteaudionotifications";
            a.FEATURE_public_device_group_id = "compositedevices";
            a.FEATURE_public_dtmf = "dtmf";
            a.FEATURE_public_monitor_sharing = "multimonitorscreenshare";
            a.FEATURE_public_app_sharing = "appshare";
            a.FEATURE_public_codec_capability = "codec_capability";
            a.FEATURE_public_webrtc1dot0 = "webrtc1.0";
            a.FEATURE_public_data_channel = "datachannel";
            a.FEATURE_public_vdnobuflimit = "vdnobuflimit";
            a.FEATURE_public_multi_window = "multiwindow";
            return a;
          }();
          a.Features = c;
          a.featureNameMap = {};
          a.featureNameMap[c.FEATURE_public_screenshare] = [a.FEATURE_ms_teams_desktop_sharing];
          a.featureNameMap[c.FEATURE_public_redirection] = [b.FEATURE_ms_teams_redirection];
          a.featureNameMap[c.FEATURE_public_speaking_indicator] = [a.FEATURE_ms_teams_speaking_indicator];
          a.featureNameMap[c.FEATURE_public_pstn] = [a.FEATURE_ms_teams_pstn];
          a.featureNameMap[c.FEATURE_public_osinfo] = [a.FEATURE_ms_teams_osinfo];
          a.featureNameMap[c.FEATURE_public_endpoint_id] = [a.FEATURE_ms_teams_endpoint_id];
          a.featureNameMap[c.FEATURE_public_remote_audio_notifications] = [a.FEATURE_ms_teams_remote_audio_notifications];
          a.featureNameMap[c.FEATURE_public_device_group_id] = [a.FEATURE_ms_teams_device_group_id];
          a.featureNameMap[c.FEATURE_public_dtmf] = [a.FEATURE_ms_teams_dtmf];
          a.featureNameMap[c.FEATURE_public_codec_capability] = [a.FEATURE_ms_teams_codec_capability];
          a.featureNameMap[c.FEATURE_public_webrtc1dot0] = [a.FEATURE_ms_teams_webrtc_1dot0];
          a.featureNameMap[c.FEATURE_public_multi_window] = [a.FEATURE_ms_teams_multi_window];
          a.featureNameMap[c.FEATURE_public_data_channel] = [a.FEATURE_ms_teams_data_channel];
          a.featureNameMap[c.FEATURE_public_vdnobuflimit] = [a.FEATURE_ms_teams_no_vd_buffer_limit];
          (function (a) {
            a[a.EngineControl = 0] = "EngineControl";
            a[a.RTCPeerConnection = 1] = "RTCPeerConnection";
            a[a.RTCSessionDescription = 2] = "RTCSessionDescription";
            a[a.RTCIceCandidate = 3] = "RTCIceCandidate";
            a[a.RTCIceCandidateEvent = 4] = "RTCIceCandidateEvent";
            a[a.MediaDevices = 5] = "MediaDevices";
            a[a.MediaDeviceInfo = 6] = "MediaDeviceInfo";
            a[a.MediaStreamTrack = 7] = "MediaStreamTrack";
            a[a.MediaStreamEvent = 8] = "MediaStreamEvent";
            a[a.MediaStream = 9] = "MediaStream";
            a[a.NavigatorUserMedia = 10] = "NavigatorUserMedia";
            a[a.VideoElement = 11] = "VideoElement";
            a[a.AudioElement = 12] = "AudioElement";
            a[a.RTCRtpReceiver = 13] = "RTCRtpReceiver";
            a[a.RTCRtpSender = 14] = "RTCRtpSender";
            a[a.RTCDtlsTransport = 15] = "RTCDtlsTransport";
            a[a.RTCIceTransport = 16] = "RTCIceTransport";
            a[a.RTCDTMFSender = 17] = "RTCDTMFSender";
            a[a.RTCDTMFToneChangeEvent = 18] = "RTCDTMFToneChangeEvent";
            a[a.RTCIceCandidatePair = 19] = "RTCIceCandidatePair";
            a[a.RTCRtpTransceiver = 20] = "RTCRtpTransceiver";
            a[a.reserved3 = 21] = "reserved3";
            a[a.reserved4 = 22] = "reserved4";
            a[a.reserved1 = 23] = "reserved1";
            a[a.reserved2 = 24] = "reserved2";
            a[a.RTCDataChannel = 25] = "RTCDataChannel";
            a[a.RTCSctpTransport = 26] = "RTCSctpTransport";
          })(c = a.class_id_t || (a.class_id_t = {}));
          var d;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.version = 1] = "version";
            a[a.feature_flags = 2] = "feature_flags";
            a[a.version_info = 3] = "version_info";
            a[a.osinfo = 4] = "osinfo";
            a[a.endpoint_id = 5] = "endpoint_id";
          })(d = a.method_id_EngineControl_t || (a.method_id_EngineControl_t = {}));
          var e;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.localDescription = 1] = "localDescription";
            a[a.remoteDescription = 2] = "remoteDescription";
            a[a.readyState = 3] = "readyState";
            a[a.iceState = 4] = "iceState";
            a[a.localStreams = 5] = "localStreams";
            a[a.remoteStreams = 6] = "remoteStreams";
            a[a.createOffer = 7] = "createOffer";
            a[a.createAnswer = 8] = "createAnswer";
            a[a.setLocalDescription = 9] = "setLocalDescription";
            a[a.setRemoteDescription = 10] = "setRemoteDescription";
            a[a.updateIce = 11] = "updateIce";
            a[a.addIceCandidate = 12] = "addIceCandidate";
            a[a.addStream = 13] = "addStream";
            a[a.removeStream = 14] = "removeStream";
            a[a.close = 15] = "close";
            a[a.iceConnectionState = 16] = "iceConnectionState";
            a[a.iceGatheringState = 17] = "iceGatheringState";
            a[a.signalingState = 18] = "signalingState";
            a[a.onaddstream = 19] = "onaddstream";
            a[a.onicecandidate = 20] = "onicecandidate";
            a[a.oniceconnectionstatechange = 21] = "oniceconnectionstatechange";
            a[a.onicegatheringstatechange = 22] = "onicegatheringstatechange";
            a[a.onsignalingstatechange = 23] = "onsignalingstatechange";
            a[a.onnegotiationneeded = 24] = "onnegotiationneeded";
            a[a.onremovestream = 25] = "onremovestream";
            a[a.getStats = 26] = "getStats";
            a[a.getReceivers = 27] = "getReceivers";
            a[a.getSenders = 28] = "getSenders";
            a[a.addTrack = 29] = "addTrack";
            a[a.removeTrack = 30] = "removeTrack";
            a[a.ontrack = 31] = "ontrack";
            a[a.setLocalDescription_v2 = 32] = "setLocalDescription_v2";
            a[a.setRemoteDescription_v2 = 33] = "setRemoteDescription_v2";
            a[a.addTransceiverWithTrack = 34] = "addTransceiverWithTrack";
            a[a.addTransceiverWithKind = 35] = "addTransceiverWithKind";
            a[a.getTransceivers = 36] = "getTransceivers";
            a[a.onconnectionstatechange = 37] = "onconnectionstatechange";
            a[a.sctp = 38] = "sctp";
            a[a.ondatachannel = 39] = "ondatachannel";
            a[a.createDataChannel = 40] = "createDataChannel";
            a[a.getStats_v2 = 41] = "getStats_v2";
          })(e = a.method_id_RTCPeerConnection_t || (a.method_id_RTCPeerConnection_t = {}));
          var k;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.enumerateDevices = 1] = "enumerateDevices";
            a[a.getDisplayMedia = 2] = "getDisplayMedia";
            a[a.ondevicechange = 3] = "ondevicechange";
          })(k = a.method_id_MediaDevices_t || (a.method_id_MediaDevices_t = {}));
          var n;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.deviceId = 1] = "deviceId";
            a[a.kind = 2] = "kind";
            a[a.label = 3] = "label";
            a[a.groupId = 4] = "groupId";
          })(n = a.method_id_MediaDeviceInfo_t || (a.method_id_MediaDeviceInfo_t = {}));
          var g;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.type = 1] = "type";
            a[a.sdp = 2] = "sdp";
          })(g = a.method_id_RTCSessionDescription_t || (a.method_id_RTCSessionDescription_t = {}));
          var p;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.kind = 1] = "kind";
            a[a.id = 2] = "id";
            a[a.label = 3] = "label";
            a[a.enabled = 4] = "enabled";
            a[a.muted = 5] = "muted";
            a[a.readyState = 6] = "readyState";
            a[a.onended = 7] = "onended";
            a[a.onmute = 8] = "onmute";
            a[a.onunmute = 9] = "onunmute";
            a[a.clone = 10] = "clone";
            a[a.stop = 11] = "stop";
            a[a.getCapabilities = 12] = "getCapabilities";
            a[a.getSettings = 13] = "getSettings";
            a[a.applyConstraints = 14] = "applyConstraints";
            a[a.getConstraints = 15] = "getConstraints";
          })(p = a.method_id_MediaStreamTrack_t || (a.method_id_MediaStreamTrack_t = {}));
          var f;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.id = 1] = "id";
            a[a.getAudioTracks = 2] = "getAudioTracks";
            a[a.getVideoTracks = 3] = "getVideoTracks";
            a[a.getTracks = 4] = "getTracks";
            a[a.getTrackById = 5] = "getTrackById";
            a[a.addTrack = 6] = "addTrack";
            a[a.removeTrack = 7] = "removeTrack";
            a[a.clone = 8] = "clone";
            a[a.active = 9] = "active";
          })(f = a.method_id_MediaStream_t || (a.method_id_MediaStream_t = {}));
          var J;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.getUserMedia = 1] = "getUserMedia";
            a[a.setCodecCapabilities = 2] = "setCodecCapabilities";
            a[a.getCapabilities = 3] = "getCapabilities";
          })(J = a.method_id_NavigatorUserMedia_t || (a.method_id_NavigatorUserMedia_t = {}));
          var x;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.candidate = 1] = "candidate";
            a[a.sdpMid = 2] = "sdpMid";
            a[a.sdpMLineIndex = 3] = "sdpMLineIndex";
          })(x = a.method_id_RTCIceCandidate_t || (a.method_id_RTCIceCandidate_t = {}));
          var m;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.candidate = 1] = "candidate";
          })(m = a.method_id_RTCIceCandidateEvent_t || (a.method_id_RTCIceCandidateEvent_t = {}));
          var D;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.stream = 1] = "stream";
          })(D = a.method_id_MediaStreamEvent_t || (a.method_id_MediaStreamEvent_t = {}));
          var B;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.sinkId = 1] = "sinkId";
            a[a.connectTo = 2] = "connectTo";
            a[a.disconnect = 3] = "disconnect";
            a[a.setFrame = 4] = "setFrame";
            a[a.addClipRect = 5] = "addClipRect";
            a[a.removeClipRect = 6] = "removeClipRect";
            a[a.onerror = 7] = "onerror";
            a[a.onvideoframechanged = 8] = "onvideoframechanged";
            a[a.placement = 9] = "placement";
          })(B = a.method_id_VideoElement_t || (a.method_id_VideoElement_t = {}));
          var t;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.sinkId = 1] = "sinkId";
            a[a.srcObject = 2] = "srcObject";
            a[a.src = 3] = "src";
            a[a.play = 4] = "play";
            a[a.pause = 5] = "pause";
          })(t = a.method_id_AudioElement_t || (a.method_id_AudioElement_t = {}));
          var h;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.track = 1] = "track";
            a[a.getContributingSources = 2] = "getContributingSources";
            a[a.getSynchronizationSources = 3] = "getSynchronizationSources";
            a[a.transport = 4] = "transport";
            a[a.rtcpTransport = 5] = "rtcpTransport";
            a[a.getCapabilities = 6] = "getCapabilities";
            a[a.getParameters = 7] = "getParameters";
            a[a.getStats = 8] = "getStats";
            a[a.getCapabilities_v2 = 9] = "getCapabilities_v2";
          })(h = a.method_id_RTCRtpReceiver_t || (a.method_id_RTCRtpReceiver_t = {}));
          var A;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.track = 1] = "track";
            a[a.transport = 2] = "transport";
            a[a.rtcpTransport = 3] = "rtcpTransport";
            a[a.dtmf = 4] = "dtmf";
            a[a.getCapabilities = 5] = "getCapabilities";
            a[a.getParameters = 6] = "getParameters";
            a[a.setParameters = 7] = "setParameters";
            a[a.replaceTrack = 8] = "replaceTrack";
            a[a.getStats = 9] = "getStats";
            a[a.setStreams = 10] = "setStreams";
            a[a.getCapabilities_v2 = 11] = "getCapabilities_v2";
          })(A = a.method_id_RTCRtpSender_t || (a.method_id_RTCRtpSender_t = {}));
          var y;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.transport = 1] = "transport";
            a[a.state = 2] = "state";
            a[a.getRemoteCertificates = 3] = "getRemoteCertificates";
            a[a.onstatechange = 4] = "onstatechange";
            a[a.onerror = 5] = "onerror";
          })(y = a.method_id_RTCDtlsTransport_t || (a.method_id_RTCDtlsTransport_t = {}));
          var E;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.role = 1] = "role";
            a[a.component = 2] = "component";
            a[a.state = 3] = "state";
            a[a.gatheringState = 4] = "gatheringState";
            a[a.localcandidates = 5] = "localcandidates";
            a[a.remotecandidates = 6] = "remotecandidates";
            a[a.onstatechange = 7] = "onstatechange";
            a[a.ongatheringstatechange = 8] = "ongatheringstatechange";
            a[a.onselectedcandidatepairchange = 9] = "onselectedcandidatepairchange";
          })(E = a.method_id_RTCIceTransport_t || (a.method_id_RTCIceTransport_t = {}));
          var u;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.insertDTMF = 1] = "insertDTMF";
            a[a.ontonechange = 2] = "ontonechange";
            a[a.canInsertDTMF = 3] = "canInsertDTMF";
            a[a.toneBuffer = 4] = "toneBuffer";
          })(u = a.method_id_RTCDTMFSender_t || (a.method_id_RTCDTMFSender_t = {}));
          var q;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.tone = 1] = "tone";
            a[a.tone_buffer = 2] = "tone_buffer";
          })(q = a.method_id_RTCDTMFToneChangeEvent_t || (a.method_id_RTCDTMFToneChangeEvent_t = {}));
          var w;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.local = 1] = "local";
            a[a.remote = 2] = "remote";
          })(w = a.method_id_RTCIceCandidatePair_t || (a.method_id_RTCIceCandidatePair_t = {}));
          var z;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.mid = 1] = "mid";
            a[a.sender = 2] = "sender";
            a[a.receiver = 3] = "receiver";
            a[a.direction = 4] = "direction";
            a[a.currentDirection = 5] = "currentDirection";
            a[a.stop = 6] = "stop";
            a[a.setCodecPreferences = 7] = "setCodecPreferences";
          })(z = a.method_id_RTCRtpTransceiver_t || (a.method_id_RTCRtpTransceiver_t = {}));
          var C;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.label = 1] = "label";
            a[a.ordered = 2] = "ordered";
            a[a.maxPacketLifeTime = 3] = "maxPacketLifeTime";
            a[a.maxRetransmits = 4] = "maxRetransmits";
            a[a.protocol = 5] = "protocol";
            a[a.negotiated = 6] = "negotiated";
            a[a.id = 7] = "id";
            a[a.readyState = 8] = "readyState";
            a[a.bufferedAmount = 9] = "bufferedAmount";
            a[a.bufferedAmountLowThreshold = 10] = "bufferedAmountLowThreshold";
            a[a.onopen = 11] = "onopen";
            a[a.onbufferedamountlow = 12] = "onbufferedamountlow";
            a[a.onerror = 13] = "onerror";
            a[a.onclosing = 14] = "onclosing";
            a[a.onclose = 15] = "onclose";
            a[a.onmessage = 16] = "onmessage";
            a[a.close = 17] = "close";
            a[a.send_text = 18] = "send_text";
            a[a.send_binary = 19] = "send_binary";
          })(C = a.method_id_RTCDataChannel_t || (a.method_id_RTCDataChannel_t = {}));
          var F;
          (function (a) {
            a[a.ctor = 0] = "ctor";
            a[a.transport = 1] = "transport";
            a[a.state = 2] = "state";
            a[a.maxMessageSize = 3] = "maxMessageSize";
            a[a.maxChannels = 4] = "maxChannels";
            a[a.onstatechange = 5] = "onstatechange";
          })(F = a.method_id_RTCSctpTransport_t || (a.method_id_RTCSctpTransport_t = {}));
          a.class_lib_info = new b.WebrpcClassLibInfo("webrpc_class_library", [new b.WebrpcClassInfo(c.EngineControl, "EngineControl", [new b.WebrpcMethodInfo(c.EngineControl, d.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.EngineControl, d.version, "version", !0), new b.WebrpcMethodInfo(c.EngineControl, d.feature_flags, "feature_flags", !0), new b.WebrpcMethodInfo(c.EngineControl, d.version_info, "version_info", !0, a.FEATURE_ms_teams_desktop_sharing), new b.WebrpcMethodInfo(c.EngineControl, d.osinfo, "osinfo", !0, a.FEATURE_ms_teams_osinfo), new b.WebrpcMethodInfo(c.EngineControl, d.endpoint_id, "endpoint_id", !0, a.FEATURE_ms_teams_endpoint_id)]), new b.WebrpcClassInfo(c.RTCPeerConnection, "RTCPeerConnection", [new b.WebrpcMethodInfo(c.RTCPeerConnection, e.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.localDescription, "localDescription", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.remoteDescription, "remoteDescription", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.readyState, "readyState", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.iceState, "iceState", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.localStreams, "localStreams", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.remoteStreams, "remoteStreams", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.createOffer, "createOffer", !1), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.createAnswer, "createAnswer", !1), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.setLocalDescription, "setLocalDescription", !1), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.setRemoteDescription, "setRemoteDescription", !1), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.updateIce, "updateIce", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.addIceCandidate, "addIceCandidate", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.addStream, "addStream", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.removeStream, "removeStream", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.close, "close", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.iceConnectionState, "iceConnectionState", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.iceGatheringState, "iceGatheringState", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.signalingState, "signalingState", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onaddstream, "onaddstream", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onicecandidate, "onicecandidate", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.oniceconnectionstatechange, "oniceconnectionstatechange", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onicegatheringstatechange, "onicegatheringstatechange", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onsignalingstatechange, "onsignalingstatechange", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onnegotiationneeded, "onnegotiationneeded", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onremovestream, "onremovestream", !0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.getStats, "getStats", !1), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.getReceivers, "getReceivers", !1, a.FEATURE_ms_teams_speaking_indicator), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.getSenders, "getSenders", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.addTrack, "addTrack", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.removeTrack, "removeTrack", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.ontrack, "ontrack", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.setLocalDescription_v2, "setLocalDescription_v2", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.setRemoteDescription_v2, "setRemoteDescription_v2", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.addTransceiverWithTrack, "addTransceiverWithTrack", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.addTransceiverWithKind, "addTransceiverWithKind", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.getTransceivers, "getTransceivers", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.onconnectionstatechange, "onconnectionstatechange", !0, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.sctp, "sctp", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.ondatachannel, "ondatachannel", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.createDataChannel, "createDataChannel", !1, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCPeerConnection, e.getStats_v2, "getStats_v2", !1, a.FEATURE_ms_teams_webrtc_1dot0)]), new b.WebrpcClassInfo(c.RTCSessionDescription, "RTCSessionDescription", [new b.WebrpcMethodInfo(c.RTCSessionDescription, g.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.RTCSessionDescription, g.type, "type", !0), new b.WebrpcMethodInfo(c.RTCSessionDescription, g.sdp, "sdp", !0)]), new b.WebrpcClassInfo(c.RTCIceCandidate, "RTCIceCandidate", [new b.WebrpcMethodInfo(c.RTCIceCandidate, x.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.RTCIceCandidate, x.candidate, "candidate", !0), new b.WebrpcMethodInfo(c.RTCIceCandidate, x.sdpMid, "sdpMid", !0), new b.WebrpcMethodInfo(c.RTCIceCandidate, x.sdpMLineIndex, "sdpMLineIndex", !0)]), new b.WebrpcClassInfo(c.RTCIceCandidateEvent, "RTCIceCandidateEvent", [new b.WebrpcMethodInfo(c.RTCIceCandidateEvent, m.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.RTCIceCandidateEvent, m.candidate, "candidate", !0)]), new b.WebrpcClassInfo(c.MediaDevices, "MediaDevices", [new b.WebrpcMethodInfo(c.MediaDevices, k.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.MediaDevices, k.enumerateDevices, "enumerateDevices", !1), new b.WebrpcMethodInfo(c.MediaDevices, k.getDisplayMedia, "getDisplayMedia", !1, a.FEATURE_ms_teams_desktop_sharing), new b.WebrpcMethodInfo(c.MediaDevices, k.ondevicechange, "ondevicechange", !0, a.FEATURE_ms_teams_speaking_indicator)]), new b.WebrpcClassInfo(c.MediaDeviceInfo, "MediaDeviceInfo", [new b.WebrpcMethodInfo(c.MediaDeviceInfo, n.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.MediaDeviceInfo, n.deviceId, "deviceId", !0), new b.WebrpcMethodInfo(c.MediaDeviceInfo, n.kind, "kind", !0), new b.WebrpcMethodInfo(c.MediaDeviceInfo, n.label, "label", !0), new b.WebrpcMethodInfo(c.MediaDeviceInfo, n.groupId, "groupId", !0)]), new b.WebrpcClassInfo(c.MediaStreamTrack, "MediaStreamTrack", [new b.WebrpcMethodInfo(c.MediaStreamTrack, p.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.clone, "clone", !1), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.stop, "stop", !1), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.getCapabilities, "getCapabilities", !1), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.getSettings, "getSettings", !1), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.applyConstraints, "applyConstraints", !1, a.FEATURE_ms_teams_desktop_sharing), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.kind, "kind", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.id, "id", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.label, "label", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.enabled, "enabled", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.muted, "muted", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.readyState, "readyState", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.onended, "onended", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.onmute, "onmute", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.onunmute, "onunmute", !0), new b.WebrpcMethodInfo(c.MediaStreamTrack, p.getConstraints, "getConstraints", !1, a.FEATURE_ms_teams_mstrack_constraints)]), new b.WebrpcClassInfo(c.MediaStream, "MediaStream", [new b.WebrpcMethodInfo(c.MediaStream, f.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.MediaStream, f.id, "id", !0), new b.WebrpcMethodInfo(c.MediaStream, f.getAudioTracks, "getAudioTracks", !1), new b.WebrpcMethodInfo(c.MediaStream, f.getVideoTracks, "getVideoTracks", !1), new b.WebrpcMethodInfo(c.MediaStream, f.getTracks, "getTracks", !1), new b.WebrpcMethodInfo(c.MediaStream, f.getTrackById, "getTrackById", !1), new b.WebrpcMethodInfo(c.MediaStream, f.addTrack, "addTrack", !1), new b.WebrpcMethodInfo(c.MediaStream, f.removeTrack, "removeTrack", !1), new b.WebrpcMethodInfo(c.MediaStream, f.clone, "clone", !0), new b.WebrpcMethodInfo(c.MediaStream, f.active, "active", !0)]), new b.WebrpcClassInfo(c.NavigatorUserMedia, "NavigatorUserMedia", [new b.WebrpcMethodInfo(c.NavigatorUserMedia, J.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.NavigatorUserMedia, J.getUserMedia, "getUserMedia", !1), new b.WebrpcMethodInfo(c.NavigatorUserMedia, J.setCodecCapabilities, "setCodecCapabilities", !1, a.FEATURE_ms_teams_codec_capability), new b.WebrpcMethodInfo(c.NavigatorUserMedia, J.getCapabilities, "getRtpCapabilities", !1, a.FEATURE_ms_teams_webrtc_1dot0)]), new b.WebrpcClassInfo(c.MediaStreamEvent, "MediaStreamEvent", [new b.WebrpcMethodInfo(c.MediaStreamEvent, D.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.MediaStreamEvent, D.stream, "stream", !0)]), new b.WebrpcClassInfo(c.VideoElement, "VideoElement", [new b.WebrpcMethodInfo(c.VideoElement, B.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.VideoElement, B.sinkId, "sinkId", !0), new b.WebrpcMethodInfo(c.VideoElement, B.connectTo, "connectTo", !1), new b.WebrpcMethodInfo(c.VideoElement, B.disconnect, "disconnect", !1), new b.WebrpcMethodInfo(c.VideoElement, B.setFrame, "setFrame", !1), new b.WebrpcMethodInfo(c.VideoElement, B.addClipRect, "addClipRect", !1), new b.WebrpcMethodInfo(c.VideoElement, B.removeClipRect, "removeClipRect", !1), new b.WebrpcMethodInfo(c.VideoElement, B.onerror, "onerror", !0), new b.WebrpcMethodInfo(c.VideoElement, B.onvideoframechanged, "onvideoframechanged", !0), new b.WebrpcMethodInfo(c.VideoElement, B.placement, "placement", !0, a.FEATURE_ms_teams_video_placement)]), new b.WebrpcClassInfo(c.AudioElement, "AudioElement", [new b.WebrpcMethodInfo(c.AudioElement, t.ctor, "ctor", !1), new b.WebrpcMethodInfo(c.AudioElement, t.sinkId, "sinkId", !0), new b.WebrpcMethodInfo(c.AudioElement, t.srcObject, "srcObject", !0), new b.WebrpcMethodInfo(c.AudioElement, t.src, "src", !0), new b.WebrpcMethodInfo(c.AudioElement, t.play, "play", !1), new b.WebrpcMethodInfo(c.AudioElement, t.pause, "pause", !1)]), new b.WebrpcClassInfo(c.RTCRtpReceiver, "RTCRtpReceiver", [new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.ctor, "ctor", !1, a.FEATURE_ms_teams_speaking_indicator), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.track, "track", !0, a.FEATURE_ms_teams_speaking_indicator), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.getContributingSources, "getContributingSources", !1, a.FEATURE_ms_teams_speaking_indicator), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.getSynchronizationSources, "getSynchronizationSources", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.transport, "transport", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.rtcpTransport, "rtcptransport", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.getCapabilities, "getCapabilities", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.getParameters, "getParameters", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.getStats, "getStats", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpReceiver, h.getCapabilities_v2, "getCapabilities_v2", !1, a.FEATURE_ms_teams_webrtc_1dot0)]), new b.WebrpcClassInfo(c.RTCRtpSender, "RTCRtpSender", [new b.WebrpcMethodInfo(c.RTCRtpSender, A.ctor, "ctor", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.track, "track", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.transport, "transport", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.rtcpTransport, "rtcpTransport", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.dtmf, "dtmf", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.getCapabilities, "getCapabilities", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.getParameters, "getParameters", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.setParameters, "setParameters", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.replaceTrack, "replaceTrack", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.getStats, "getStats", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.setStreams, "setStreams", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCRtpSender, A.getCapabilities_v2, "getCapabilities_v2", !1, a.FEATURE_ms_teams_webrtc_1dot0)]), new b.WebrpcClassInfo(c.RTCDtlsTransport, "RTCDtlsTransport", [new b.WebrpcMethodInfo(c.RTCDtlsTransport, y.ctor, "ctor", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDtlsTransport, y.transport, "transport", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDtlsTransport, y.state, "state", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDtlsTransport, y.getRemoteCertificates, "getRemoteCertificates", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDtlsTransport, y.onstatechange, "onstatechange", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDtlsTransport, y.onerror, "onerror", !0, a.FEATURE_ms_teams_pstn)]), new b.WebrpcClassInfo(c.RTCIceTransport, "RTCIceTransport", [new b.WebrpcMethodInfo(c.RTCIceTransport, E.ctor, "ctor", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.role, "role", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.component, "component", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.state, "state", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.gatheringState, "gatheringState", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.localcandidates, "localcandidates", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.remotecandidates, "remotecandidates", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.onstatechange, "onstatechange", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.ongatheringstatechange, "ongatheringstatechange", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceTransport, E.onselectedcandidatepairchange, "onselectedcandidatepairchange", !0, a.FEATURE_ms_teams_pstn)]), new b.WebrpcClassInfo(c.RTCDTMFSender, "RTCDTMFSender", [new b.WebrpcMethodInfo(c.RTCDTMFSender, u.ctor, "ctor", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDTMFSender, u.insertDTMF, "insertDTMF", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDTMFSender, u.ontonechange, "ontonechange", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDTMFSender, u.canInsertDTMF, "canInsertDTMF", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDTMFSender, u.toneBuffer, "toneBuffer", !0, a.FEATURE_ms_teams_pstn)]), new b.WebrpcClassInfo(c.RTCDTMFToneChangeEvent, "RTCDTMFToneChangeEvent", [new b.WebrpcMethodInfo(c.RTCDTMFToneChangeEvent, q.ctor, "ctor", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDTMFToneChangeEvent, q.tone, "tone", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCDTMFToneChangeEvent, q.tone_buffer, "tone_buffer", !0, a.FEATURE_ms_teams_pstn)]), new b.WebrpcClassInfo(c.RTCIceCandidatePair, "RTCIceCandidatePair", [new b.WebrpcMethodInfo(c.RTCIceCandidatePair, w.ctor, "ctor", !1, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceCandidatePair, w.local, "local", !0, a.FEATURE_ms_teams_pstn), new b.WebrpcMethodInfo(c.RTCIceCandidatePair, w.remote, "remote", !0, a.FEATURE_ms_teams_pstn)]), new b.WebrpcClassInfo(c.RTCRtpTransceiver, "RTCRtpTransceiver", [new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.ctor, "ctor", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.mid, "mid", !0, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.sender, "sender", !0, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.receiver, "receiver", !0, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.direction, "direction", !0, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.currentDirection, "currentDirection", !0, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.stop, "stop", !1, a.FEATURE_ms_teams_webrtc_1dot0), new b.WebrpcMethodInfo(c.RTCRtpTransceiver, z.setCodecPreferences, "setCodecPreferences", !1, a.FEATURE_ms_teams_webrtc_1dot0)]), new b.WebrpcClassInfo(c.RTCDataChannel, "RTCDataChannel", [new b.WebrpcMethodInfo(c.RTCDataChannel, C.ctor, "ctor", !1, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.label, "label", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.ordered, "ordered", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.maxPacketLifeTime, "maxPacketLifeTime", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.maxRetransmits, "maxRetransmits", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.protocol, "protocol", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.negotiated, "negotiated", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.id, "id", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.readyState, "readyState", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.bufferedAmount, "bufferedAmount", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.bufferedAmountLowThreshold, "bufferedAmountLowThreshold", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.onopen, "onopen", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.onbufferedamountlow, "onbufferedamountlow", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.onerror, "onerror", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.onclosing, "onclosing", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.onclose, "onclose", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.onmessage, "onmessage", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.close, "close", !1, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.send_text, "send_text", !1, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCDataChannel, C.send_binary, "send_binary", !1, a.FEATURE_ms_teams_data_channel)]), new b.WebrpcClassInfo(c.RTCSctpTransport, "RTCSctpTransport", [new b.WebrpcMethodInfo(c.RTCSctpTransport, F.ctor, "ctor", !1, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCSctpTransport, F.transport, "transport", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCSctpTransport, F.state, "state", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCSctpTransport, F.maxMessageSize, "maxMessageSize", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCSctpTransport, F.maxChannels, "maxChannels", !0, a.FEATURE_ms_teams_data_channel), new b.WebrpcMethodInfo(c.RTCSctpTransport, F.onstatechange, "onstatechange", !0, a.FEATURE_ms_teams_data_channel)])]);
        },
        545: function (b, a, c) {
          var d = this && this.__spreadArrays || function () {
            for (var a = 0, b = 0, c = arguments.length; b < c; b++) a += arguments[b].length;
            for (var a = Array(a), d = 0, b = 0; b < c; b++) for (var e = arguments[b], k = 0, m = e.length; k < m; k++, d++) a[d] = e[k];
            return a;
          };
          Object.defineProperty(a, "__esModule", {
            value: !0
          });
          var e = c(550),
            k;
          (function (a) {
            a[a.req = 0] = "req";
            a[a.reply = 1] = "reply";
            a[a.event_req = 2] = "event_req";
            a[a.event_reply = 3] = "event_reply";
          })(k = a.ws_msg_type_t || (a.ws_msg_type_t = {}));
          b = function () {
            function a() {}
            a.createMessageByid = function (a, b, c, k, n, m) {
              for (var r = [], B = 6; B < arguments.length; B++) r[B - 6] = arguments[B];
              (B = e.WebrpcClassLibInfoUtil.getMethodByid(k, n)) && B.isprop || (a = !1);
              return this.createMessage.apply(this, d([c, a, b, k, n, m], r));
            };
            a.createMessage = function (a, b, c, e, k, m) {
              for (var n = [], r = 6; r < arguments.length; r++) n[r - 6] = arguments[r];
              return {
                v: "webrtc",
                hdr: {
                  version: this._version,
                  msg_type: this.getMsgType(a),
                  modifier: b,
                  destroy: c,
                  proc: {
                    iid: e,
                    methodid: k
                  }
                },
                objref: {
                  oid: m
                },
                params: d(n)
              };
            };
            a.getMsgType = function (a) {
              var b = "";
              switch (a) {
                default:
                  b = "req";
                  break;
                case k.reply:
                  b = "reply";
                  break;
                case k.event_req:
                  b = "event-req";
                  break;
                case k.event_reply:
                  b = "event-reply";
              }
              return b;
            };
            a._version = 1;
            return a;
          }();
          a.WsJsonUtil = b;
        }
      },
      k = {};
    return d(307);
  }();
});